export const AmbulatoryCareLogo = (
  <g>
    <g>
      <g>
        <path
          d="M252.206,254.508L101.941,254.479L69.588,222.126C69.588,222.126 66.099,209.182 65.684,203.475C64.941,193.229 64.494,176.513 62.21,168.095C61.333,164.865 56.784,146.51 55.041,138.918C53.298,131.326 51.594,118.748 55.802,105.422C60.011,92.096 66.015,84.608 79.978,81.841C88.915,80.07 99.71,84.713 99.71,84.713L150.77,135.773C150.77,135.773 150.79,91.338 150.691,91.034C148.298,83.678 146.864,74.3 146.059,68.787C145.254,63.274 145.537,53.559 148.223,45.533C149.63,41.331 156.922,27.097 170.885,29.864C178.616,31.396 190.3,35.402 190.3,35.402L252.244,97.346L252.206,254.508Z"
          fillOpacity="0.2"
        />
        <g transform="matrix(1,0,0,1,-4.86615,2.64785)">
          <g transform="matrix(0.232686,0,0,0.213678,-303.695,-78.0231)">
            <path
              d="M1595.88,1141.14C1592.12,1126.03 1572.57,1040.12 1565.08,1004.6C1557.59,969.066 1550.26,910.2 1568.35,847.835C1586.43,785.471 1612.24,750.428 1672.24,737.481C1732.25,724.533 1763.59,791.148 1769.63,810.812C1781.18,848.373 1782.4,893.839 1778.94,919.639C1775.48,945.44 1769.31,989.324 1759.03,1023.75C1748.75,1058.18 1745.16,1120.71 1747.69,1157.43C1750.21,1194.14 1756.47,1266.18 1760.18,1285.93C1763.89,1305.67 1764.64,1380.39 1696.69,1390.8C1628.75,1401.2 1614.01,1354.67 1610.82,1306.72C1607.62,1258.77 1605.7,1180.54 1595.88,1141.14Z"
              fill="none"
              stroke="white"
              strokeWidth="35.81px"
            />
          </g>
          <g transform="matrix(-0.232686,0,0,0.213678,565.427,-130)">
            <path
              d="M1595.88,1141.14C1592.12,1126.03 1572.57,1040.12 1565.08,1004.6C1557.59,969.066 1550.26,910.2 1568.35,847.835C1586.43,785.471 1612.24,750.428 1672.24,737.481C1732.25,724.533 1763.59,791.148 1769.63,810.812C1781.18,848.373 1782.4,893.839 1778.94,919.639C1775.48,945.44 1769.31,989.324 1759.03,1023.75C1748.75,1058.18 1745.16,1120.71 1747.69,1157.43C1750.21,1194.14 1756.47,1266.18 1760.18,1285.93C1763.89,1305.67 1764.64,1380.39 1696.69,1390.8C1628.75,1401.2 1614.01,1354.67 1610.82,1306.72C1607.62,1258.77 1605.7,1180.54 1595.88,1141.14Z"
              fill="none"
              stroke="white"
              strokeWidth="35.81px"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
);

export const AnaestheticsLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,63.7139,36.8308)">
      <g>
        <path
          d="M0,22.633L-9.146,13.52L-31.566,-8.901L-39.327,-2.148L-48.275,-11.097L-52.476,-1.74L-48.078,-0.792L-53.145,9.416L-30.271,32.29L-12.662,32.29L-3.448,33.73L0,22.633Z"
          fillOpacity="0.2"
        />
      </g>
    </g>
    <g transform="matrix(1,0,0,1,10.5933,24.9108)">
      <path
        d="M0,21.347L4.296,11.623L-0.668,10.86L3.055,0L4.869,0.834L1.432,9.304L6.874,9.304L0,21.347Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,16.1309,26.3183)">
      <path
        d="M0,21.959L9.93,12.412L4.965,10.598L14.438,0L16.04,1.623L8.402,9.738L13.081,12.412L0,21.959Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,19.1396,42.0714)">
      <path
        d="M0,10.121L10.645,7.447L7.685,4.186L18.76,0L19.906,1.927L9.953,4.679L13.031,8.498L0,10.121Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </g>
);

export const AuthoringLogo = (
  <>
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
      <g>
        <g transform="matrix(0.24,0,0,0.24,0,0)">
          <path
            d="M174.989,54.908L168.659,48.571L173.424,44.091L207.457,55.548L214.835,46.239L254.989,86.393L254.127,102.218L252.898,132.908L252.898,254.53L129.458,254.53L128.662,253.734L61.827,253.734L27.528,219.436L74.135,218.256L48.35,192.471L65.696,184.064L66.65,185.018L58.818,161.402L63.274,156.496L97.62,165.388L96.758,164.526L107.009,122.888L174.989,54.908Z"
            fillOpacity="0.2"
          />
        </g>
      </g>
    </g>
    <g transform="matrix(0.397038,0,0,0.397038,26.6955,21.5299)">
      <path
        d="M369,55C373.714,61.692 380.22,67.22 386,73L414,101C417.511,104.511 424.641,114.793 430,114.793C433.17,114.793 435.977,111.007 438,108.999L456,91C461.717,85.283 474.418,76.729 474.847,68C475.181,61.222 468.298,56.298 464,52L432,20C427.858,15.86 422.709,9.028 416,10.613C409.985,12.033 405.163,18.837 401,23L369,55M357,67L107,317C102.674,321.326 98.233,325.564 94.02,330C92.498,331.602 90.207,333.578 90.207,336C90.207,338.422 92.498,340.398 94.02,342C97.585,345.753 101.34,349.34 105,353L149,397C158.27,390.47 165.989,381.011 174,373L402,145C406.059,140.941 415.227,134.726 416.654,129C417.366,126.147 414.733,123.845 412.98,122C409.102,117.918 404.943,114.107 401.09,110.001C399.388,108.187 397.461,105.028 394.91,104.346C391.13,103.334 387.279,108.725 385,111L265,231C255.673,240.327 246.474,249.807 237,258.985C232.917,262.939 227.338,267.385 222.438,261.772C217.599,256.23 224.236,250.785 228.001,247C238.971,235.971 250,225 261,214L373,102C375.424,99.575 380.793,95.812 380.793,92C380.793,88.83 377.007,86.023 374.999,84C369.247,78.205 363.684,71.709 357,67M80,351C73.696,378.252 60.304,403.748 54,431C64.756,430.061 75.789,424.737 86,421.333C101.87,416.043 118.71,411.778 134,405C131.21,399.017 125.623,394.623 121,390L97,366C91.801,360.801 86.729,354.138 80,351M278.044,374.858C270.156,378.265 272.143,389.774 280.004,391.606C285.913,392.983 292.956,392 299,392L493,392C498.144,392 505.464,393.224 509.566,389.347C514.189,384.979 512.006,376.134 505.985,374.434C501.706,373.225 496.41,374 492,374L295,374C289.869,374 282.845,372.785 278.044,374.858M244.019,434.742C236.907,437.578 237.29,447.934 244.094,450.852C248.039,452.543 252.816,452 257,452L491,452C496.841,452 505.222,453.443 509.682,448.721C514.422,443.704 511.629,435.445 504.999,434.228C499.602,433.238 493.475,434 488,434L264,434C258.034,434 249.634,432.504 244.019,434.742M5.044,485.742C-4.371,489.579 0.398,502.035 9,502.895C18.162,503.812 27.792,503 37,503L477,503L499,502.999C502.638,502.98 506.729,503.028 509.566,500.347C513.803,496.343 512.331,487.933 506.956,485.742C502.393,483.883 495.843,485 491,485L17,485C13.259,485 8.583,484.3 5.044,485.742Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </>
);

export const BloodTransfusionLogo = (
  <g>
    <g>
      <g>
        <path
          d="M79.877,190.562C71.397,181.884 68.852,170.361 68.852,161.495L68.852,82.154C68.852,65.28 82.552,51.58 99.426,51.58L117.23,51.58C115.119,49.391 113.821,46.413 113.821,43.134C113.821,36.412 119.278,30.955 126,30.955C129.597,30.955 132.832,32.517 135.062,35L135.062,35L151.642,51.58L152.574,51.58C161.644,51.58 169.796,55.538 175.396,61.819L176,62L255.861,141.861L255.861,255L144,255L80,191L79.877,190.562Z"
          fillOpacity="0.2"
        />
        <g>
          <path
            d="M170.876,110L171,110L171,90L81,90L81,110L81.124,110C81.042,110.821 81,111.655 81,112.5L81,157.5C81,179.679 93.821,191 115,191L135,191C157.179,191 171,179.679 171,157.5L171,112.5C171,111.655 170.958,110.821 170.876,110Z"
            fill="white"
          />
          <g transform="matrix(0.961914,0,0,0.989842,5.74571,3.38329)">
            <path
              d="M184.426,79.579C184.426,62.532 170.184,48.692 152.642,48.692L97.39,48.692C79.847,48.692 65.605,62.532 65.605,79.579L65.605,159.735C65.605,169.598 68.814,182.716 79.936,191.667C87.2,197.513 97.91,201.665 113.58,201.665L134.372,201.665C149.967,201.665 160.995,197.557 168.657,191.739C180.458,182.776 184.426,169.611 184.426,159.735C184.426,159.735 184.426,79.579 184.426,79.579ZM176.109,79.579L176.109,159.735C176.109,167.639 172.981,178.198 163.536,185.37C157.033,190.309 147.608,193.583 134.372,193.583C134.372,193.583 113.58,193.583 113.58,193.583C100.418,193.583 91.342,190.353 85.24,185.442C76.313,178.258 73.922,167.652 73.922,159.735C73.922,159.735 73.922,79.579 73.922,79.579C73.922,66.993 84.438,56.774 97.39,56.774C97.39,56.774 152.642,56.774 152.642,56.774C165.594,56.774 176.109,66.993 176.109,79.579Z"
              fill="white"
            />
          </g>
          <g transform="matrix(4,0,0,5,-366,-840)">
            <rect x="122" y="208" width="2" height="4" fill="white" />
          </g>
          <g transform="matrix(0.883371,0,0,0.883371,16.8376,8.35082)">
            <path
              d="M123.575,25.588C115.965,25.588 109.788,31.766 109.788,39.375C109.788,46.985 115.965,53.163 123.575,53.163C131.184,53.163 137.362,46.985 137.362,39.375C137.362,31.766 131.184,25.588 123.575,25.588ZM123.575,34.644C126.186,34.644 128.306,36.764 128.306,39.375C128.306,41.986 126.186,44.106 123.575,44.106C120.964,44.106 118.844,41.986 118.844,39.375C118.844,36.764 120.964,34.644 123.575,34.644Z"
              fill="white"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
);

export const COVID19Logo = (
  <>
    <g>
      <g>
        <g transform="matrix(4.16667,0,0,4.16667,251.107,55.3988)">
          <path
            d="M-25.416,4.131L-34.811,4.131L-40.758,8.43L-43.092,21.072L-42.388,21.555L-52.827,25.198L-31.055,46.97L0,46.97L0,15.143L-20.083,-4.939L-25.416,4.131Z"
            fillOpacity="0.2"
          />
        </g>
      </g>
    </g>
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
      <g transform="matrix(0,-1,-1,0,14.2658,10.7268)">
        <path
          d="M-2.907,-2.908C-4.513,-2.908 -5.815,-1.606 -5.815,-0.001C-5.815,1.606 -4.513,2.907 -2.907,2.907C-1.302,2.907 0,1.606 0,-0.001C0,-1.606 -1.302,-2.908 -2.907,-2.908"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,41.1314,17.4268)">
        <path
          d="M-3.35,-3.351C-5.201,-3.351 -6.701,-1.851 -6.701,-0.001C-6.701,1.85 -5.201,3.35 -3.35,3.35C-1.5,3.35 -0,1.85 -0,-0.001C-0,-1.851 -1.5,-3.351 -3.35,-3.351"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,38.413,7.5662)">
        <path
          d="M-2.402,-2.402C-3.729,-2.402 -4.804,-1.327 -4.804,-0.002C-4.804,1.326 -3.729,2.402 -2.402,2.402C-1.075,2.402 0,1.326 0,-0.002C0,-1.327 -1.075,-2.402 -2.402,-2.402"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,50.4887,34.3675)">
        <path
          d="M-2.341,-2.338C-3.632,-2.338 -4.679,-1.291 -4.679,0C-4.679,1.293 -3.632,2.341 -2.341,2.341C-1.048,2.341 0,1.293 0,0C0,-1.291 -1.048,-2.338 -2.341,-2.338"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,49.6661,27.1612)">
        <path
          d="M-1.517,-1.517C-2.356,-1.517 -3.034,-0.837 -3.034,0.001C-3.034,0.837 -2.356,1.517 -1.517,1.517C-0.679,1.517 -0,0.837 -0,0.001C-0,-0.837 -0.679,-1.517 -1.517,-1.517"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,37.7806,47.8958)">
        <path
          d="M-2.402,-2.403C-3.728,-2.403 -4.804,-1.327 -4.804,-0.001C-4.804,1.326 -3.728,2.402 -2.402,2.402C-1.076,2.402 -0.001,1.326 -0.001,-0.001C-0.001,-1.327 -1.076,-2.403 -2.402,-2.403"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,23.8756,46.2525)">
        <path
          d="M-1.518,-1.516C-2.356,-1.516 -3.034,-0.836 -3.034,0.001C-3.034,0.838 -2.356,1.518 -1.518,1.518C-0.68,1.518 0,0.838 0,0.001C0,-0.836 -0.68,-1.516 -1.518,-1.516"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,9.7797,35.1263)">
        <path
          d="M-2.341,-2.338C-3.633,-2.338 -4.679,-1.291 -4.679,0.001C-4.679,1.293 -3.633,2.341 -2.341,2.341C-1.048,2.341 0,1.293 0,0.001C0,-1.291 -1.048,-2.338 -2.341,-2.338"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,12.8751,21.7257)">
        <path
          d="M-1.517,-1.517C-2.354,-1.517 -3.035,-0.838 -3.035,-0C-3.035,0.836 -2.354,1.517 -1.517,1.517C-0.679,1.517 0,0.836 0,-0C0,-0.838 -0.679,-1.517 -1.517,-1.517"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,25.4547,9.9683)">
        <path
          d="M-1.58,-1.581C-2.453,-1.581 -3.161,-0.873 -3.161,-0C-3.161,0.871 -2.453,1.58 -1.58,1.58C-0.707,1.58 0,0.871 0,-0C0,-0.873 -0.707,-1.581 -1.58,-1.581"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(1,0,0,1,34.3691,35.6964)">
        <path
          d="M0,-11.632C0,-11.039 -0.482,-10.557 -1.076,-10.557C-1.67,-10.557 -2.15,-11.039 -2.15,-11.632C-2.15,-12.226 -1.67,-12.706 -1.076,-12.706C-0.482,-12.706 0,-12.226 0,-11.632M-4.047,6.131C-10.67,6.131 -16.058,0.742 -16.058,-5.88C-16.058,-12.502 -10.67,-17.89 -4.047,-17.89C-2.426,-17.89 -0.852,-17.573 0.629,-16.946L0.334,-16.248C-1.053,-16.834 -2.527,-17.132 -4.047,-17.132C-10.251,-17.132 -15.299,-12.084 -15.299,-5.88C-15.299,0.324 -10.251,5.372 -4.047,5.372C2.158,5.372 7.205,0.324 7.205,-5.88C7.205,-6.844 7.084,-7.801 6.842,-8.726L7.576,-8.917C7.834,-7.931 7.965,-6.908 7.965,-5.88C7.965,0.742 2.576,6.131 -4.047,6.131M2.654,-9.546C3.91,-9.546 4.93,-8.528 4.93,-7.27C4.93,-6.014 3.91,-4.994 2.654,-4.994C1.396,-4.994 0.377,-6.014 0.377,-7.27C0.377,-8.528 1.396,-9.546 2.654,-9.546M9.936,-2.332C10.215,-3.459 10.367,-4.637 10.367,-5.851C10.367,-5.861 10.365,-5.87 10.365,-5.88L12.77,-5.88L12.77,-7.65L10.25,-7.65C10.074,-9.072 9.695,-10.433 9.139,-11.697C8.432,-11.143 7.541,-10.81 6.572,-10.81C4.268,-10.81 2.4,-12.678 2.4,-14.983C2.4,-16.193 2.92,-17.28 3.744,-18.043C3.266,-18.354 2.764,-18.632 2.248,-18.886L4.045,-22.442L1.643,-23.706L0.387,-19.649C-1.049,-20.125 -2.578,-20.39 -4.174,-20.39C-5.14,-20.39 -6.082,-20.293 -6.995,-20.114L-7.334,-22.063L-8.978,-21.683L-8.597,-19.702C-10.364,-19.138 -11.985,-18.247 -13.388,-17.096L-16.626,-20.39L-18.712,-18.649L-15.081,-15.458C-16.012,-14.402 -16.791,-13.21 -17.387,-11.915L-18.712,-12.454L-19.471,-10.557L-18.12,-9.957C-18.503,-8.654 -18.712,-7.277 -18.712,-5.851C-18.712,-4.446 -18.509,-3.089 -18.137,-1.804L-22.252,-0.57L-21.493,1.39L-17.567,-0.186C-16.055,3.385 -13.154,6.222 -9.544,7.659L-10.494,9.798L-8.914,10.556L-8.012,8.173C-6.788,8.507 -5.502,8.688 -4.174,8.688C-2.861,8.688 -1.592,8.511 -0.383,8.186L1.01,12.074L3.033,11.062L1.664,7.465C5.109,5.953 7.855,3.142 9.285,-0.349L12.641,0.442L13.148,-1.329L9.936,-2.332Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
    </g>
  </>
);

export const CardiologyLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,60.2656,22.9607)">
      <path
        d="M0,24.009L0,14.63L-21.42,-6.789C-21.42,-6.789 -21.761,-7.059 -21.97,-7.099C-22.241,-7.152 -22.499,-7.18 -22.763,-7.217L-25.788,-10.242C-25.788,-10.242 -26.021,-10.456 -26.147,-10.557C-27.425,-11.564 -29.175,-11.641 -31.354,-10.784C-32.509,-10.327 -32.917,-10.447 -33.222,-10.814C-33.462,-11.101 -35.175,-12.956 -35.193,-12.98C-35.278,-13.097 -35.481,-13.295 -35.88,-13.295C-36.324,-13.296 -36.946,-13.038 -37.542,-12.606C-38.226,-12.109 -38.679,-11.532 -38.751,-11.062C-38.792,-10.781 -38.7,-10.587 -38.618,-10.473C-38.565,-10.402 -37.132,-8.878 -36.882,-8.517C-36.694,-8.241 -36.581,-8.075 -37.288,-7.324C-37.369,-7.229 -37.431,-7.116 -37.508,-7.018C-38.8,-8.059 -42.838,-7.823 -42.838,-6.292C-42.838,-6.28 -43.041,-0.191 -43.104,1.604C-45.212,4.823 -45.614,9.109 -44.828,12.74C-44.179,15.757 -42.589,18.53 -40.233,20.905C-40.187,20.951 -40.097,21.056 -40.097,21.056L-23.849,37.305L-13.293,37.305C-5.982,37.305 0,31.321 0,24.009"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(1,0,0,1,42.2314,12.3361)">
      <path
        d="M0,35.826C-1.443,36.887 -9.509,37.119 -15.477,34.012C-22.011,30.613 -24.197,26.121 -24.879,22.952C-25.783,18.765 -24.982,13.579 -21.268,11.023C-20.687,11.736 -19.807,13.321 -20.344,16.028C-20.671,17.528 -19.043,18.18 -18.57,17.003C-18.556,16.967 -17.074,13.357 -12.959,8.61C-9.966,5.154 -6.626,5.096 -5.229,5.252C-5.311,5.719 -5.348,6.232 -5.335,6.75C-5.324,7.253 -5.266,7.781 -5.158,8.263C-6.012,8.444 -7.435,8.918 -8.577,10.256C-9.928,11.83 -10.451,14.069 -10.134,16.924C-10.126,16.979 -9.953,18.323 -9.294,21.302C-8.615,24.407 -10.146,26.045 -11.773,27.777C-12.231,28.265 -12.678,28.744 -13.066,29.242C-13.4,29.666 -13.328,30.282 -12.899,30.617C-12.723,30.759 -12.51,30.826 -12.299,30.826C-12.008,30.826 -11.719,30.697 -11.527,30.451C-11.171,29.998 -10.759,29.562 -10.344,29.116C-8.623,27.281 -6.482,24.996 -7.38,20.883C-8.018,18.008 -8.186,16.694 -8.186,16.694C-8.44,14.428 -8.076,12.697 -7.108,11.552C-7.04,11.467 -6.963,11.401 -6.887,11.326C-2.34,14.55 0.147,20.853 0.469,30.135C0.483,30.586 0.498,30.9 0.518,31.047C0.54,31.215 0.572,31.411 0.61,31.631C0.82,32.876 1.174,34.96 0,35.826M-23.395,5.489C-22.948,5.595 -22.446,5.65 -21.939,5.65C-21.507,5.65 -21.079,5.609 -20.686,5.53C-21.247,6.658 -21.629,7.859 -21.771,9.046C-22.432,9.433 -23.015,9.883 -23.542,10.38L-23.395,5.489ZM-21.939,3.996C-21.013,3.996 -20.385,4.187 -20.137,4.332C-20.385,4.48 -21.013,4.67 -21.939,4.671C-22.861,4.67 -23.49,4.481 -23.739,4.333C-23.49,4.186 -22.861,3.995 -21.939,3.996M-18.162,4.283C-16.846,2.888 -17.155,1.982 -17.633,1.28C-17.854,0.955 -18.32,0.419 -18.675,0.023C-18.525,-0.062 -18.381,-0.124 -18.236,-0.231C-18.015,-0.393 -17.824,-0.563 -17.656,-0.736C-17.21,-0.248 -16.521,0.509 -16.317,0.75C-15.157,2.148 -13.489,1.487 -12.781,1.205C-11.104,0.546 -9.873,0.551 -9.02,1.224C-8.344,1.751 -7.996,2.568 -8.012,3.448C-9.933,3.82 -12.277,4.831 -14.439,7.326C-16.213,9.372 -17.498,11.188 -18.43,12.659C-18.848,10.765 -19.821,9.646 -20.295,9.217C-20.102,7.471 -19.343,5.662 -18.162,4.283M-18.814,-1.023C-19.104,-0.809 -19.365,-0.673 -19.568,-0.598C-19.437,-0.76 -19.234,-0.968 -18.932,-1.188C-18.645,-1.396 -18.389,-1.529 -18.186,-1.605C-18.313,-1.443 -18.517,-1.237 -18.814,-1.023M-4.01,4.566C-3.834,4.835 -3.59,5.578 -3.561,6.706C-3.531,7.928 -3.778,8.712 -3.882,8.908C-4.057,8.685 -4.33,7.924 -4.357,6.727C-4.384,5.597 -4.174,4.843 -4.01,4.566M2.542,31.305L2.459,30.788C2.444,30.672 2.438,30.424 2.426,30.068C2.102,20.599 -0.439,13.97 -5.072,10.256C-4.65,10.133 -4.345,10.104 -4.324,10.103C-4.044,10.086 -3.471,9.851 -3.268,9.637C-2.722,9.066 -2.555,7.736 -2.581,6.68C-2.621,5.16 -3.027,3.699 -3.936,3.525C-4.812,3.357 -5.615,3.273 -6.529,3.271C-6.564,2.01 -7.119,0.845 -8.113,0.068C-9.391,-0.939 -11.141,-1.017 -13.32,-0.16C-14.475,0.298 -14.883,0.178 -15.188,-0.19C-15.428,-0.477 -17.141,-2.332 -17.159,-2.355C-17.244,-2.473 -17.447,-2.671 -17.846,-2.671C-18.29,-2.672 -18.912,-2.414 -19.508,-1.981C-20.191,-1.485 -20.645,-0.907 -20.717,-0.438C-20.758,-0.156 -20.666,0.038 -20.584,0.151C-20.531,0.222 -19.098,1.747 -18.848,2.107C-18.66,2.384 -18.547,2.55 -19.254,3.3C-19.335,3.396 -19.396,3.509 -19.474,3.607C-20.766,2.566 -24.804,2.802 -24.804,4.333C-24.804,4.345 -25.007,10.433 -25.069,12.228C-27.178,15.448 -27.58,19.733 -26.794,23.365C-25.705,28.424 -22.007,32.822 -16.382,35.75C-12.676,37.679 -8.047,38.498 -4.398,38.498C-1.849,38.498 0.223,38.097 1.165,37.402C3.305,35.818 2.809,32.882 2.542,31.305"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </g>
);

export const DermatologyLogo = (
  <g>
    <path
      d="M58.707,193.023C58.707,193.023 35.138,151.209 35.138,126C35.138,75.852 75.852,35.138 126,35.138C151.891,35.138 193.838,59.644 193.838,59.644L252.089,117.895L252.089,252.235L148.292,252.235L148.221,252.164L117.848,252.164L58.707,193.023Z"
      fillOpacity="0.2"
    />
    <g transform="matrix(1.53296,0,0,1.53296,4.76114,64.15)">
      <g>
        <clipPath id="_clipDermatology">
          <circle cx="79.088" cy="40.347" r="59.272" />
        </clipPath>
        <g clipPath="url(#_clipDermatology)">
          <g transform="matrix(0.858572,0.000211232,0.000210833,1,15.7844,53.2959)">
            <path
              d="M11.436,16.406C11.436,16.406 16.069,16.399 23.592,16.388C25.269,16.385 26.629,15.214 26.627,13.774C26.625,12.334 25.261,11.167 23.584,11.169C16.061,11.181 11.428,11.188 11.428,11.188C9.75,11.19 8.39,12.361 8.392,13.801C8.395,15.242 9.758,16.409 11.436,16.406ZM39.396,16.364C43.22,16.358 47.302,16.352 51.552,16.345C53.23,16.343 54.59,15.171 54.587,13.731C54.585,12.291 53.222,11.124 51.544,11.127C47.294,11.133 43.212,11.139 39.388,11.145C37.71,11.148 36.35,12.319 36.352,13.759C36.355,15.199 37.718,16.366 39.396,16.364ZM67.356,16.321C71.38,16.315 75.453,16.309 79.512,16.303C81.19,16.3 82.55,15.129 82.547,13.689C82.545,12.249 81.182,11.082 79.504,11.084C75.445,11.09 71.372,11.097 67.348,11.103C65.67,11.105 64.31,12.276 64.313,13.717C64.315,15.157 65.678,16.324 67.356,16.321ZM95.316,16.279C99.503,16.272 103.581,16.266 107.472,16.26C109.15,16.258 110.51,15.087 110.508,13.646C110.505,12.206 109.142,11.039 107.464,11.042C103.573,11.048 99.495,11.054 95.308,11.06C93.63,11.063 92.27,12.234 92.273,13.674C92.275,15.114 93.638,16.281 95.316,16.279ZM123.276,16.236C128.112,16.229 132.255,16.223 135.433,16.218C137.11,16.215 138.47,15.044 138.468,13.604C138.465,12.164 137.102,10.997 135.425,10.999C132.247,11.004 128.104,11.01 123.268,11.018C121.591,11.02 120.231,12.192 120.233,13.632C120.235,15.072 121.599,16.239 123.276,16.236Z"
              fill="white"
            />
          </g>
          <g transform="matrix(1,-4.07637e-06,-3.80189e-06,1,1.95705,37.7406)">
            <path
              d="M11.436,16.406C11.436,16.406 15.369,16.4 21.873,16.39C23.313,16.388 24.48,15.217 24.478,13.777C24.476,12.337 23.305,11.17 21.865,11.172C15.361,11.182 11.428,11.188 11.428,11.188C9.987,11.19 8.82,12.361 8.822,13.801C8.824,15.241 9.995,16.408 11.436,16.406ZM35.441,16.37C38.708,16.365 42.209,16.359 45.879,16.354C47.319,16.352 48.486,15.181 48.484,13.741C48.482,12.3 47.311,11.133 45.871,11.135C42.201,11.141 38.7,11.146 35.433,11.151C33.993,11.153 32.826,12.324 32.828,13.764C32.83,15.205 34.001,16.372 35.441,16.37ZM59.447,16.333C62.871,16.328 66.364,16.323 69.884,16.317C71.324,16.315 72.492,15.144 72.49,13.704C72.487,12.264 71.316,11.097 69.876,11.099C66.356,11.104 62.863,11.109 59.439,11.115C57.999,11.117 56.831,12.288 56.834,13.728C56.836,15.168 58.007,16.335 59.447,16.333ZM83.453,16.297C86.971,16.292 90.464,16.286 93.89,16.281C95.33,16.279 96.498,15.108 96.495,13.668C96.493,12.228 95.322,11.06 93.882,11.062C90.456,11.068 86.963,11.073 83.445,11.078C82.005,11.08 80.837,12.251 80.839,13.691C80.842,15.132 82.013,16.299 83.453,16.297ZM107.459,16.26C111.124,16.255 114.624,16.25 117.896,16.245C119.336,16.242 120.503,15.071 120.501,13.631C120.499,12.191 119.328,11.024 117.888,11.026C114.616,11.031 111.116,11.036 107.451,11.042C106.01,11.044 104.843,12.215 104.845,13.655C104.847,15.095 106.018,16.263 107.459,16.26ZM131.464,16.224C136.913,16.216 140.645,16.21 141.902,16.208C143.342,16.206 144.509,15.035 144.507,13.595C144.505,12.155 143.334,10.987 141.894,10.989C140.637,10.991 136.905,10.997 131.456,11.005C130.016,11.008 128.849,12.178 128.851,13.619C128.853,15.059 130.024,16.226 131.464,16.224Z"
              fill="white"
            />
          </g>
          <g transform="matrix(1,0,0,1,1.95699,0)">
            <path
              d="M11.432,31.87C13.766,31.87 16.006,33.448 18.309,34.878C21.484,36.849 24.719,38.67 27.938,38.67C31.138,38.67 34.465,36.856 37.722,34.897C40.114,33.457 42.433,31.87 44.743,31.87C47.012,31.87 49.142,33.439 51.33,34.853C54.409,36.842 57.541,38.67 60.676,38.67C63.792,38.67 67.012,36.849 70.169,34.872C72.443,33.448 74.65,31.87 76.898,31.87C79.13,31.87 81.259,33.442 83.462,34.857C86.554,36.842 89.718,38.67 92.879,38.67C96.012,38.67 99.29,36.854 102.501,34.886C104.838,33.454 107.107,31.87 109.373,31.87C111.597,31.87 113.651,33.436 115.789,34.841C118.822,36.834 121.938,38.67 125.161,38.67C128.311,38.67 131.72,36.865 135.073,34.917C137.573,33.465 140.015,31.87 142.364,31.87C143.804,31.87 144.973,30.701 144.973,29.261C144.973,27.821 143.804,26.651 142.364,26.651C139.213,26.651 135.805,28.456 132.451,30.405C129.952,31.857 127.509,33.452 125.161,33.452C122.884,33.452 120.798,31.888 118.655,30.48C115.619,28.485 112.531,26.651 109.373,26.651C106.258,26.651 102.988,28.467 99.775,30.436C97.437,31.869 95.159,33.452 92.879,33.452C90.626,33.452 88.485,31.88 86.281,30.465C83.187,28.479 80.033,26.651 76.898,26.651C73.777,26.651 70.556,28.473 67.399,30.449C65.126,31.873 62.92,33.452 60.676,33.452C58.451,33.452 56.347,31.881 54.162,30.469C51.087,28.482 47.932,26.651 44.743,26.651C41.596,26.651 38.291,28.464 35.031,30.425C32.636,31.866 30.291,33.452 27.938,33.452C25.604,33.452 23.364,31.873 21.061,30.444C17.886,28.473 14.65,26.651 11.432,26.651C9.991,26.651 8.822,27.821 8.822,29.261C8.822,30.701 9.991,31.87 11.432,31.87Z"
              fill="white"
            />
          </g>
          <g transform="matrix(1,0,0,1,1.95699,0)">
            <path
              d="M11.435,16.406L142.368,16.207C143.808,16.205 144.975,15.034 144.973,13.594C144.971,12.154 143.8,10.987 142.36,10.989L11.428,11.188C9.987,11.19 8.82,12.361 8.822,13.801C8.824,15.241 9.995,16.408 11.435,16.406Z"
              fill="white"
            />
          </g>
        </g>
      </g>
      <g transform="matrix(0.986337,0,0,0.986337,-50.5074,-111.97)">
        <circle
          cx="131.39"
          cy="154.427"
          r="60.093"
          fill="none"
          stroke="white"
          strokeWidth="5.29px"
        />
      </g>
    </g>
  </g>
);

export const DiabetesLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,60.2656,13.2957)">
      <g>
        <path
          d="M-12.681,-4.827L-12.879,-5.281L-15.125,-5.799L-55.146,16.837L-36.339,35.643L-41.904,39.947L-34.881,46.97L0,46.97L0,6.55L-12.349,-5.799L-12.681,-4.827Z"
          fillOpacity="0.2"
        />
      </g>
    </g>
    <g transform="matrix(0.437826,0.89906,0.89906,-0.437826,7.89534,3.26149)">
      <path
        d="M23.055,-13.432C23.055,-13.432 20.259,26.217 20.008,29.774C19.757,33.33 22.226,33.802 23.055,33.86C23.886,33.919 26.653,34.353 26.937,30.323C27.223,26.293 27.724,19.18 27.724,19.18"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.8px"
      />
    </g>
    <g transform="matrix(1,0,0,1,33.5654,35.4829)">
      <path
        d="M0,8.061C-2.678,9.125 -3.862,6.243 -3.812,6.213C-3.759,6.184 -5.003,3.198 -2.201,1.991C0.603,0.784 1.646,0.319 3.437,-0.373C5.229,-1.064 6.799,0.706 7.134,1.405C7.468,2.102 7.864,4.688 5.687,5.67C3.509,6.653 0,8.061 0,8.061Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.8px"
      />
    </g>
    <g transform="matrix(1,0,0,1,36.9873,38.0237)">
      <path
        d="M0,-10.657C2.321,-11.628 4.125,-9.334 4.519,-8.532C4.913,-7.731 4.926,-4.857 2.925,-4.044C0.032,-2.87 -4.431,-1.101 -7.058,-0.064C-9.684,0.971 -10.877,-2.044 -10.847,-1.993C-10.817,-1.943 -12.269,-5.288 -9.335,-6.503C-6.399,-7.717 0,-10.657 0,-10.657Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.8px"
      />
    </g>
    <g transform="matrix(0.144388,0.989521,0.989521,-0.144388,33.2084,16.5456)">
      <path
        d="M6.695,-6.988C6.695,-6.988 4.487,0.699 3.907,3.281C3.327,5.864 6.341,6.808 6.695,6.885C7.048,6.962 9.776,7.495 10.47,4.946C11.166,2.398 12.091,-0.708 12.091,-0.708"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.8px"
      />
    </g>
    <g transform="matrix(0.866039,-0.499977,-0.499977,-0.866039,23.384,57.02)">
      <path
        d="M-1.556,5.808L21.675,5.808"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.8px"
      />
    </g>
    <g transform="matrix(-1,0,0,1,49.9588,32.3556)">
      <path
        d="M-0.05,-13.672C-0.05,-13.672 -4.073,-6.806 -4.073,-4.025C-4.073,-1.242 -1.738,0 -0.05,0C1.639,0 4.023,-1.193 4.023,-4.123C4.023,-7.054 -0.05,-13.672 -0.05,-13.672Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.51px"
      />
    </g>
    <g transform="matrix(1,0,0,1,27.9644,31.7523)">
      <path
        d="M0,-7.89C-3.809,-6.454 -4.081,-4.577 -3.498,-3.14C-2.915,-1.703 -1.77,0 2.574,-1.476"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.8px"
      />
    </g>
  </g>
);

export const ENTLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,60.2656,19.7477)">
      <path
        d="M0,27.222L0,5.143L-14.539,-9.396L-22.477,-13.021L-33.352,-13.296L-42.883,-8.334L-45.789,1.01L-45.727,4.26L-49.008,10.729L-49.008,11.885L-48.699,12.266L-49.508,13.612L-46.105,17.014L-46.105,18.041L-45.385,17.784L-44.885,24.22L-44.868,24.224L-45.336,24.806L-45.331,24.808L-45.758,24.666L-45.758,24.791L-30.031,40.518L-13.293,40.518C-5.982,40.518 0,34.534 0,27.222"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(1,0,0,1,11.2329,27.5222)">
      <path
        d="M0,4.843C-0.691,4.088 -1.006,3.46 0,2.327C1.007,1.196 3.02,-1.698 3.396,-2.201C3.774,-2.704 4.026,-3.837 3.396,-4.78C2.768,-5.723 2.265,-5.66 3.082,-7.925C3.9,-10.189 4.718,-13.145 5.535,-14.277C6.353,-15.409 8.932,-21.07 20.694,-21.07C32.455,-21.07 38.745,-13.586 38.43,-4.151C38.116,5.283 32.708,6.668 32.708,14.027C32.708,17.045 32.833,21.197 36.041,25.913"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="2px"
      />
    </g>
    <g transform="matrix(-0.841544,0.540188,0.540188,0.841544,38.1171,29.7682)">
      <path
        d="M1.58,-8.765C0.605,-8.887 -1.242,-8.972 -1.648,-6.693C-2.055,-4.415 0.313,-2.123 1.58,-1.664C2.846,-1.206 4.42,-0.499 5.361,-0.43C6.303,-0.361 7.776,-0.86 7.327,-2.14"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.79px"
      />
    </g>
    <g transform="matrix(1,0,0,1,12.3027,48.4676)">
      <path
        d="M0,-15.034C0,-15.034 0.628,-16.543 1.635,-17.612C2.641,-18.681 4.277,-20.38 7.862,-20.38C11.447,-20.38 14.026,-18.806 15.85,-15.034C17.674,-11.26 22.266,0.314 23.523,5.346L20.378,5.346C19.687,2.452 18.177,-2.768 17.108,-5.095C16.038,-7.422 14.214,-12.077 7.988,-12.077C2.797,-12.077 2.545,-11.77 1.731,-11.523C1.568,-11.473 1.614,-11.844 1.446,-12.072C3.774,-13.959 4.277,-15.347 8.554,-15.347C10.378,-15.347 10.692,-15.285 11.761,-14.907C11.147,-15.952 8.122,-18.246 0.382,-14.809C0.193,-14.725 0.214,-14.891 0,-15.034"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(-0.301984,0.953313,0.953313,0.301984,32.4783,34.403)">
      <path
        d="M-5.512,-3.512C-4.208,-4.088 -3.854,-6.071 2.406,-3.512"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.01px"
      />
    </g>
    <g transform="matrix(0,1,1,0,14.215,34.7199)">
      <path
        d="M-0.466,-0.466L0.466,-0.466"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.16px"
      />
    </g>
    <g transform="matrix(1,0,0,1,13.749,53.4353)">
      <path
        d="M0,-15.409C0.44,-14.906 1.321,-14.214 0.88,-12.831C0.44,-11.447 0.503,-8.49 4.969,-8.49C7.233,-8.49 9.246,-9.434 11.825,0"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="2px"
      />
    </g>
  </g>
);

export const ElderlyLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,45.4453,59.9123)">
      <path
        d="M0,-53.467L-6.067,-53.82L-8.202,-49.56L-11.82,-46.967L-17.187,-51.404L-23.909,-51.764L-25.288,-46.459L-31.187,-38.654L-35.438,-29.78L-36.975,-22.567L-37.75,-16.842L-38.125,-14.092L-34.813,-10.658L-36.169,-4.629L-31.187,0.353L1.527,0.353C8.838,0.353 14.82,-5.63 14.82,-12.943L14.82,-38.793L0,-53.467Z"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(1,0,0,1,21.3643,33.2627)">
      <path
        d="M0,-6.19C0.3,-6.208 0.646,-5.931 1.075,-5.409C1.848,-4.796 3.051,-3.743 4.205,-3.87C4.173,-3.189 4.176,-2.363 4.239,-0.794C4.401,1.369 5.399,5.311 5.423,8.039C5.425,10.591 4.929,15.5 4.287,18.476C3.96,19.173 4.094,19.617 3.417,19.612C3.405,19.604 3.387,19.593 3.376,19.585C2.397,19.159 1.094,18.649 0.404,18.379C0.183,16.754 -0.569,13.821 -0.91,11.689C-0.654,11.755 -0.285,11.706 0.103,11.614C-1.462,3.391 -2.263,1.607 -0.815,-5.218C-0.555,-5.863 -0.3,-6.174 0,-6.19ZM20.771,-27.173C18.656,-27.134 16.461,-26.268 16.483,-22.427C10.099,-19.632 5.757,-13.047 4.91,-7.539C4.904,-7.516 4.902,-7.508 4.896,-7.484C1.924,-8.612 1.118,-11.455 2.151,-14.039C2.479,-15.046 2.844,-15.79 3.347,-16.739C3.414,-16.892 3.786,-17.082 3.923,-17.082C5.574,-16.997 7.561,-18.787 7.561,-21.065C7.561,-23.342 5.708,-25.194 3.432,-25.194C1.153,-25.194 -0.671,-23.44 -0.671,-21.163C-0.623,-20.526 -0.417,-19.554 -0.664,-19.075C-3.131,-16.738 -0.866,-19.482 -5.93,-13.1C-11.034,-6.718 -13.43,4.055 -13.298,8.711C-13.233,9.583 -13.327,10.797 -13.257,11.661C-11.89,11.709 -11.345,11.742 -10.463,11.737C-10.627,12.384 -11.005,18.68 -11.066,20.912L-5.314,20.859C-3.172,19.96 -7.6,19.155 -8.266,18.496C-7.967,16.67 -6.836,14.332 -6.484,11.731L-4.478,11.752C-3.897,13.994 -2.933,16.577 -2.17,18.66C-1.649,19.42 -1.918,20.013 -1.445,20.776L3.596,20.776C3.816,20.776 10.448,20.983 11.024,20.764C11.604,20.541 11.418,20.289 11.252,19.948C11.053,19.491 8.613,18.742 8.648,18.489C9.715,14.491 9.731,11.166 9.882,9.161C10.847,11.485 11.673,13.706 12.689,17.463C12.838,18.173 13.095,19.781 13.361,20.764L19.277,20.783C19.51,20.784 19.928,20.57 19.908,20.208C19.869,19.523 16.904,18.852 16.614,18.701C16.462,18.63 16.404,18.215 16.347,17.906C16.126,15.185 15.418,12.46 14.97,9.772C14.381,7.239 13.92,4.708 13.511,2.041C13.269,-0.287 13.39,-3.267 13.848,-5.075C14.47,-7.299 15.063,-9.3 16.799,-11.347C17.317,-11.847 17.832,-11.469 18.284,-10.793C20.274,-7.769 23.455,-4.44 26.435,-2.321C26.406,-2.285 26.368,-2.264 26.345,-2.225C26.168,-1.951 26.054,-1.614 25.975,-1.205L27.049,-1C27.11,-1.315 27.193,-1.517 27.269,-1.637C27.279,-1.651 27.294,-1.644 27.304,-1.657C28.063,-1.076 28.501,-0.773 28.948,-0.658C28.949,-0.657 28.951,-0.652 28.953,-0.651L25.359,20.613L26.441,20.791L30.056,-0.608C30.313,-0.691 30.577,-0.844 30.857,-1.191C31.035,-1.519 31.417,-2.203 30.078,-2.91C28.075,-4.246 26.569,-5.971 24.796,-7.896C22.87,-10.211 21.766,-12.448 20.73,-14.977C20.428,-16.605 19.136,-17.964 19.544,-19.654C19.613,-19.72 19.692,-19.804 19.764,-19.873C20.012,-19.815 20.271,-19.783 20.538,-19.783C22.565,-19.468 24.625,-20.862 24.625,-23.44C24.625,-25.35 22.679,-27.173 20.771,-27.173Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.75px"
      />
    </g>
  </g>
);

export const ElectrolytesLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(0.24,0,0,0.24,0,0)">
      <path
        d="M251.107,105.585L251.107,195.707C251.107,200.268 250.548,204.705 249.496,208.954L129.894,88.536L155.091,75.498L174.787,89.881L181.568,38.044L251.107,105.585Z"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(0.24,0,0,0.24,-0.24,0)">
      <path
        d="M130.936,68.886L161.668,68.886L161.668,38.044L182.531,38.044L182.531,68.765L214.018,68.765L214.018,88.095L182.666,88.095L182.666,119.345L161.699,119.345L161.699,88.485L130.894,88.485L130.936,68.886Z"
        fill="white"
      />
    </g>
  </g>
);

export const EmergencyMedicineLogo = (
  <>
    <g transform="matrix(4.16667,0,0,4.16667,-699.446,-99.4459)">
      <g>
        <g transform="matrix(0.24,0,0,0.24,167.867,23.867)">
          <path
            d="M193,58L252.806,117.292L252.806,252.44L118.5,252.5L59,193L37.02,150.264L66.978,133.933L34.27,101.225L59.773,62.555L103.728,86.42L104.72,37.781L150,34L182.251,66.023L193,58Z"
            fillOpacity="0.2"
          />
        </g>
      </g>
    </g>
    <g transform="matrix(1,0,0,1,30,30)">
      <g transform="matrix(1,0,0,1,68.515,31.2369)">
        <g transform="matrix(144,0,0,144,3.91359,111.169)">
          <path
            d="M0.075,-0.038C0.083,-0.041 0.092,-0.045 0.104,-0.05C0.115,-0.055 0.127,-0.061 0.138,-0.068L0.138,-0.076L0.135,-0.153C0.134,-0.154 0.134,-0.154 0.134,-0.154L0.134,-0.157C0.124,-0.163 0.114,-0.169 0.106,-0.176C0.097,-0.182 0.089,-0.191 0.08,-0.201C0.077,-0.205 0.075,-0.209 0.073,-0.213C0.072,-0.218 0.071,-0.222 0.071,-0.226C0.071,-0.236 0.073,-0.245 0.076,-0.253C0.08,-0.262 0.084,-0.27 0.09,-0.278C0.095,-0.286 0.102,-0.293 0.108,-0.3C0.115,-0.307 0.122,-0.314 0.128,-0.32C0.127,-0.328 0.126,-0.334 0.125,-0.339C0.124,-0.344 0.124,-0.347 0.124,-0.349C0.123,-0.352 0.123,-0.354 0.122,-0.356L0.116,-0.366C0.115,-0.367 0.115,-0.369 0.115,-0.372C0.115,-0.375 0.114,-0.377 0.114,-0.38C0.113,-0.382 0.112,-0.385 0.111,-0.387C0.11,-0.389 0.109,-0.391 0.108,-0.394L0.124,-0.409L0.135,-0.399L0.135,-0.415L0.134,-0.45C0.126,-0.457 0.118,-0.465 0.11,-0.472C0.102,-0.48 0.095,-0.488 0.089,-0.496C0.084,-0.505 0.08,-0.514 0.078,-0.523C0.076,-0.533 0.077,-0.544 0.081,-0.556C0.084,-0.569 0.09,-0.579 0.098,-0.586C0.107,-0.594 0.116,-0.6 0.127,-0.604L0.123,-0.648L0.122,-0.667C0.121,-0.666 0.123,-0.666 0.126,-0.666C0.129,-0.666 0.132,-0.665 0.136,-0.665C0.14,-0.665 0.145,-0.665 0.15,-0.665L0.16,-0.655L0.17,-0.663C0.173,-0.661 0.176,-0.659 0.178,-0.658C0.181,-0.656 0.183,-0.655 0.184,-0.654C0.186,-0.653 0.187,-0.652 0.187,-0.651C0.187,-0.65 0.186,-0.646 0.184,-0.639C0.182,-0.631 0.18,-0.622 0.177,-0.612L0.183,-0.612C0.201,-0.611 0.216,-0.606 0.228,-0.597C0.24,-0.589 0.246,-0.575 0.246,-0.556L0.243,-0.548L0.225,-0.554C0.227,-0.549 0.229,-0.545 0.23,-0.542C0.232,-0.54 0.234,-0.537 0.234,-0.536C0.227,-0.528 0.217,-0.525 0.207,-0.525C0.197,-0.526 0.187,-0.529 0.178,-0.536L0.172,-0.542C0.171,-0.536 0.171,-0.53 0.171,-0.523C0.171,-0.517 0.171,-0.509 0.17,-0.502C0.176,-0.499 0.181,-0.495 0.187,-0.492C0.192,-0.489 0.196,-0.485 0.2,-0.481C0.206,-0.477 0.212,-0.472 0.218,-0.467C0.224,-0.462 0.229,-0.456 0.234,-0.45C0.237,-0.446 0.241,-0.441 0.245,-0.435C0.249,-0.429 0.251,-0.423 0.253,-0.417C0.258,-0.4 0.259,-0.385 0.255,-0.372C0.25,-0.358 0.243,-0.346 0.233,-0.335C0.224,-0.324 0.212,-0.313 0.199,-0.303C0.187,-0.294 0.175,-0.283 0.164,-0.273L0.163,-0.26L0.177,-0.265L0.188,-0.247C0.186,-0.245 0.183,-0.242 0.18,-0.239C0.178,-0.237 0.175,-0.234 0.173,-0.23C0.17,-0.227 0.168,-0.224 0.167,-0.22C0.166,-0.219 0.165,-0.217 0.165,-0.215C0.165,-0.213 0.164,-0.21 0.164,-0.207C0.166,-0.206 0.169,-0.205 0.171,-0.204C0.173,-0.203 0.175,-0.202 0.177,-0.201C0.186,-0.196 0.195,-0.19 0.204,-0.184C0.212,-0.178 0.22,-0.171 0.227,-0.163C0.229,-0.16 0.231,-0.157 0.233,-0.153C0.235,-0.15 0.237,-0.147 0.238,-0.143C0.243,-0.128 0.244,-0.116 0.241,-0.104C0.239,-0.093 0.234,-0.084 0.226,-0.075C0.219,-0.067 0.21,-0.059 0.199,-0.053C0.189,-0.047 0.178,-0.041 0.166,-0.036L0.166,-0.021C0.166,-0.019 0.166,-0.017 0.167,-0.015L0.145,0.016L0.135,0.022L0.138,-0.021L0.138,-0.026L0.121,-0.02C0.115,-0.017 0.108,-0.015 0.102,-0.013C0.095,-0.01 0.089,-0.008 0.082,-0.007L0.07,-0.018C0.07,-0.02 0.071,-0.023 0.071,-0.025C0.07,-0.027 0.07,-0.029 0.07,-0.031L0.075,-0.038ZM0.204,-0.394C0.204,-0.386 0.203,-0.38 0.201,-0.374C0.199,-0.368 0.196,-0.363 0.193,-0.357C0.189,-0.352 0.185,-0.347 0.181,-0.343C0.176,-0.338 0.171,-0.334 0.167,-0.33L0.165,-0.3C0.168,-0.302 0.17,-0.304 0.174,-0.306L0.203,-0.331C0.208,-0.336 0.212,-0.34 0.216,-0.345C0.22,-0.349 0.223,-0.354 0.227,-0.36C0.23,-0.365 0.233,-0.371 0.236,-0.379C0.237,-0.395 0.236,-0.407 0.231,-0.417C0.227,-0.428 0.219,-0.438 0.208,-0.449C0.205,-0.452 0.201,-0.455 0.197,-0.458C0.193,-0.461 0.19,-0.464 0.187,-0.467C0.18,-0.472 0.173,-0.476 0.167,-0.481C0.16,-0.486 0.153,-0.49 0.146,-0.496C0.14,-0.501 0.133,-0.508 0.127,-0.515C0.122,-0.522 0.119,-0.529 0.119,-0.537C0.12,-0.544 0.122,-0.551 0.127,-0.556C0.132,-0.562 0.137,-0.566 0.145,-0.569C0.152,-0.572 0.16,-0.572 0.167,-0.57C0.17,-0.57 0.173,-0.568 0.176,-0.566L0.19,-0.553C0.192,-0.55 0.195,-0.549 0.198,-0.548C0.204,-0.546 0.209,-0.545 0.213,-0.546L0.21,-0.561L0.212,-0.565C0.213,-0.565 0.215,-0.565 0.218,-0.566C0.221,-0.568 0.223,-0.568 0.224,-0.568C0.222,-0.577 0.217,-0.583 0.209,-0.586C0.202,-0.589 0.193,-0.591 0.183,-0.593C0.174,-0.594 0.164,-0.594 0.155,-0.593C0.146,-0.591 0.138,-0.589 0.13,-0.585C0.122,-0.581 0.115,-0.575 0.11,-0.569C0.104,-0.562 0.1,-0.554 0.098,-0.544C0.096,-0.538 0.096,-0.532 0.097,-0.527C0.098,-0.522 0.101,-0.517 0.103,-0.512C0.106,-0.507 0.109,-0.502 0.113,-0.498C0.117,-0.494 0.121,-0.49 0.125,-0.485C0.131,-0.479 0.139,-0.473 0.147,-0.466C0.156,-0.46 0.165,-0.453 0.173,-0.446C0.181,-0.438 0.188,-0.43 0.194,-0.422C0.2,-0.413 0.203,-0.404 0.204,-0.394ZM0.18,-0.075L0.165,-0.065L0.166,-0.053C0.173,-0.056 0.18,-0.06 0.187,-0.065C0.193,-0.069 0.199,-0.074 0.205,-0.08C0.21,-0.086 0.214,-0.092 0.218,-0.099C0.221,-0.106 0.223,-0.114 0.224,-0.123C0.221,-0.132 0.218,-0.141 0.213,-0.147C0.209,-0.154 0.203,-0.16 0.195,-0.167C0.186,-0.173 0.177,-0.179 0.165,-0.184C0.154,-0.19 0.144,-0.196 0.135,-0.202C0.127,-0.209 0.121,-0.216 0.118,-0.225C0.115,-0.234 0.117,-0.246 0.125,-0.26C0.127,-0.262 0.128,-0.265 0.13,-0.267C0.132,-0.269 0.134,-0.271 0.136,-0.272L0.132,-0.296C0.124,-0.288 0.116,-0.279 0.109,-0.269C0.102,-0.26 0.096,-0.25 0.091,-0.238L0.09,-0.226C0.091,-0.224 0.092,-0.222 0.093,-0.22C0.094,-0.218 0.095,-0.216 0.095,-0.213C0.098,-0.209 0.101,-0.206 0.103,-0.204C0.105,-0.201 0.107,-0.199 0.109,-0.198C0.11,-0.196 0.113,-0.194 0.115,-0.192C0.118,-0.19 0.122,-0.187 0.127,-0.184C0.132,-0.181 0.138,-0.177 0.145,-0.174C0.152,-0.17 0.159,-0.166 0.167,-0.161C0.174,-0.157 0.18,-0.152 0.187,-0.147C0.193,-0.142 0.198,-0.136 0.201,-0.13C0.204,-0.124 0.206,-0.118 0.205,-0.111C0.204,-0.104 0.2,-0.096 0.193,-0.088C0.189,-0.083 0.185,-0.079 0.18,-0.075ZM0.187,-0.394C0.186,-0.399 0.184,-0.405 0.181,-0.409C0.177,-0.414 0.174,-0.419 0.169,-0.423C0.169,-0.421 0.169,-0.42 0.169,-0.419C0.169,-0.418 0.169,-0.417 0.169,-0.416C0.169,-0.415 0.17,-0.414 0.17,-0.413L0.175,-0.404L0.168,-0.369L0.167,-0.354C0.173,-0.36 0.178,-0.366 0.182,-0.373C0.186,-0.379 0.188,-0.386 0.187,-0.394ZM0.185,-0.119C0.182,-0.124 0.179,-0.128 0.176,-0.131C0.172,-0.134 0.168,-0.137 0.164,-0.14C0.164,-0.13 0.164,-0.121 0.165,-0.113C0.165,-0.105 0.165,-0.1 0.165,-0.096L0.165,-0.087C0.17,-0.092 0.174,-0.096 0.177,-0.101C0.181,-0.105 0.183,-0.109 0.185,-0.114C0.185,-0.116 0.185,-0.118 0.185,-0.119ZM0.081,-0.021L0.138,-0.042L0.138,-0.05L0.081,-0.025L0.081,-0.021ZM0.188,-0.575C0.188,-0.577 0.188,-0.579 0.19,-0.581C0.192,-0.582 0.194,-0.583 0.196,-0.583C0.198,-0.583 0.2,-0.582 0.202,-0.581C0.203,-0.579 0.204,-0.577 0.204,-0.575C0.204,-0.573 0.203,-0.571 0.202,-0.57C0.2,-0.569 0.198,-0.568 0.196,-0.568C0.194,-0.568 0.192,-0.569 0.19,-0.57C0.188,-0.571 0.188,-0.573 0.188,-0.575ZM0.201,-0.481C0.201,-0.481 0.201,-0.481 0.2,-0.481C0.2,-0.481 0.2,-0.481 0.201,-0.481Z"
            fill="white"
            fillRule="nonzero"
          />
        </g>
      </g>
      <path
        d="M74,133L74,185L118,185L118,133L162,159L184,121L140,96L184,70L162,32L117,58L117,7L74,7L74,58L30,32L8,70L52,96L8,121L30,159L74,133Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="6px"
      />
    </g>
  </>
);

export const FluidsElectrolytesLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(0.24,0,0,0.24,0,0)">
      <path
        d="M251.107,105.585L251.107,195.707C251.107,200.268 250.548,204.705 249.496,208.954L129.894,88.536L155.091,75.498L174.787,89.881L181.568,38.044L251.107,105.585Z"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(0.24,0,0,0.24,-0.24,0)">
      <path
        d="M130.936,68.886L161.668,68.886L161.668,38.044L182.531,38.044L182.531,68.765L214.018,68.765L214.018,88.095L182.666,88.095L182.666,119.345L161.699,119.345L161.699,88.485L130.894,88.485L130.936,68.886Z"
        fill="white"
      />
    </g>
  </g>
);

export const GastroenterologyLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,60.2656,24.1067)">
      <path
        d="M0,22.863L0,5.306L-10.793,-5.481C-12.517,-7.125 -14.814,-7.823 -17.46,-7.474C-17.838,-7.426 -18.188,-7.343 -18.523,-7.241L-23.373,-12.091C-23.373,-12.091 -25.656,-13.084 -26.257,-13.177C-26.766,-13.255 -27.271,-13.295 -27.727,-13.296C-29.023,-13.295 -29.536,-13.019 -29.82,-12.136C-30.753,-8.66 -31.051,-2.057 -31.141,0.678C-31.195,2.494 -31.33,6.744 -33.402,7.87C-35.125,8.809 -36.904,8.138 -38.957,7.369C-40.992,6.604 -43.304,5.738 -45.729,6.624C-47.195,7.158 -48.825,8.452 -49.781,9.844C-51.473,12.308 -52.07,15.124 -52.649,17.85C-52.649,17.85 -52.825,18.391 -52.836,18.477C-52.85,18.632 -52.828,18.866 -52.633,19.106C-52.632,19.11 -44.774,26.969 -35.586,36.159L-13.293,36.159C-5.982,36.159 0,30.175 0,22.863"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(1,0,0,1,50.1836,30.3838)">
      <path
        d="M0,-0.5C-1.344,7.536 -9.777,16.763 -18.701,16.764C-18.769,16.763 -18.834,16.763 -18.896,16.763C-23.834,16.688 -27.854,14.788 -29.925,11.55C-30.025,11.39 -30.145,11.187 -30.277,10.96C-31.293,9.234 -33.188,6.016 -35.857,7.21C-37.525,7.954 -37.953,9.856 -38.033,11.381C-38.465,11.296 -38.856,11.244 -39.089,11.221C-39.448,11.185 -39.785,11.171 -40.113,11.167C-39.617,8.879 -39.067,6.723 -37.795,4.874C-37.111,3.878 -35.873,2.887 -34.859,2.514C-33.23,1.92 -31.512,2.567 -29.686,3.253C-27.428,4.099 -24.869,5.056 -22.221,3.622C-18.981,1.863 -18.824,-3.127 -18.751,-5.526C-18.69,-7.448 -18.439,-13.499 -17.693,-17.023C-17.322,-16.922 -16.947,-16.838 -16.588,-16.78C-16.281,-16.733 -15.991,-16.728 -15.699,-16.709C-16.297,-13.565 -15.896,-10.924 -14.559,-9.765C-14.076,-9.348 -13.035,-8.754 -11.511,-9.424C-10.904,-9.69 -10.349,-10.011 -9.797,-10.328C-8.867,-10.867 -8.063,-11.334 -7.081,-11.462C-5.029,-11.728 -3.371,-11.214 -2.135,-9.936C0.051,-7.67 0.512,-3.563 0,-0.5M-39.246,12.764C-40.078,12.679 -41.157,12.581 -41.127,12.371C-41.102,12.159 -39.992,12.288 -39.209,12.37C-38.373,12.455 -37.297,12.566 -37.322,12.76C-37.349,12.952 -38.461,12.841 -39.246,12.764M-16.354,-18.312C-15.563,-18.191 -14.547,-18.005 -14.586,-17.84C-14.623,-17.674 -15.72,-17.818 -16.41,-17.921C-17.201,-18.043 -18.195,-18.208 -18.179,-18.392C-18.157,-18.576 -17.04,-18.418 -16.354,-18.312M-0.474,-11.539C-2.219,-13.349 -4.611,-14.116 -7.378,-13.751C-8.818,-13.563 -9.904,-12.935 -10.955,-12.327C-11.432,-12.049 -11.915,-11.769 -12.444,-11.536C-12.855,-11.353 -12.985,-11.456 -13.049,-11.512C-13.6,-11.99 -14.002,-14.106 -13.232,-17.169C-13.115,-17.293 -13.04,-17.434 -13.014,-17.6C-12.831,-18.84 -15.387,-19.333 -16.175,-19.454C-16.684,-19.532 -17.189,-19.572 -17.645,-19.573C-18.941,-19.572 -19.454,-19.296 -19.738,-18.413C-20.671,-14.937 -20.969,-8.334 -21.059,-5.599C-21.113,-3.783 -21.248,0.467 -23.32,1.593C-25.043,2.532 -26.822,1.861 -28.875,1.092C-30.91,0.327 -33.222,-0.54 -35.646,0.347C-37.113,0.881 -38.743,2.175 -39.699,3.567C-41.391,6.031 -41.988,8.847 -42.567,11.573C-42.567,11.573 -42.743,12.114 -42.754,12.2C-42.768,12.354 -42.746,12.589 -42.551,12.829C-42.058,13.438 -40.584,13.787 -39.363,13.911C-38.963,13.952 -38.58,13.972 -38.224,13.971C-37.141,13.971 -36.41,13.806 -36.027,13.481C-35.864,13.346 -35.699,13.167 -35.695,12.915C-35.69,12.665 -35.73,12.389 -35.732,12.194C-35.757,9.968 -35.188,9.438 -34.916,9.317C-34.177,8.958 -32.775,11.267 -32.268,12.134C-32.116,12.388 -31.983,12.613 -31.865,12.794C-29.375,16.696 -24.66,18.983 -18.932,19.071C-18.854,19.071 -18.773,19.073 -18.701,19.073C-8.512,19.073 0.754,8.997 2.277,-0.119C2.84,-3.488 2.459,-8.5 -0.474,-11.539"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </g>
);

export const HaematologyLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,51.6973,57.6012)">
      <path
        d="M0,-44.048C0,-44.048 -7.064,-41.468 -7.837,-41.682C-8.609,-41.895 -8.627,-45.656 -17.193,-46.184C-25.76,-46.712 -31.988,-42.181 -33.941,-40.426C-35.394,-39.121 -35.527,-38.768 -35.501,-38.673L-39.263,-42.434L-44.075,-38.968L-43.48,-38.461L-46.472,-37.5L-36.784,-27.811L-34.689,-25.718L-42.711,-23.16L-47.026,-18.032L-47.491,-11.906L-32.92,2.664L-4.725,2.664C2.586,2.664 8.568,-3.319 8.568,-10.631L8.568,-35.479L0,-44.048Z"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(-0.249472,-0.968382,-0.968382,0.249472,22.2382,9.32841)">
      <ellipse
        cx="-15.213"
        cy="-3.92"
        rx="11.5"
        ry="15.71"
        fill="none"
        stroke="white"
        strokeWidth="2.04px"
      />
    </g>
    <g transform="matrix(-0.249459,-0.968385,-0.968385,0.249459,38.4523,33.6435)">
      <ellipse
        cx="-9.749"
        cy="-2.512"
        rx="7.37"
        ry="10.068"
        fill="none"
        stroke="white"
        strokeWidth="2px"
      />
    </g>
    <g transform="matrix(-0.420478,-0.907303,-0.907303,0.420478,6.17288,33.635)">
      <ellipse
        cx="-9.135"
        cy="-4.233"
        rx="7.37"
        ry="10.069"
        fill="none"
        stroke="white"
        strokeWidth="2px"
      />
    </g>
    <g transform="matrix(1,0,0,1,31.2578,27.9748)">
      <path
        d="M0,-10.592C4.13,-11.625 12.373,-8.717 2.687,-3.842C-7,1.033 -10.125,-2.842 -10.125,-2.842"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.31px"
      />
    </g>
    <g transform="matrix(-0.939061,0.343751,0.343751,0.939061,39.579,46.3768)">
      <path
        d="M-10.058,-2.957C-7.389,0.698 -1.909,-0.892 0.095,-2.957"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.31px"
      />
    </g>
    <g transform="matrix(-0.828411,0.560121,0.560121,0.828411,12.0789,44.2026)">
      <path
        d="M-9.446,-3.38C-6.776,0.274 -1.297,-1.317 0.707,-3.38"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.31px"
      />
    </g>
    <g transform="matrix(-0.428349,-0.903613,-0.903613,0.428349,5.33736,14.7516)">
      <path
        d="M-3.986,-6.302C-2.121,-6.302 -0.608,-4.326 -0.608,-1.888C-0.607,0.548 -2.121,2.523 -3.986,2.523C-5.852,2.522 -7.364,0.547 -7.364,-1.89C-7.365,-4.326 -5.852,-6.303 -3.986,-6.302"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(-0.428349,-0.903613,-0.903613,0.428349,47.8374,24.6266)">
      <path
        d="M-3.986,-6.302C-2.12,-6.301 -0.608,-4.326 -0.608,-1.888C-0.607,0.548 -2.121,2.523 -3.986,2.523C-5.853,2.523 -7.364,0.547 -7.364,-1.89C-7.365,-4.326 -5.852,-6.303 -3.986,-6.302"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(-0.428349,-0.903613,-0.903613,0.428349,44.5932,13.1266)">
      <path
        d="M-3.986,-6.302C-2.12,-6.301 -0.608,-4.326 -0.608,-1.888C-0.607,0.548 -2.121,2.523 -3.986,2.523C-5.853,2.523 -7.364,0.547 -7.364,-1.89C-7.365,-4.326 -5.852,-6.303 -3.986,-6.302"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </g>
);

export const IPCLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g>
      <g transform="matrix(0.24,0,0,0.24,0,0)">
        <g>
          <path
            d="M135.488,63.424L137.135,56.464L201.053,120.382L202.341,119.064L254.278,171.002L254.278,257.497L249.013,253.062L162.138,253.062L104.294,195.218L105.556,189.883C101.932,183.205 88.902,161.937 85.722,157.536C82.659,153.296 56.038,121.144 52.885,116.874C48,110.256 58.188,99.477 63.389,104.579C68.186,109.283 91.919,133.644 91.919,133.644C81.59,114.842 73.121,94.932 68.033,84.396C62.944,73.86 79.162,66.86 83.427,76.225C87.693,85.589 106.042,121.688 106.042,121.688C98.804,98.542 92.65,77.775 89.43,68.423C86.209,59.071 100.332,53.686 104.294,62.221C107.972,70.144 121.502,108.882 123.423,114.396L123.529,113.95C121.648,96.98 119.547,72.55 119.045,64.13C118.532,55.526 132.996,53.844 135.185,62.221C135.275,62.568 135.377,62.971 135.488,63.424Z"
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g transform="matrix(0.24,0,0,0.24,-0.0895325,-0.413345)">
        <path
          d="M106.415,192.523C103.683,187.178 89.44,163.888 86.095,159.258C83.032,155.019 56.411,122.866 53.258,118.596C48.373,111.978 58.561,101.199 63.762,106.301C68.559,111.005 92.292,135.366 92.292,135.366C81.963,116.565 73.494,96.655 68.406,86.119C63.317,75.582 79.535,68.583 83.8,77.947C88.066,87.311 106.415,123.41 106.415,123.41C99.177,100.264 93.023,79.497 89.803,70.146C86.582,60.794 100.705,55.408 104.667,63.943C108.629,72.478 124.024,116.772 124.024,116.772C122.113,99.773 119.931,74.456 119.418,65.852C118.905,57.249 133.369,55.566 135.558,63.943C137.746,72.319 146.076,112.602 146.179,118.596C146.283,124.59 150.605,132.532 155.409,135.366C157.52,136.367 160.803,138.405 163.037,135.366C165.27,132.327 173.941,122.025 178.498,120.414C183.054,118.802 195.136,116.58 200.077,125.116C201.49,128.073 201.141,133.038 195.5,135.366C189.86,137.694 183.482,143.4 180.514,148.697C178.162,151.874 176.343,159.435 173.315,163.102C170.286,166.77 164.303,176.064 158.056,182.342C151.809,188.62 150.354,190.852 139.998,192.523C129.642,194.194 123.909,197.402 117.702,196.94C111.495,196.478 106.95,193.818 106.415,192.523"
          fill="none"
          stroke="rgb(255,253,253)"
          strokeWidth="9px"
        />
      </g>
    </g>
  </g>
);

export const ITULogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,62.2773,21.4582)">
      <g>
        <path
          d="M0,29.74L-0.036,29.704L-0.036,20.675L-0.562,20.223C-0.52,14.194 -0.433,-0.365 -0.581,-0.514L-11.66,-11.593L-28.333,-11.872L-28.212,-3.405L-28.562,3.353L-19.203,12.712L-37.658,17.501L-41.17,13.988L-42.416,12.804L-50.313,4.907L-52.02,5.737L-52.02,20.862L-52.257,28.91L-40.225,40.942L-26.77,41.612L-28.966,39.807L0,40.55L0,29.74Z"
          fillOpacity="0.2"
        />
      </g>
    </g>
    <g transform="matrix(1,0,0,1,12.3687,30.0992)">
      <path
        d="M0,16.393C0,17.268 0.004,18.097 -0.003,18.925C-0.004,19.13 -0.016,19.342 -0.066,19.54C-0.243,20.237 -0.92,20.667 -1.653,20.568C-2.357,20.473 -2.873,19.875 -2.874,19.149L-2.874,4.758C-2.874,2.252 -2.876,-0.254 -2.873,-2.76C-2.872,-3.45 -2.376,-4.037 -1.71,-4.153C-1.027,-4.274 -0.355,-3.917 -0.119,-3.28C-0.046,-3.085 -0.023,-2.858 -0.023,-2.647C-0.018,2.72 -0.019,8.087 -0.018,13.455L-0.018,13.772L35.279,13.772L35.279,13.459C35.279,10.288 35.277,7.116 35.28,3.945C35.281,3.127 35.678,2.538 36.357,2.323C37.381,1.997 38.397,2.73 38.399,3.817C38.406,7.376 38.402,10.937 38.402,14.497C38.402,16.001 38.404,17.504 38.401,19.008C38.398,19.856 37.821,20.491 36.984,20.578C36.199,20.658 35.475,20.133 35.318,19.337C35.267,19.078 35.283,18.804 35.28,18.537C35.276,17.922 35.27,17.31 35.285,16.695C35.29,16.465 35.227,16.387 34.983,16.387C31.378,16.395 27.775,16.393 24.171,16.393L0,16.393Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,44.7539,33.7217)">
      <path
        d="M0,7.332L-0.263,7.332C-7.21,7.332 -14.158,7.331 -21.106,7.336C-21.334,7.336 -21.416,7.289 -21.413,7.039C-21.401,5.587 -21.416,4.136 -21.403,2.684C-21.394,1.598 -20.96,0.73 -19.957,0.243C-19.642,0.09 -19.26,0.012 -18.908,0.011C-13.43,-0.004 -7.95,-0.001 -2.472,0.002C-1.15,0.003 -0.026,1.004 0.019,2.327C0.073,3.966 0.033,5.609 0.034,7.25C0.034,7.266 0.021,7.281 0,7.332"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,40.5947,23.4391)">
      <path
        d="M0,-12.487C-0.425,-12.487 -0.836,-12.491 -1.247,-12.482C-1.294,-12.481 -1.378,-12.408 -1.379,-12.366C-1.389,-11.947 -1.385,-11.528 -1.385,-11.104L0,-11.104L0,-12.487ZM-2.079,-11.105L-2.079,-12.487C-2.509,-12.487 -2.921,-12.49 -3.333,-12.481C-3.376,-12.479 -3.453,-12.4 -3.455,-12.355C-3.464,-11.944 -3.46,-11.532 -3.46,-11.105L-2.079,-11.105ZM-4.15,-11.098L-4.15,-12.487C-4.574,-12.487 -4.987,-12.491 -5.397,-12.482C-5.444,-12.481 -5.527,-12.406 -5.527,-12.364C-5.537,-11.945 -5.533,-11.526 -5.533,-11.098L-4.15,-11.098ZM8.642,-9.69L-5.52,-9.69L-5.52,-0.066L8.642,-0.066L8.642,-9.69ZM-6.88,1.372L-6.88,-13.831C-6.798,-13.839 -6.725,-13.853 -6.65,-13.853C-1.183,-13.854 4.287,-13.853 9.755,-13.859C9.98,-13.859 10.023,-13.779 10.022,-13.574C10.018,-9.549 10.021,-5.522 10.021,-1.496C10.021,-0.649 10.02,0.198 10.02,1.044L10.02,1.372L-6.88,1.372Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(0.00862037,0.999963,0.999963,-0.00862037,17.9714,33.7316)">
      <path
        d="M3.634,-3.645C1.614,-3.634 -0.023,-1.98 -0.01,0.035C0.003,2.026 1.656,3.671 3.634,3.663C5.715,3.654 7.338,2.024 7.322,-0.043C7.307,-2.043 5.655,-3.655 3.634,-3.645"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,41.2939,15.0349)">
      <path
        d="M0,7.531C-0.354,6.057 -0.71,4.583 -1.08,3.042C-1.194,3.269 -1.284,3.441 -1.367,3.616C-1.548,3.998 -1.721,4.384 -1.91,4.76C-1.949,4.834 -2.057,4.918 -2.132,4.919C-3.134,4.929 -4.135,4.926 -5.161,4.926L-5.161,3.902C-4.401,3.902 -3.651,3.894 -2.901,3.907C-2.698,3.911 -2.597,3.848 -2.513,3.666C-1.994,2.556 -1.462,1.452 -0.936,0.346C-0.888,0.246 -0.835,0.149 -0.752,-0.014C-0.391,1.49 -0.045,2.934 0.301,4.376C0.322,4.385 0.346,4.392 0.368,4.4C0.773,3.529 1.177,2.657 1.605,1.735C1.852,2.37 2.079,2.953 2.305,3.536C2.413,3.817 2.527,4.097 2.625,4.383C2.683,4.557 2.778,4.618 2.965,4.616C4.174,4.608 5.383,4.612 6.593,4.612L6.905,4.612C6.905,4.933 6.915,5.225 6.893,5.515C6.89,5.56 6.744,5.629 6.663,5.63C5.852,5.639 5.038,5.636 4.227,5.636C3.569,5.636 2.913,5.628 2.257,5.641C2.064,5.645 1.98,5.574 1.924,5.404C1.813,5.079 1.685,4.762 1.534,4.364C1.021,5.468 0.541,6.507 0.06,7.545C0.039,7.54 0.02,7.535 0,7.531"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </g>
);

export const MedicalLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,30.1177,39.9537)">
      <path
        d="M0,-5.568L0.168,-5.663L0.17,-5.618L0,-5.568ZM30.148,-16.63L22.154,-24.624L8.04,-20.076L7.361,-20.717L2.199,-25.88L0.527,-18.656L-4.491,-23.674L-9.844,-19.764L-15.444,-23.277L-21.931,-23.277L-16.917,-18.264L-17.411,-18.317L-3.594,-4.5L-4.202,-4.319L-0.821,-0.938L-3.668,0.143L-0.127,3.683L-2.838,5.194L12.279,20.312L16.855,20.312C24.166,20.312 30.148,14.328 30.148,7.016L30.148,-16.63Z"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(1,0,0,1,26.5781,26.54)">
      <path
        d="M0,5.169C-0.657,5.169 -1.23,4.746 -1.426,4.116C-1.672,3.331 -1.232,2.49 -0.445,2.245L6.528,0.067C6.674,0.023 6.824,0 6.975,0C7.634,0 8.206,0.422 8.402,1.05C8.521,1.433 8.484,1.836 8.299,2.191C8.115,2.544 7.801,2.804 7.42,2.924L0.446,5.1C0.301,5.146 0.153,5.169 0,5.169"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,27.0796,31.7733)">
      <path
        d="M0,4.545C-0.588,4.545 -1.104,4.167 -1.279,3.604C-1.385,3.262 -1.354,2.899 -1.186,2.582C-1.02,2.266 -0.741,2.031 -0.398,1.926L5.574,0.062C5.704,0.021 5.838,0 5.974,0C6.562,0 7.076,0.378 7.251,0.941C7.472,1.646 7.077,2.399 6.373,2.619L0.399,4.482C0.269,4.524 0.134,4.545 0,4.545"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,27.5801,37.0067)">
      <path
        d="M0,3.92C-0.521,3.92 -0.975,3.586 -1.13,3.09C-1.325,2.466 -0.975,1.802 -0.354,1.607L4.619,0.055C4.734,0.02 4.852,0 4.973,0C5.493,0 5.945,0.334 6.102,0.831C6.196,1.134 6.167,1.454 6.021,1.735C5.874,2.014 5.626,2.222 5.324,2.315L0.352,3.867C0.237,3.903 0.12,3.92 0,3.92"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,28.0801,42.2411)">
      <path
        d="M0,3.296C-0.452,3.296 -0.846,3.006 -0.981,2.574C-1.149,2.033 -0.846,1.454 -0.307,1.286L3.665,0.047C3.765,0.016 3.868,0 3.973,0C4.424,0 4.819,0.291 4.952,0.723C5.034,0.984 5.01,1.262 4.883,1.505C4.754,1.749 4.539,1.928 4.278,2.009L0.306,3.25C0.207,3.279 0.103,3.296 0,3.296"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,32.8311,24.7623)">
      <path
        d="M0,-9.108C0,-10.601 -1.208,-11.808 -2.697,-11.808C-4.187,-11.808 -5.396,-10.601 -5.396,-9.108C-5.396,-8.151 -4.896,-7.312 -4.143,-6.835L-4.211,-6.835L-3.831,2.7L-1.586,1.997L-1.186,-6.835L-1.252,-6.835C-0.5,-7.312 0,-8.151 0,-9.108"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(0.954406,-0.298512,-0.298512,-0.954406,29.7113,37.6703)">
      <path
        d="M-0.248,0.25L1.196,0.25L1.688,1.605L0.118,1.604L-0.248,0.25Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(0.954282,-0.298907,-0.298907,-0.954282,29.9313,42.6243)">
      <path
        d="M-0.287,0.19L0.703,0.19L1.309,1.856L0.165,1.858L-0.287,0.19Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,29.792,45.2895)">
      <path
        d="M0,2.022L0.523,2.022L0.615,0L-0.073,0.213L0,2.022Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(0.954517,-0.298155,-0.298155,-0.954517,29.4918,32.7165)">
      <path
        d="M-0.208,0.309L1.69,0.309L2.068,1.353L0.073,1.354L-0.208,0.309Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,27.6528,18.885)">
      <path
        d="M0,1.321C0,1.321 -1.936,0.677 -1.923,-2.258C-1.91,-5.193 -19.659,-3.555 -19.659,-3.555C-19.659,-3.555 -20.206,-1.59 -17.748,-1.345C-17.748,-1.345 -17.543,0.813 -15.836,1.018C-15.836,1.018 -15.905,3.749 -11.741,3.476C-11.741,3.476 -13.424,6.514 0.297,5.831L0,1.321Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,32.6123,18.885)">
      <path
        d="M0,1.321C0,1.321 1.937,0.677 1.924,-2.258C1.912,-5.193 19.659,-3.555 19.659,-3.555C19.659,-3.555 20.205,-1.59 17.749,-1.345C17.749,-1.345 17.544,0.813 15.837,1.018C15.837,1.018 15.906,3.749 11.741,3.476C11.741,3.476 13.426,6.514 -0.296,5.831L0,1.321Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </g>
);

export const NeonatesLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,60.2656,23.7197)">
      <path
        d="M0,23.25L0,9.874L-23.133,-13.259L-28.497,-13.296L-28.617,-13.246L-28.765,-13.259L-29.159,-13.02L-32.185,-11.756L-31.893,-11.361L-33.379,-10.459L-34.508,-4.837L-32.285,-0.689L-33.883,-1.087L-30.898,1.897L-30.171,3.255L-34.072,2.83L-36.446,1.273L-36.988,2.512L-37.258,2.483L-37.071,2.703L-38.093,5.038L-31.629,11.502L-31.405,11.785L-31.008,13.038L-36.183,11.926L-41.794,14.758L-44.075,20.38L-43.383,27.238L-34.075,36.546L-13.293,36.546C-5.982,36.546 0,30.562 0,23.25"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(1,0,0,1,32.416,36.7907)">
      <path
        d="M0,-12.841C-3.739,-12.841 -6.78,-15.883 -6.78,-19.622C-6.78,-23.359 -3.739,-26.4 0,-26.4C3.736,-26.4 6.777,-23.359 6.777,-19.622C6.777,-15.883 3.736,-12.841 0,-12.841M6.459,-16.046C7.048,-17.107 7.386,-18.324 7.386,-19.622C7.386,-23.694 4.072,-27.008 0,-27.008C-4.074,-27.008 -7.388,-23.694 -7.388,-19.622C-7.388,-15.547 -4.074,-12.233 0,-12.233C2.553,-12.233 4.807,-13.536 6.134,-15.512C7.5,-14.139 13.82,-7.035 10.634,3.987C8.99,9.67 6.196,13.051 2.767,13.505C-0.373,13.924 -3.144,11.855 -4.496,9.624C-5.842,7.405 -7.337,6.322 -8.8,6.497C-10.563,6.707 -12.049,8.673 -13.217,12.339C-13.417,12.966 -13.711,13.364 -14.024,13.428C-14.335,13.492 -14.631,13.219 -14.78,13.049C-15.665,12.038 -16.437,8.992 -14.94,4.741C-13.859,1.667 -11.142,-0.754 -8.333,-1.145C-6.496,-1.402 -3.757,-0.928 -1.137,2.777C-1.04,2.914 -0.85,2.947 -0.713,2.849C-0.576,2.753 -0.543,2.563 -0.641,2.426C-3.437,-1.529 -6.413,-2.028 -8.417,-1.747C-11.442,-1.326 -14.36,1.259 -15.514,4.538C-16.997,8.749 -16.41,12.11 -15.237,13.45C-14.831,13.914 -14.357,14.119 -13.9,14.024C-13.516,13.945 -12.986,13.619 -12.637,12.524C-11.563,9.153 -10.211,7.279 -8.729,7.101C-7.528,6.961 -6.212,7.968 -5.017,9.94C-3.689,12.129 -1.082,14.167 1.954,14.167C2.248,14.167 2.546,14.149 2.847,14.108C4.979,13.826 8.904,12.157 11.218,4.156C14.578,-7.466 7.66,-14.871 6.459,-16.046"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,32.416,36.7907)">
      <path
        d="M0,-12.841C-3.739,-12.841 -6.78,-15.883 -6.78,-19.622C-6.78,-23.359 -3.739,-26.4 0,-26.4C3.736,-26.4 6.777,-23.359 6.777,-19.622C6.777,-15.883 3.736,-12.841 0,-12.841ZM6.459,-16.046C7.048,-17.107 7.386,-18.324 7.386,-19.622C7.386,-23.694 4.072,-27.008 0,-27.008C-4.074,-27.008 -7.388,-23.694 -7.388,-19.622C-7.388,-15.547 -4.074,-12.233 0,-12.233C2.553,-12.233 4.807,-13.536 6.134,-15.512C7.5,-14.139 13.82,-7.035 10.634,3.987C8.99,9.67 6.196,13.051 2.767,13.505C-0.373,13.924 -3.144,11.855 -4.496,9.624C-5.842,7.405 -7.337,6.322 -8.8,6.497C-10.563,6.707 -12.049,8.673 -13.217,12.339C-13.417,12.966 -13.711,13.364 -14.024,13.428C-14.335,13.492 -14.631,13.219 -14.78,13.049C-15.665,12.038 -16.437,8.992 -14.94,4.741C-13.859,1.667 -11.142,-0.754 -8.333,-1.145C-6.496,-1.402 -3.757,-0.928 -1.137,2.777C-1.04,2.914 -0.85,2.947 -0.713,2.849C-0.576,2.753 -0.543,2.563 -0.641,2.426C-3.437,-1.529 -6.413,-2.028 -8.417,-1.747C-11.442,-1.326 -14.36,1.259 -15.514,4.538C-16.997,8.749 -16.41,12.11 -15.237,13.45C-14.831,13.914 -14.357,14.119 -13.9,14.024C-13.516,13.945 -12.986,13.619 -12.637,12.524C-11.563,9.153 -10.211,7.279 -8.729,7.101C-7.528,6.961 -6.212,7.968 -5.017,9.94C-3.689,12.129 -1.082,14.167 1.954,14.167C2.248,14.167 2.546,14.149 2.847,14.108C4.979,13.826 8.904,12.157 11.218,4.156C14.578,-7.466 7.66,-14.871 6.459,-16.046Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.5px"
      />
    </g>
    <g transform="matrix(1,0,0,1,30.0435,26.2722)">
      <path
        d="M0,7.008C1.461,7.773 2.742,8.044 3.823,8.044C6.428,8.044 7.875,6.471 7.896,6.446C8.007,6.321 7.997,6.129 7.872,6.017C7.747,5.905 7.553,5.915 7.441,6.042C7.416,6.07 4.847,8.859 0.282,6.469C-3.925,4.266 -6.81,2.494 -7.214,1.006C-7.314,0.634 -7.256,0.283 -7.036,-0.07C-6.833,-0.395 -6.527,-0.596 -6.102,-0.683C-3.567,-1.206 1.729,2.461 1.782,2.498C1.921,2.595 2.11,2.56 2.206,2.423C2.301,2.284 2.267,2.095 2.129,1.999C1.904,1.841 -3.439,-1.851 -6.224,-1.28C-6.813,-1.158 -7.26,-0.859 -7.553,-0.391C-7.863,0.106 -7.946,0.629 -7.801,1.165C-7.335,2.88 -4.588,4.606 0,7.008"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,30.0435,26.2722)">
      <path
        d="M0,7.008C1.461,7.773 2.742,8.044 3.823,8.044C6.428,8.044 7.875,6.471 7.896,6.446C8.007,6.321 7.997,6.129 7.872,6.017C7.747,5.905 7.553,5.915 7.441,6.042C7.416,6.07 4.847,8.859 0.282,6.469C-3.925,4.266 -6.81,2.494 -7.214,1.006C-7.314,0.634 -7.256,0.283 -7.036,-0.07C-6.833,-0.395 -6.527,-0.596 -6.102,-0.683C-3.567,-1.206 1.729,2.461 1.782,2.498C1.921,2.595 2.11,2.56 2.206,2.423C2.301,2.284 2.267,2.095 2.129,1.999C1.904,1.841 -3.439,-1.851 -6.224,-1.28C-6.813,-1.158 -7.26,-0.859 -7.553,-0.391C-7.863,0.106 -7.946,0.629 -7.801,1.165C-7.335,2.88 -4.588,4.606 0,7.008Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.5px"
      />
    </g>
  </g>
);

export const NeurologyLogo = (
  <>
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
      <g transform="matrix(1,0,0,1,43.6035,55.3684)">
        <path
          d="M0,-39.135L-5.125,-42.881L-20.063,-44.032L-30.837,-38.177L-34.908,-29.91L-36.524,-25.236L-32.5,-19.46L-33.471,-14.923L-23.596,-5.486L-23.471,-3.611L-14.971,4.897L3.369,4.897C10.68,4.897 16.662,-1.086 16.662,-8.399L16.662,-26.861L5.407,-37.987L0,-39.135Z"
          fillOpacity="0.2"
        />
      </g>
    </g>
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
      <g transform="matrix(1,0,0,1,21.7744,36.7865)">
        <path
          d="M0,-0.267C0.926,-0.134 2.028,-0.105 3.532,0C2.029,-0.105 0.925,-0.135 0,-0.267Z"
          fill="none"
          fillRule="nonzero"
          stroke="white"
          strokeWidth="2px"
        />
      </g>
      <g transform="matrix(1,0,0,1,26.2349,36.7964)">
        <path
          d="M0,0.06C-0.265,0.038 -0.517,0.018 -0.76,0C-0.517,0.018 -0.265,0.038 0,0.06Z"
          fill="none"
          fillRule="nonzero"
          stroke="white"
          strokeWidth="2px"
        />
      </g>
      <g transform="matrix(1,0,0,1,26.2349,50.8824)">
        <path
          d="M0,-14.026C0.243,-13.794 0.473,-13.586 0.698,-13.387C0.345,-13.072 -0.041,-12.728 -0.444,-12.37C0.673,-8.142 -1.324,-6.874 -4.764,-6.288C-4.931,-3.863 -5.102,0 -5.102,0L-2.102,0C-1.585,-0.71 0.842,-7.823 0.906,-9.423C1.822,-9.988 2.639,-10.457 3.33,-11.683C2.263,-12.082 1.267,-12.815 0,-14.026Z"
          fill="none"
          fillRule="nonzero"
          stroke="white"
          strokeWidth="2px"
        />
      </g>
      <g transform="matrix(1,0,0,1,26.9331,43.4151)">
        <path
          d="M0,-5.92C-0.225,-6.118 -0.456,-6.326 -0.698,-6.559C-5.056,-6.928 -6.364,-6.525 -8.686,-8.603C-11.449,-8.202 -13.272,-7.733 -14.889,-8.201C-16.386,-7.429 -16.855,-6.233 -15.934,-3.657C-13.697,-0.004 -10.886,2.683 -5.533,1.192C-2.049,0.612 -0.017,-0.646 -1.142,-4.902C-0.739,-5.261 -0.353,-5.605 0,-5.92Z"
          fill="none"
          fillRule="nonzero"
          stroke="white"
          strokeWidth="2px"
        />
      </g>
      <g transform="matrix(1,0,0,1,39.9131,16.8443)">
        <path
          d="M0,17.017C0.104,17.537 0.354,23.745 -4.296,22.333C-9.116,23.118 -10.589,22.963 -13.678,20.012C-18.036,19.643 -19.344,20.045 -21.666,17.968C-26.053,18.604 -28.073,19.417 -30.653,16.367C-33.708,12.775 -34.011,11.769 -30.56,9.121C-31.998,6.436 -30.136,4.927 -28.284,4.384C-29.533,3.115 -27.369,-1.162 -22.664,-2.072C-20.124,-4.784 -14.539,-6.728 -7.941,-4.609C-0.853,-5.319 3.654,-3.122 3.743,-0.166C7.579,-0.505 9.838,1.73 9.823,4.313C13.238,6.404 14.971,9.58 11.867,12.952C12.354,17.027 10.551,18.769 2.764,17.132C1.989,17.579 0.664,17.389 0,17.017Z"
          fill="none"
          fillRule="nonzero"
          stroke="white"
          strokeWidth="2px"
        />
      </g>
    </g>
  </>
);

export const NursingLogo = (
  <g>
    <g>
      <g>
        <path
          d="M251.917,142.631L252.46,143.174L252.46,252.001L116.459,252.001L47.368,182.91C47.368,182.91 52.908,180.621 47.368,182.91L25.038,119.39C21.517,107.427 26.931,94.505 37.875,89.206C62.926,77.075 93.656,69.948 126.73,69.948C159.802,69.948 190.534,77.075 215.586,89.206C220.315,91.496 224.286,95.861 224.401,95.652L251.917,123.794L251.917,142.631Z"
          fillOpacity="0.2"
        />
        <g transform="matrix(2.85995,0,0,2.85995,-946.481,-65.2648)">
          <path
            d="M375,48.309C363.746,48.309 353.29,50.652 344.766,54.64C341.042,56.382 339.2,60.63 340.398,64.563L347.996,85.445C355.85,82.309 365.133,80.508 375,80.508C384.867,80.508 394.149,82.309 402.004,85.445L409.602,64.563C410.801,60.63 408.958,56.382 405.234,54.64C396.71,50.652 386.253,48.309 375,48.309Z"
            fill="none"
            fillRule="nonzero"
            stroke="white"
            strokeWidth="2.8px"
          />
        </g>
        <g transform="matrix(2.85995,0,0,2.85995,-946.481,-65.2648)">
          <path
            d="M381.815,61.697L378.041,61.697L378.041,57.924C378.041,56.928 377.234,56.121 376.238,56.121L373.761,56.121C372.766,56.121 371.959,56.928 371.959,57.924L371.959,61.697L368.186,61.697C367.19,61.697 366.383,62.504 366.383,63.5L366.383,65.977C366.383,66.973 367.19,67.78 368.186,67.78L371.959,67.78L371.959,71.553C371.959,72.549 372.766,73.356 373.761,73.356L376.238,73.356C377.234,73.356 378.041,72.549 378.041,71.553L378.041,67.78L381.815,67.78C382.811,67.78 383.617,66.973 383.617,65.977L383.617,63.5C383.617,62.504 382.811,61.697 381.815,61.697Z"
            fill="white"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </g>
);

export const NutritionLogo = (
  <>
    <g>
      <g>
        <path
          d="M144.844,82.715C140.032,84.447 134.52,85.696 128.386,86.499L128.043,86.543C126.172,81.7 119.917,62.052 98.995,55.32C100.114,49.503 103.166,43.599 104.83,41.954C115.71,49.827 126.933,63.227 127.968,82.993C128.113,71.013 132.344,61.38 138.809,54.363C145.901,46.665 155.682,42.115 165.706,41.069C165.802,41.458 165.894,41.845 165.981,42.231L166.39,41.448L251.775,126.118L251.775,215.951L252.256,216.433L252.256,252.881L121,252.881L81,205L81.24,204.54C80.513,203.863 79.794,203.112 79.083,202.283C66.991,188.154 62.116,178.434 56.479,167.448C50.842,156.461 50.1,152.658 47.656,140.232C45.211,127.807 45.433,97.445 70.019,80.431C81.589,72.425 97.231,77.071 105.949,80.531C114.667,83.991 126.224,86.575 128.043,86.543C130.054,86.508 136.862,85.412 144.52,83.337L144.844,82.715Z"
          fillOpacity="0.2"
        />
      </g>
    </g>
    <g transform="matrix(0.849003,0,0,0.849003,19.3081,17.3991)">
      <g>
        <g>
          <path
            d="M128.074,81.441C131.364,81.384 145.556,78.915 158.194,74.294C197.051,60.084 209.994,86.387 213.995,94.282C217.995,102.177 221.336,129.085 217.283,148.622C212.744,170.502 205.482,188.28 195.496,203.788C178.719,229.842 167.814,229.518 146.908,223.432C140.294,221.506 135.417,218.94 126.454,218.94C108.454,218.94 87.342,237.551 70.406,217.765C56.163,201.124 50.421,189.675 43.782,176.735C37.143,163.795 36.268,159.315 33.389,144.679C30.51,130.044 30.771,94.283 59.73,74.243C73.358,64.812 91.782,70.284 102.05,74.36C112.319,78.435 125.932,81.478 128.074,81.441ZM127.985,77.26C128.155,63.149 133.139,51.803 140.754,43.538C149.108,34.471 160.629,29.112 172.436,27.88C180.487,60.62 162.723,76.907 128.477,81.389L128.074,81.441C125.87,75.737 118.502,52.594 93.859,44.666C95.178,37.814 98.772,30.859 100.732,28.922C113.547,38.195 126.766,53.979 127.985,77.26Z"
            fill="none"
            stroke="white"
            strokeWidth="9.42px"
          />
          <g transform="matrix(0.375058,0,0,0.375058,-142.424,-175.687)">
            <path
              d="M532.239,833.486C524.436,790.541 544.684,728.307 590.76,710.882"
              fill="none"
              stroke="white"
              strokeWidth="25.12px"
            />
          </g>
        </g>
      </g>
    </g>
  </>
);

export const ObstetricsGynaecologyLogo = (
  <>
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
      <g transform="matrix(1,0,0,1,38.3906,67.015)">
        <g>
          <path
            d="M0,-50.577L-4.891,-51.757L-11.758,-51.757L-17.57,-46.757L-17.939,-36.882L-15.341,-34.728L-16.443,-35.01L-9.871,-28.438L-14.848,-24.367L7.564,-1.954L27.969,1.18L27.969,-22.609L0,-50.577Z"
            fillOpacity="0.2"
          />
        </g>
      </g>
    </g>
    <g transform="matrix(4.16667,0,0,4.16667,90.32,150.325)">
      <g>
        <path
          d="M0,-11.89C0,-16.449 3.793,-20.157 8.456,-20.157C13.119,-20.157 16.914,-16.449 16.914,-11.89C16.914,-7.332 13.119,-3.624 8.456,-3.624C3.793,-3.624 0,-7.332 0,-11.89M19.881,-11.89C19.881,-18.084 14.756,-23.124 8.456,-23.124C2.157,-23.124 -2.968,-18.084 -2.968,-11.89C-2.968,-6.375 1.099,-1.785 6.436,-0.844L6.436,2.944L1.866,2.944L1.866,6.57L6.436,6.57L6.436,11.234L10.478,11.234L10.478,6.57L14.87,6.57L14.87,2.944L10.478,2.944L10.478,-0.844C15.814,-1.785 19.881,-6.375 19.881,-11.89"
          fill="white"
          fillRule="nonzero"
        />
      </g>
    </g>
  </>
);

export const OncologyLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g>
      <g>
        <g transform="matrix(1,0,0,1,62.3848,41.9603)">
          <path
            d="M0,-15.704L-20.173,-35.876L-22.752,-31.953L-41.752,-32.578L-26.252,-18.578L-30.283,-16.703L-34.235,-20.183L-41.002,-17.078L-41.752,-9.828L-25.127,6.047L-24.035,7.503L-30.127,7.503L-29.435,8.672L-40.752,8.672L-44.332,12.221L-37.066,19.487L-23.01,19.534L-23.002,19.547L-10.377,20.172L-11.298,19.19L-2.119,18.305L0,-15.704Z"
            fillOpacity="0.2"
          />
        </g>
        <g transform="matrix(1,0,0,1,22.5078,46.1009)">
          <path d="M0,3.362L8.795,3.362L5.433,0L0,3.362Z" fillOpacity="0.2" />
        </g>
      </g>
    </g>
    <g transform="matrix(1,0,0,1,22.1841,31.727)">
      <path
        d="M0,-3.187L16.126,-3.187C15.554,-4.144 15.074,-4.982 14.546,-5.791C14.458,-5.929 14.179,-6.006 13.988,-6.006C10,-6.019 6.01,-6.018 2.022,-6.012C1.854,-6.011 1.619,-5.996 1.528,-5.89C0.851,-5.104 0.307,-4.236 0,-3.187M-0.106,-0.248C0.145,0.814 0.622,1.674 1.244,2.457C1.331,2.565 1.561,2.6 1.724,2.6C5.852,2.608 9.98,2.607 14.107,2.6C14.255,2.6 14.464,2.583 14.541,2.488C15.193,1.683 15.705,0.802 15.96,-0.248L-0.106,-0.248ZM13.378,-15.269C12.289,-16.039 11.216,-16.799 10.152,-17.553C11.357,-18.573 12.539,-19.574 13.72,-20.574C13.699,-20.618 13.675,-20.662 13.652,-20.705L2.343,-20.705C2.301,-20.668 2.259,-20.63 2.217,-20.592C2.386,-20.468 2.557,-20.346 2.724,-20.219C5.078,-18.441 7.409,-16.632 9.791,-14.892C12,-13.279 14.253,-11.73 16.185,-9.777C17.644,-8.301 18.886,-6.672 19.533,-4.671C20.466,-1.781 20.058,0.959 18.496,3.539C17.15,5.761 15.248,7.455 13.214,9.062C12.125,8.296 11.054,7.542 9.945,6.761C10.455,6.35 10.921,5.973 11.496,5.51L4.261,5.51C4.559,5.756 4.748,5.934 4.957,6.084C7.432,7.87 9.919,9.636 12.384,11.436C14.5,12.982 16.513,14.645 18.068,16.791C19.154,18.292 19.843,19.946 20.001,21.803C20.011,21.922 20.021,22.042 20.017,22.162C20.017,22.237 19.994,22.311 19.972,22.417L16.3,22.417C16.099,21.71 15.906,21.027 15.707,20.344C15.599,19.974 15.373,19.839 14.958,19.84C10.269,19.857 5.579,19.856 0.889,19.843C0.511,19.841 0.28,19.946 0.18,20.308C0.043,20.806 -0.122,21.298 -0.223,21.803C-0.313,22.249 -0.526,22.462 -0.991,22.455C-1.81,22.44 -2.628,22.446 -3.446,22.451C-3.973,22.455 -4.137,22.193 -4.093,21.69C-3.897,19.481 -3.005,17.554 -1.547,15.937C-0.405,14.667 0.912,13.554 2.145,12.367C2.401,12.12 2.6,12.099 2.907,12.33C3.829,13.026 4.783,13.679 5.757,14.374C4.754,15.202 3.771,16.016 2.653,16.94L12.951,16.94C12.974,16.901 12.996,16.864 13.019,16.827C12.074,16.075 11.154,15.289 10.181,14.578C7.73,12.792 5.239,11.064 2.798,9.264C1.125,8.032 -0.412,6.632 -1.701,4.987C-4.891,0.913 -4.944,-3.709 -1.839,-7.853C-0.573,-9.542 0.992,-10.93 2.686,-12.25C3.765,-11.493 4.836,-10.742 5.965,-9.95C5.542,-9.616 5.161,-9.315 4.681,-8.937L11.341,-8.937C11.111,-9.13 10.951,-9.282 10.773,-9.41C8.184,-11.276 5.574,-13.113 3.009,-15.012C0.771,-16.667 -1.325,-18.48 -2.776,-20.914C-3.5,-22.129 -3.965,-23.433 -4.077,-24.853C-4.124,-25.458 -3.998,-25.628 -3.413,-25.636C-2.595,-25.648 -1.776,-25.632 -0.958,-25.643C-0.519,-25.649 -0.314,-25.437 -0.231,-25.02C0.047,-23.628 0.054,-23.629 1.442,-23.629C6.013,-23.629 10.583,-23.637 15.154,-23.619C15.628,-23.616 15.859,-23.723 15.988,-24.213C16.359,-25.647 16.382,-25.641 17.892,-25.641C18.353,-25.641 18.81,-25.648 19.269,-25.639C19.898,-25.627 20.039,-25.451 19.984,-24.835C19.816,-22.975 19.101,-21.33 18.019,-19.833C16.732,-18.056 15.115,-16.613 13.378,-15.269"
        fill="white"
      />
    </g>
  </g>
);

export const OphthalmicsLogo = (
  <>
    <g transform="matrix(4.16667,0,0,4.16667,-699.446,-99.4459)">
      <g>
        <g transform="matrix(0.24,0,0,0.24,167.867,23.867)">
          <path
            d="M30.842,132.091L151.605,252.855L251.944,252.855L251.944,157.668L221.081,126.804L156.507,88.4L99.584,86.184L30.842,132.091Z"
            fillOpacity="0.2"
          />
        </g>
      </g>
    </g>
    <g transform="matrix(4.16667,0,0,4.16667,-398.604,-398.485)">
      <path
        d="M125.905,132.255C128.099,132.254 129.888,130.47 129.888,128.273C129.885,126.078 128.099,124.292 125.905,124.291C125.5,124.293 125.114,124.373 124.743,124.487C125.496,124.878 126.014,125.658 126.013,126.567C126.014,126.685 125.997,126.795 125.981,126.906C126.704,126.948 127.288,127.537 127.286,128.273C127.288,129.036 126.668,129.656 125.907,129.655C125.303,129.655 124.801,129.259 124.614,128.716C124.323,128.847 123.997,128.923 123.655,128.923C122.972,128.924 122.366,128.628 121.934,128.168C121.932,128.203 121.924,128.239 121.922,128.273C121.924,130.47 123.71,132.254 125.905,132.255Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(4.16667,0,0,4.16667,-398.602,-398.827)">
      <path
        d="M148.499,125.46C148.042,125.002 137.17,114.257 125.905,114.257C114.644,114.257 103.771,125.002 103.31,125.46C103.008,125.763 102.846,126.175 102.857,126.602C102.871,127.029 103.059,127.432 103.379,127.716C103.836,128.123 114.698,137.66 125.905,137.66C137.114,137.66 147.977,128.123 148.43,127.716C148.752,127.432 148.937,127.029 148.952,126.602C148.963,126.174 148.802,125.764 148.499,125.46ZM125.905,122.563C129.055,122.563 131.617,125.124 131.615,128.273C131.617,131.421 129.053,133.982 125.905,133.982C122.756,133.982 120.198,131.421 120.196,128.273C120.198,125.124 122.754,122.562 125.905,122.563ZM118.714,133.214C113.874,131.523 109.614,128.637 107.295,126.884C109.747,125.772 114.051,124.042 118.925,123.051C117.833,124.508 117.174,126.313 117.172,128.273C117.172,130.106 117.745,131.809 118.714,133.214ZM132.889,123.051C137.763,124.043 142.067,125.773 144.519,126.884C142.198,128.639 137.943,131.528 133.096,133.217C134.063,131.81 134.638,130.108 134.638,128.273C134.639,126.313 133.98,124.507 132.889,123.051ZM137.336,120.939C133.878,119.955 129.918,119.182 125.905,119.183C121.899,119.183 117.927,119.953 114.469,120.936C117.888,118.981 121.92,117.36 125.905,117.36C129.883,117.36 133.918,118.982 137.336,120.939Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </>
);

export const OralLogo = (
  <g>
    <g>
      <path
        d="M85.097,208.24C61.483,187.472 67.753,127.624 67.753,127.624C48.126,98.837 59.9,66.124 59.9,66.121C65.162,52.444 75.359,42.299 90.35,41.075C103.217,40.028 113.804,50.314 125.998,51.004C138.198,50.314 148.78,40.028 161.653,41.075C169.818,41.742 176.561,45.057 181.858,50.147L182,50L257.533,126.894L257.533,265L208.129,265L209,265.871L142.477,265.871L85,208.393L85.097,208.24Z"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(0.83816,0,0,0.83816,-62.2321,-105.301)">
      <path
        d="M224.962,303.803C225.427,303.803 225.887,303.813 226.351,303.806C227.192,303.803 228.041,303.799 228.879,303.86C260.233,305.945 256.183,366.879 256.183,366.879C257.583,382.166 270.654,376.25 270.654,376.25C302.022,353.806 294.071,277.901 294.071,277.901C317.489,243.555 303.441,204.526 303.439,204.522C297.16,188.205 284.996,176.101 267.115,174.64C251.757,173.391 239.131,185.663 224.576,186.487C210.027,185.663 197.396,173.391 182.044,174.64C164.158,176.101 151.993,188.205 145.715,204.522C145.715,204.526 131.667,243.555 155.084,277.901C155.084,277.901 147.132,353.806 178.5,376.25C178.5,376.25 191.573,382.166 192.973,366.879C192.973,366.879 188.923,305.945 220.277,303.86C221.834,303.759 223.401,303.786 224.962,303.803Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="8.35px"
      />
    </g>
    <path
      d="M110,46.08C119.944,50.087 155.744,71.147 165,60"
      fill="none"
      stroke="white"
      strokeWidth="7px"
    />
  </g>
);

export const OrthopaedicsTraumaLogo = (
  <g>
    <g>
      <g>
        <path
          d="M252.52,252.008L78.041,251.993L46.46,220.413L48.313,156.606L59.293,135.246L105.268,123.88L108.882,110.154L98.944,98.776L90.887,78.627L91.848,59.25L101.47,44.452L113.961,36.235L126.689,34.423L139.009,36.829L156.726,45.826L252.52,141.621L252.52,252.008Z"
          fillOpacity="0.2"
        />
        <g transform="matrix(0.804177,0,0,0.804177,23.1116,23.0228)">
          <g transform="matrix(1.24351,0,0,1.24351,-28.7395,-28.629)">
            <path
              d="M118.889,31.708C103.61,34.603 91.306,46.585 88.089,61.784C87.365,65.162 87.285,73.927 87.928,78.109C89.858,90.172 95.407,101.43 103.288,109.07L105.781,111.482L105.459,113.895C105.057,116.951 104.173,119.444 103.047,120.65C102.001,121.856 102.404,121.695 82.621,125.555C74.016,127.164 65.733,129.094 64.044,129.657C54.877,132.873 48.845,139.629 46.352,149.6C45.87,151.53 45.307,155.632 45.066,158.929C44.422,167.292 44.503,216.91 45.146,218.679C45.95,221.011 48.443,221.655 50.373,220.046L51.419,219.242L51.66,186.995C51.901,155.792 51.901,154.747 52.866,151.45C55.359,142.765 59.46,138.181 67.181,135.688C69.03,135.045 78.037,133.115 87.205,131.346C105.379,127.807 106.505,127.485 108.917,124.108C111.089,121.132 112.054,117.996 112.214,112.93L112.456,108.346L107.952,103.762C99.267,95.399 94.683,84.784 94.12,72.48C93.879,65.564 94.603,61.302 97.257,55.994C100.634,49.078 105.379,44.173 111.973,41.036C117.12,38.543 120.176,37.9 126.046,37.9C131.917,37.9 135.053,38.624 140.119,41.036C146.714,44.173 151.539,49.078 154.836,55.994C157.49,61.382 158.294,65.725 157.972,72.48C157.329,84.864 152.825,95.399 144.382,103.843L139.878,108.346L139.878,111.884C139.878,118.881 142.452,124.832 146.553,127.164C147.035,127.485 146.553,131.908 143.899,151.53C142.13,164.719 140.602,176.46 140.441,177.586L140.2,179.677L131.032,179.677C125.966,179.677 120.98,179.918 119.935,180.159C112.054,181.928 105.54,189.085 104.253,197.288C102.645,207.421 109.4,217.553 119.613,220.288C121.463,220.77 128.137,220.931 155.72,220.931C185.555,220.931 189.818,220.85 191.908,220.207C198.985,218.116 204.052,213.291 206.303,206.456C207.107,203.963 207.188,202.596 207.349,186.03C207.509,165.764 207.027,154.827 205.74,149.6C203.891,142.524 200.754,137.457 195.849,133.758C190.541,129.737 188.772,129.255 163.36,124.269C152.665,122.178 150.011,121.535 149.207,120.73C148.081,119.685 147.116,116.951 146.633,113.734L146.312,111.643L149.528,108.346C159.259,98.294 164.647,84.784 164.727,70.469C164.727,64.92 164.164,61.382 162.636,56.959C156.283,39.026 137.546,28.25 118.889,31.708ZM139.315,187.316C139.154,188.04 138.431,193.75 137.546,200.263C136.661,206.697 135.938,212.487 135.777,213.211L135.536,214.417L128.539,214.256C122.106,214.095 121.382,214.015 119.13,212.969C114.145,210.637 111.249,206.456 111.008,200.907C110.847,198.333 111.089,197.127 111.812,195.197C113.34,191.096 117.281,187.718 121.623,186.673C122.508,186.432 126.931,186.271 131.354,186.271L139.476,186.19L139.315,187.316ZM185.395,135.768C191.346,137.779 194.964,140.915 197.538,146.303C200.272,152.174 200.433,152.978 200.433,179.918L200.433,204.204L199.226,206.375C197.538,209.592 192.15,214.256 191.185,213.291C191.024,213.13 188.29,195.278 185.234,173.645L179.524,134.241L180.891,134.562C181.535,134.562 183.625,135.206 185.395,135.768Z"
              fill="white"
              fillRule="nonzero"
            />
          </g>
          <path
            d="M69.5,191.1C68.9,191.4 68,192.4 67.8,193.3C67.4,194.3 67.2,203.4 67.2,218.6C67.2,238.7 67.3,242.5 68,243.8C69.5,246.6 73.7,246.6 75.1,243.8C76.2,241.7 76.1,194.7 75,192.7C73.8,190.5 72,189.9 69.5,191.1Z"
            fill="white"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </g>
);

export const PaediatricsLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,60.2656,20.3037)">
      <path
        d="M0,26.666L0,13.716L-25.075,-11.359L-29.008,-13.296L-33.633,-13.296L-37.883,-11.359L-40.825,-7.699L-39.383,-2.921L-35.758,1.329L-39.383,14.923L-36.883,17.079L-35.133,25.829L-36.848,31.445L-28.332,39.962L-13.293,39.962C-5.982,39.962 0,33.978 0,26.666"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(1,0,0,1,35.8604,24.0314)">
      <path
        d="M0,11.7C-0.018,11.778 -0.147,11.862 -0.241,11.889C-0.521,11.971 -0.807,12.025 -1.114,12.096C-1.161,12.693 -1.203,13.291 -1.255,13.889C-1.351,15.004 -1.533,16.101 -1.745,17.202C-1.943,18.228 -1.95,19.293 -2.016,20.342C-2.029,20.586 -2.115,20.689 -2.336,20.696C-2.654,20.705 -2.971,20.698 -3.29,20.698C-3.399,21.205 -3.399,21.205 -4.329,21.483C-4.036,21.948 -3.752,22.409 -3.456,22.861C-3.417,22.921 -3.315,22.952 -3.237,22.972C-2.803,23.091 -2.367,23.207 -1.93,23.313C-1.685,23.373 -1.501,23.5 -1.396,23.732C-1.135,24.322 -1.027,24.932 -1.169,25.572C-1.225,25.821 -1.334,26.03 -1.603,26.116C-1.652,26.132 -1.722,26.195 -1.724,26.238C-1.735,26.56 -1.966,26.679 -2.216,26.74C-3.099,26.963 -3.981,27.179 -4.87,27.374C-5.326,27.474 -5.792,27.526 -6.254,27.601L-7.213,27.601C-7.487,27.546 -7.766,27.504 -8.035,27.429C-8.884,27.196 -9.73,26.954 -10.575,26.705C-10.854,26.625 -10.974,26.423 -10.959,26.127C-10.917,25.293 -10.712,24.524 -10.196,23.841C-9.646,23.113 -9.24,22.319 -9.327,21.36C-9.836,21.197 -9.836,21.197 -9.758,20.639C-9.746,20.547 -9.717,20.454 -9.717,20.361C-9.716,19.989 -9.654,19.598 -9.742,19.247C-10.072,17.928 -10.463,16.623 -10.808,15.306C-10.888,15.004 -10.938,14.667 -10.891,14.362C-10.82,13.912 -10.666,13.471 -10.517,13.038C-10.445,12.83 -10.456,12.657 -10.557,12.473C-10.75,12.125 -11.013,11.922 -11.441,11.958C-11.956,11.999 -12.474,12.032 -12.99,12.027C-13.776,12.019 -14.037,11.704 -13.951,10.928C-13.856,10.059 -13.546,9.252 -13.229,8.448C-13.198,8.371 -13.15,8.281 -13.166,8.21C-13.329,7.473 -13.204,6.747 -13.077,6.026C-12.942,5.251 -12.877,4.44 -12.436,3.765C-12.105,3.262 -11.916,2.712 -11.701,2.165C-11.372,1.326 -11.028,0.493 -10.694,-0.333C-11.092,-0.697 -10.767,-1.05 -10.658,-1.373C-10.587,-1.581 -10.389,-1.798 -10.192,-1.897C-9.996,-1.994 -9.729,-1.948 -9.482,-1.967C-9.71,-2.381 -9.981,-2.801 -10.181,-3.253C-10.424,-3.804 -10.813,-4.139 -11.364,-4.367C-12.788,-4.957 -13.652,-6.058 -14.116,-7.502C-14.144,-7.591 -14.186,-7.675 -14.238,-7.803C-14.298,-7.554 -14.346,-7.36 -14.393,-7.165C-14.456,-7.298 -14.494,-7.426 -14.496,-7.555C-14.501,-8.134 -14.461,-8.715 -14.504,-9.291C-14.563,-10.075 -14.53,-10.846 -14.313,-11.664C-14.594,-11.458 -14.826,-11.286 -15.058,-11.115L-15.058,-11.228C-14.79,-11.469 -14.51,-11.699 -14.26,-11.957C-14.141,-12.079 -14.078,-12.255 -13.961,-12.454C-14.138,-12.412 -14.26,-12.384 -14.467,-12.335C-14.139,-12.561 -13.879,-12.739 -13.621,-12.918C-13.633,-12.949 -13.646,-12.98 -13.659,-13.011C-13.978,-13.037 -14.297,-13.062 -14.617,-13.088C-14.621,-13.113 -14.626,-13.139 -14.63,-13.165C-14.28,-13.249 -13.935,-13.364 -13.579,-13.408C-13.344,-13.437 -13.178,-13.513 -13.034,-13.692C-12.911,-13.843 -12.768,-13.979 -12.625,-14.131C-12.777,-14.21 -12.907,-14.278 -13.114,-14.387C-12.959,-14.387 -12.869,-14.414 -12.812,-14.382C-12.529,-14.223 -12.331,-14.359 -12.123,-14.538C-11.96,-14.678 -11.771,-14.787 -11.574,-14.923C-11.662,-15.021 -11.75,-15.118 -11.863,-15.244C-11.776,-15.236 -11.717,-15.248 -11.688,-15.224C-11.412,-14.996 -11.168,-15.133 -10.895,-15.252C-7.467,-16.744 -3.216,-15.586 -1.142,-12.601C-0.695,-11.96 -0.369,-11.269 -0.306,-10.476C-0.255,-9.875 -0.379,-9.312 -0.694,-8.804C-0.776,-8.675 -0.959,-8.613 -1.079,-8.503C-1.174,-8.416 -1.305,-8.308 -1.314,-8.201C-1.37,-7.559 -1.65,-7.035 -2.087,-6.581C-2.146,-6.52 -2.198,-6.453 -2.251,-6.386C-2.558,-5.988 -2.518,-5.835 -2.101,-5.554C-1.97,-5.465 -1.84,-5.293 -1.821,-5.145C-1.811,-5.053 -2.021,-4.943 -2.115,-4.828C-2.177,-4.753 -2.237,-4.657 -2.248,-4.565C-2.264,-4.437 -2.229,-4.303 -2.225,-4.172C-2.212,-3.73 -2.26,-3.667 -2.677,-3.568C-2.665,-3.499 -2.652,-3.429 -2.642,-3.359C-2.614,-3.183 -2.672,-3.087 -2.861,-3.035C-2.988,-3.001 -3.119,-2.901 -3.199,-2.793C-3.372,-2.559 -3.499,-2.294 -3.667,-2.056C-3.904,-1.717 -4.242,-1.586 -4.651,-1.649C-4.855,-1.68 -5.07,-1.692 -5.258,-1.766C-5.554,-1.882 -5.693,-1.788 -5.744,-1.487C-5.022,-1.612 -4.687,-1.07 -4.303,-0.633C-4.145,-0.454 -4.037,-0.216 -4.207,0.045C-3.358,0.253 -2.848,0.86 -2.42,1.552C-1.744,2.641 -1.344,3.845 -1.011,5.07C-0.474,7.042 -0.115,9.047 0.04,11.086C0.054,11.29 0.044,11.502 0,11.7M2.019,10.935C1.858,8.822 1.483,6.674 0.905,4.55C0.569,3.314 0.112,1.868 -0.731,0.508C-1.019,0.044 -1.415,-0.519 -1.987,-0.996C-1.907,-1.115 -1.833,-1.237 -1.759,-1.36C-1.333,-1.605 -1.011,-1.969 -0.827,-2.402C-0.513,-2.751 -0.286,-3.236 -0.245,-3.911C0.147,-4.445 0.196,-4.985 0.147,-5.392C0.122,-5.603 0.065,-5.812 -0.019,-6.013C0.22,-6.39 0.399,-6.79 0.517,-7.208C0.671,-7.341 0.841,-7.519 0.991,-7.758C1.524,-8.614 1.759,-9.612 1.673,-10.634C1.587,-11.696 1.2,-12.711 0.489,-13.733C-1.292,-16.295 -4.438,-17.886 -7.723,-17.886C-9.111,-17.886 -10.444,-17.612 -11.685,-17.072C-11.759,-17.04 -11.833,-17.013 -11.906,-16.986C-12.201,-16.875 -12.604,-16.723 -13.026,-16.426C-13.384,-16.175 -13.666,-15.908 -13.914,-15.673L-14.147,-15.454C-14.623,-15.028 -15.083,-14.508 -15.477,-13.953C-15.955,-13.28 -16.272,-12.429 -16.419,-11.426C-16.513,-10.791 -16.543,-10.225 -16.51,-9.698C-16.485,-9.281 -16.39,-8.932 -16.321,-8.677C-16.299,-8.597 -16.272,-8.518 -16.261,-8.435C-15.962,-5.704 -14.507,-3.583 -12.26,-2.592C-12.376,-2.408 -12.472,-2.212 -12.542,-2.009C-12.852,-1.357 -12.908,-0.796 -12.836,-0.332C-13.075,0.256 -13.314,0.846 -13.548,1.44L-13.643,1.684C-13.795,2.08 -13.927,2.422 -14.095,2.678C-14.699,3.6 -14.852,4.564 -14.975,5.339L-15.031,5.682C-15.148,6.35 -15.29,7.151 -15.199,8.039C-15.492,8.793 -15.812,9.695 -15.923,10.709C-16.031,11.682 -15.813,12.482 -15.277,13.088C-14.742,13.691 -13.979,14.002 -13.008,14.012L-12.844,14.012C-12.846,14.027 -12.849,14.043 -12.851,14.057C-12.934,14.592 -12.892,15.181 -12.727,15.808C-12.575,16.39 -12.414,16.971 -12.252,17.55C-12.051,18.275 -11.849,19 -11.68,19.656C-11.672,19.748 -11.683,19.842 -11.687,19.935C-11.692,20.029 -11.696,20.123 -11.699,20.217C-11.708,20.267 -11.716,20.318 -11.723,20.366C-11.826,21.101 -11.743,21.697 -11.464,22.167C-11.537,22.301 -11.638,22.459 -11.78,22.645C-12.495,23.594 -12.874,24.7 -12.94,26.029C-13.001,27.263 -12.288,28.276 -11.136,28.608C-10.279,28.86 -9.421,29.106 -8.562,29.343C-8.32,29.409 -8.073,29.458 -7.825,29.504L-7.608,29.546L-7.213,29.586L-6.253,29.586L-5.935,29.559L-5.518,29.497C-5.158,29.444 -4.797,29.389 -4.444,29.312C-3.535,29.112 -2.634,28.891 -1.741,28.667C-0.911,28.463 -0.382,28.006 -0.075,27.484C0.339,27.114 0.634,26.606 0.769,26.001C0.993,24.991 0.874,23.957 0.413,22.919C0.206,22.458 -0.11,22.079 -0.513,21.803C-0.235,21.439 -0.063,20.98 -0.034,20.465C-0.019,20.21 -0.007,19.954 0.007,19.697C0.044,18.94 0.079,18.224 0.204,17.577C0.386,16.632 0.61,15.377 0.722,14.06C0.735,13.912 0.747,13.763 0.759,13.615C1.276,13.346 1.772,12.86 1.938,12.13C2.021,11.759 2.048,11.363 2.019,10.935"
        fill="white"
      />
    </g>
  </g>
);

export const PainLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,63.7139,36.8308)">
      <g>
        <path
          d="M0,22.633L-9.146,13.52L-31.566,-8.901L-39.327,-2.148L-48.275,-11.097L-52.476,-1.74L-48.078,-0.792L-53.145,9.416L-30.271,32.29L-12.662,32.29L-3.448,33.73L0,22.633Z"
          fillOpacity="0.2"
        />
      </g>
    </g>
    <g transform="matrix(1,0,0,1,10.5933,24.9108)">
      <path
        d="M0,21.347L4.296,11.623L-0.668,10.86L3.055,0L4.869,0.834L1.432,9.304L6.874,9.304L0,21.347Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,16.1309,26.3183)">
      <path
        d="M0,21.959L9.93,12.412L4.965,10.598L14.438,0L16.04,1.623L8.402,9.738L13.081,12.412L0,21.959Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,19.1396,42.0714)">
      <path
        d="M0,10.121L10.645,7.447L7.685,4.186L18.76,0L19.906,1.927L9.953,4.679L13.031,8.498L0,10.121Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </g>
);

export const PalliativeCareLogo = (
  <>
    <g>
      <g>
        <path
          d="M127.891,150.983C127.271,151.489 126.64,152.002 126,152.522C108.65,138.42 98.109,129.445 88.684,120.001C67.953,99.663 69.621,81.035 69.621,81.035L69.625,81.035C69.609,80.648 69.594,80.26 69.594,79.87C69.594,64.188 82.82,50.596 99.134,50.596C111.063,50.596 121.333,58.275 125.997,68.059L126.003,68.059C130.667,58.275 140.937,50.596 152.865,50.596C160.398,50.596 167.272,53.494 172.49,58.157L174.37,54.246L220.855,100.731L221,92L252,123L252,252L124,252L54,182L28.434,112.434L44,93L131.354,180.354L142.384,174L125,157L127.891,150.983Z"
          fillOpacity="0.2"
        />
      </g>
    </g>
    <g transform="matrix(1,0,0,1,2.50328,-1.95597)">
      <g transform="matrix(0.350609,0,0,0.350609,-86.8705,-41.7154)">
        <path
          d="M760.809,355.685L760.797,355.685C760.844,354.582 760.885,353.476 760.885,352.362C760.885,307.636 723.163,268.868 676.629,268.868C642.608,268.868 613.316,290.771 600.014,318.674L599.997,318.674C586.694,290.771 557.403,268.868 523.38,268.868C476.848,268.868 439.125,307.636 439.125,352.362C439.125,353.476 439.167,354.582 439.213,355.685L439.202,355.685C439.202,355.685 434.446,408.816 493.573,466.824C520.456,493.76 550.521,519.357 600.005,559.58C649.49,519.357 679.555,493.76 706.438,466.824C765.565,408.816 760.809,355.685 760.809,355.685Z"
          fill="none"
          stroke="white"
          strokeWidth="22.82px"
        />
      </g>
      <g transform="matrix(0.350609,0,0,0.350609,-86.8705,-41.7154)">
        <path
          d="M394.667,555.165C394.667,555.165 377.456,520.743 366.392,511.523C355.328,502.303 360.245,489.395 380.529,492.468C400.813,495.542 428.474,531.807 441.997,548.404C455.52,565 470.886,566.229 470.886,566.229C520.675,573.605 535.291,577.134 562.541,620.161C597.57,675.469 571.146,701.298 534.266,698.839C497.386,696.381 477.716,677.94 477.716,677.94C477.716,677.94 425.4,644.908 405.116,635.688C384.832,626.467 339.96,532.422 329.511,507.22C319.062,482.019 327.052,392.276 341.804,392.891C356.557,393.506 364.547,402.111 364.547,434.689C364.547,467.267 367.621,482.634 367.621,482.634"
          fill="none"
          stroke="white"
          strokeWidth="22.82px"
        />
      </g>
      <g transform="matrix(0.350609,0,0,0.350609,-86.8705,-41.7154)">
        <path
          d="M805.344,555.165C805.344,555.165 822.555,520.743 833.619,511.523C844.683,502.303 839.766,489.395 819.482,492.468C799.197,495.542 771.537,531.807 758.014,548.404C744.491,565 729.125,566.229 729.125,566.229C679.336,573.605 664.72,577.134 637.47,620.161C602.441,675.469 628.864,701.298 665.745,698.839C702.625,696.381 722.295,677.94 722.295,677.94C722.295,677.94 774.61,644.908 794.895,635.688C815.179,626.467 860.05,532.422 870.5,507.22C880.949,482.019 872.958,392.276 858.206,392.891C843.454,393.506 835.463,402.111 835.463,434.689C835.463,467.267 832.39,482.634 832.39,482.634"
          fill="none"
          stroke="white"
          strokeWidth="22.82px"
        />
      </g>
    </g>
  </>
);

export const PharmacyLogo = (
  <g>
    <g>
      <g>
        <path
          d="M94.211,54.782L70.066,47.921L47.092,55.93L39.117,76.132L47.55,205.764L93.921,252.135L252.193,252.135L252.131,145.73L203.948,97.547L134.45,95.021L94.211,54.782Z"
          fillOpacity="0.2"
        />
        <path
          d="M218.785,138.533C216.761,165.844 193.931,187.405 166.104,187.405C138.278,187.405 115.448,165.844 113.423,138.533L218.785,138.533ZM113.43,130.533C115.5,103.262 138.31,81.75 166.104,81.75C193.898,81.75 216.708,103.262 218.779,130.533L113.43,130.533Z"
          fill="white"
        />
        <path
          d="M35.2,179.717C35.2,198.498 50.447,213.746 69.228,213.746C88.009,213.746 103.257,198.498 103.257,179.717C103.257,179.717 103.257,77.899 103.257,77.899C103.257,59.118 88.009,43.871 69.228,43.871C50.447,43.871 35.2,59.118 35.2,77.899L35.2,179.717ZM95.257,129.539L95.257,77.899C95.257,63.533 83.594,51.871 69.228,51.871C54.863,51.871 43.2,63.533 43.2,77.899L43.2,129.539L95.257,129.539Z"
          fill="white"
        />
      </g>
    </g>
  </g>
);

export const PlaceholderCategoryIconLogo = (
  <g>
    <g>
      <g transform="matrix(1.05547,0,0,1.05547,-6.73702,-6.73553)">
        <path
          d="M78.637,181.749C62.564,168.312 52.334,148.117 52.334,125.552C52.334,85.141 85.142,52.333 125.553,52.333C145.936,52.333 164.385,60.68 177.668,74.142L254.14,150.614L251.104,150.022L251.104,250.754L147.642,250.754L78.637,181.749Z"
          fillOpacity="0.2"
        />
      </g>
      <g transform="matrix(3.28986,0,0,3.28986,-51.1715,-282.733)">
        <circle
          cx="53.718"
          cy="124.104"
          r="22.256"
          fill="none"
          stroke="white"
          strokeWidth="2.43px"
        />
      </g>
    </g>
  </g>
);

export const RenalLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,60.2656,25.2297)">
      <path
        d="M0,21.74L0,12.055L-22.968,-10.896C-24.493,-12.423 -26.55,-13.296 -28.892,-13.295C-31.16,-13.295 -33.433,-12.488 -35.29,-11.019C-39.319,-7.844 -41.649,-2.9 -41.843,2.9C-41.995,7.487 -41.241,13.838 -36.905,18.261L-20.146,35.036L-13.293,35.036C-5.982,35.036 0,29.052 0,21.74"
        fill="rgb(225,82,26)"
      />
    </g>
    <g transform="matrix(1,0,0,1,40.3311,22.6848)">
      <path
        d="M0,22.491L-0.173,23.883C-0.491,26.511 -0.527,29.19 -0.518,31.929C-0.67,31.936 -0.834,31.943 -0.99,31.95C-0.964,29.529 -0.844,27.083 -0.726,24.709C-0.647,23.114 -0.567,21.52 -0.516,19.924C-0.487,19.036 -0.481,18.149 -0.521,17.277C-0.319,13.196 -1.998,10.239 -5.304,8.893C-4.807,8.195 -4.422,7.36 -4.223,6.496C-3.994,5.507 -4.018,4.548 -4.291,3.67C-4.187,3.615 -4.092,3.561 -3.99,3.508C1.842,7.692 0.832,15.863 0,22.491M-2.748,18.348C-3.193,21.463 -6.238,22.567 -8.708,22.567C-9.98,22.567 -11.235,22.28 -12.242,21.758C-13.266,21.227 -14.352,20.421 -15.305,19.483C-19.254,15.595 -19.917,9.742 -19.775,5.515C-19.603,0.355 -17.564,-4.019 -14.035,-6.8C-12.551,-7.972 -10.749,-8.617 -8.957,-8.618C-6.275,-8.618 -4.152,-7.197 -3.125,-4.72C-2.355,-2.854 -2.374,-0.21 -4.217,1.17C-5.334,1.998 -6.019,1.974 -6.314,2.164C-6.808,2.481 -6.954,3.136 -6.64,3.633C-6.103,4.482 -6.158,5.399 -6.303,6.018C-6.565,7.165 -7.295,8.13 -7.879,8.491C-8.25,8.72 -8.445,9.151 -8.369,9.582C-8.293,10.012 -7.961,10.352 -7.533,10.442C-3.722,11.235 -2.111,13.894 -2.748,18.348M-2.814,2.76C-0.197,0.664 -0.101,-2.982 -1.156,-5.533C-2.51,-8.8 -5.422,-10.75 -8.957,-10.75C-11.226,-10.75 -13.498,-9.943 -15.355,-8.474C-19.385,-5.299 -21.715,-0.355 -21.908,5.445C-22.061,10.097 -21.303,16.573 -16.799,21.003C-15.699,22.087 -14.43,23.026 -13.225,23.652C-11.9,24.339 -10.34,24.699 -8.708,24.7C-6.135,24.699 -3.428,23.718 -1.871,21.631C-1.913,22.636 -1.955,23.641 -2.002,24.645C-2.135,27.247 -2.266,29.938 -2.275,32.6C-2.277,32.834 -2.151,33.051 -1.945,33.163C-1.842,33.221 -1.599,33.241 -1.305,33.24C-0.629,33.239 0.304,33.134 0.312,33.13C0.582,33.048 0.766,32.798 0.764,32.518C0.75,29.613 0.767,26.782 1.099,24.037L1.268,22.652C2.128,15.821 3.182,7.427 -2.814,2.76"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </g>
);

export const RespiratoryLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(1,0,0,1,60.2656,21.9737)">
      <path
        d="M0,24.996L0,14.923L-27.973,-13.05C-27.973,-13.05 -28.439,-13.285 -28.764,-13.222C-29.854,-13.011 -30.236,-13.011 -31.332,-13.222C-31.717,-13.296 -32.037,-13.193 -32.214,-12.946C-32.324,-12.794 -32.426,-12.524 -32.283,-12.099C-32.006,-11.272 -31.866,-10.866 -31.592,-10.067C-31.539,-9.915 -31.451,-9.796 -31.349,-9.696L-31.354,-9.691L-30.688,-9.025C-30.875,-9.062 -30.988,-9.103 -30.988,-9.103L-31.262,-9.218L-31.254,-8.923C-31.233,-8.108 -31.216,-7.295 -31.201,-6.478C-31.177,-5.463 -31.171,-4.45 -31.165,-3.437C-31.162,-2.911 -31.159,-2.384 -31.153,-1.858C-31.152,-1.711 -31.155,-1.563 -31.155,-1.415L-32.862,-3.122C-32.862,-3.122 -33.838,-3.78 -34.596,-3.945C-34.824,-3.987 -35.059,-4.008 -35.292,-4.008C-40.719,-4.007 -46.418,7.365 -47.588,13.311C-48.495,17.934 -47.694,23.45 -47.136,26.328C-47.053,26.751 -47.053,27.112 -47.053,27.44C-47.05,27.892 -47.045,28.511 -46.629,28.939L-37.277,38.292L-13.293,38.292C-5.982,38.292 0,32.308 0,24.996"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(1,0,0,1,28.6963,11.9854)">
      <path
        d="M0,-2.586C0.03,-2.593 0.067,-2.592 0.111,-2.583C0.704,-2.469 1.111,-2.422 1.522,-2.422C1.927,-2.422 2.35,-2.471 2.932,-2.583C3.157,-2.626 3.19,-2.515 3.129,-2.321C2.852,-1.498 2.714,-1.092 2.439,-0.295C2.354,-0.052 1.901,0.059 1.517,0.059C1.136,0.059 0.688,-0.053 0.603,-0.295C0.329,-1.092 0.192,-1.498 -0.083,-2.321C-0.131,-2.458 -0.108,-2.565 0,-2.586M-0.022,-0.079C0.233,0.664 1.22,0.722 1.517,0.722C1.815,0.721 2.808,0.664 3.065,-0.079C3.339,-0.878 3.479,-1.284 3.757,-2.111C3.897,-2.535 3.798,-2.805 3.687,-2.959C3.509,-3.204 3.188,-3.308 2.806,-3.234C1.715,-3.023 1.333,-3.023 0.237,-3.234C-0.147,-3.307 -0.468,-3.205 -0.645,-2.958C-0.755,-2.806 -0.856,-2.535 -0.714,-2.11C-0.437,-1.284 -0.297,-0.878 -0.022,-0.079"
        fill="white"
        fillRule="nonzero"
      />
    </g>
    <g transform="matrix(1,0,0,1,45.6309,16.1846)">
      <path
        d="M0,31.79C-0.112,32.362 -0.114,32.847 -0.115,33.22C-0.115,33.302 -0.115,33.413 -0.119,33.505C-0.713,33.569 -1.522,33.001 -2.118,32.585C-2.423,32.373 -2.711,32.173 -3.004,32.005C-5.259,30.731 -7.995,30.028 -10.711,30.029C-11.082,30.029 -11.454,30.042 -11.816,30.067C-12.98,30.144 -13.223,29.745 -13.244,27.482C-13.244,27.226 -13.248,26.976 -13.256,26.739C-13.291,25.903 -13.359,25.073 -13.428,24.269L-13.443,24.058C-13.584,22.423 -13.714,20.879 -13.614,19.261C-13.59,18.852 -13.553,18.417 -13.502,17.935C-13.33,17.692 -12.561,16.546 -12.934,15.71L-12.957,14.778C-12.904,14.571 -12.852,14.368 -12.793,14.17C-12.019,11.519 -12.025,9.234 -12.031,7.398C-12.037,4.519 -11.902,3.816 -10.561,3.522C-10.434,3.499 -10.303,3.488 -10.169,3.488C-6.107,3.488 -0.759,13.279 0.45,19.429C1.303,23.767 0.535,29.036 0,31.79M-17.386,24.087C-17.457,24.948 -17.532,25.841 -17.57,26.739C-17.579,26.976 -17.582,27.226 -17.582,27.48C-17.6,29.614 -17.816,30.075 -18.808,30.074C-18.87,30.075 -18.938,30.073 -19.01,30.067C-19.372,30.042 -19.744,30.029 -20.113,30.029C-22.829,30.028 -25.567,30.731 -27.822,32.006C-28.115,32.172 -28.403,32.373 -28.714,32.589C-29.379,33.052 -30.152,33.589 -30.707,33.507C-30.711,33.412 -30.711,33.296 -30.711,33.198C-30.712,32.847 -30.714,32.362 -30.826,31.791C-31.361,29.038 -32.131,23.771 -31.275,19.43C-30.07,13.28 -24.721,3.487 -20.657,3.488C-20.529,3.488 -20.396,3.498 -20.297,3.517C-18.924,3.816 -18.787,4.519 -18.795,7.397C-18.801,9.234 -18.808,11.519 -18.033,14.17C-17.976,14.368 -17.922,14.571 -17.869,14.777L-17.893,15.71C-18.267,16.546 -17.496,17.692 -17.323,17.935C-17.274,18.38 -17.237,18.825 -17.212,19.261C-17.111,20.897 -17.25,22.503 -17.386,24.087M2.126,19.101C0.957,13.154 -4.742,1.782 -10.169,1.782C-10.406,1.782 -10.641,1.804 -10.894,1.85C-13.752,2.475 -13.744,4.867 -13.738,7.403C-13.732,8.866 -13.727,10.645 -14.17,12.653C-14.195,12.418 -14.211,12.163 -14.225,11.877C-14.258,10.768 -14.275,9.66 -14.293,8.552L-14.297,8.009C-14.307,6.65 -14.315,5.29 -14.308,3.932C-14.302,3.405 -14.299,2.879 -14.296,2.353C-14.29,1.338 -14.285,0.325 -14.26,-0.69C-14.245,-1.506 -14.229,-2.32 -14.207,-3.133L-14.199,-3.43L-14.471,-3.314C-14.476,-3.313 -14.838,-3.173 -15.413,-3.173C-15.988,-3.173 -16.352,-3.313 -16.355,-3.314L-16.627,-3.429L-16.619,-3.134C-16.599,-2.319 -16.581,-1.505 -16.566,-0.689C-16.542,0.326 -16.536,1.339 -16.53,2.353C-16.527,2.878 -16.524,3.405 -16.519,3.931C-16.512,5.29 -16.52,6.649 -16.53,8.009L-16.533,8.551C-16.551,9.66 -16.568,10.768 -16.602,11.873C-16.616,12.16 -16.631,12.416 -16.656,12.653C-17.098,10.652 -17.094,8.87 -17.09,7.403C-17.082,4.868 -17.074,2.474 -19.961,1.844C-20.189,1.802 -20.424,1.781 -20.657,1.781C-26.084,1.782 -31.783,13.154 -32.953,19.101C-33.86,23.724 -33.06,29.239 -32.501,32.117C-32.418,32.54 -32.418,32.901 -32.418,33.229C-32.414,33.837 -32.41,34.753 -31.396,35.092C-31.139,35.177 -30.868,35.22 -30.594,35.22C-29.503,35.22 -28.569,34.568 -27.729,33.982C-27.46,33.795 -27.205,33.616 -26.981,33.491C-24.71,32.206 -21.877,31.582 -19.129,31.769C-19.018,31.777 -18.908,31.78 -18.805,31.78C-15.914,31.78 -15.89,28.993 -15.877,27.495C-15.876,27.259 -15.873,27.027 -15.866,26.81C-15.828,25.915 -15.749,25.004 -15.68,24.176C-15.543,22.556 -15.401,20.882 -15.508,19.155C-15.578,18.04 -15.703,16.966 -15.878,15.96L-15.413,15.115L-14.949,15.96C-15.123,16.964 -15.248,18.04 -15.318,19.155C-15.425,20.882 -15.284,22.556 -15.146,24.201C-15.077,25.005 -14.998,25.915 -14.962,26.809C-14.953,27.028 -14.951,27.259 -14.949,27.495C-14.937,28.993 -14.912,31.78 -12.02,31.78C-11.918,31.78 -11.809,31.776 -11.697,31.769C-11.38,31.747 -11.053,31.735 -10.729,31.735C-8.291,31.735 -5.846,32.358 -3.846,33.491C-3.613,33.621 -3.347,33.808 -3.084,33.99C-2.26,34.567 -1.326,35.22 -0.232,35.22C0.041,35.22 0.312,35.176 0.574,35.091C1.584,34.752 1.588,33.837 1.592,33.221C1.592,32.901 1.592,32.54 1.674,32.116C2.233,29.239 3.034,23.724 2.126,19.101"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </g>
);

export const ResuscitationLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g transform="matrix(0.24,0,0,0.24,0,0)">
      <g>
        <path
          d="M82.173,177.031L79.155,179.473C35.455,143.277 33.693,114.589 33.693,95.168C33.693,75.748 49.139,43.085 87.98,42.643C112.26,42.643 128.589,58.531 128.589,61.623C128.589,58.531 144.039,42.643 166.547,42.643C189.06,42.643 204.064,57.727 206.714,62.948L204.588,64.272L210.23,64.272L276.317,130.364L274.88,142.993L274.88,265.105L161.355,265.105L78.709,182.464L82.173,177.031Z"
          fillOpacity="0.2"
        />
      </g>
    </g>
    <g transform="matrix(1,0,0,1,49.6113,38.2004)">
      <path
        d="M0,-23.093L-14.618,-13.983L-7.309,-13.983L-30.614,4.873C-41.102,-3.814 -41.525,-10.699 -41.525,-15.36C-41.525,-20.021 -37.818,-27.86 -28.496,-27.966C-22.669,-27.966 -18.75,-24.153 -18.75,-23.411C-18.75,-24.153 -15.042,-27.966 -9.64,-27.966C-4.237,-27.966 -0.636,-24.346 0,-23.093Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.5px"
      />
    </g>
    <g transform="matrix(1,0,0,1,22.0693,23.7268)">
      <path
        d="M0,21.571L26.165,-1.522L20.656,-1.522L28.807,-5.536C30.713,-1.829 32.626,6.105 25.317,13.308C18.009,20.511 9.428,27.107 9.428,27.107L0,21.571Z"
        fill="none"
        fillRule="nonzero"
        stroke="white"
        strokeWidth="1.5px"
      />
    </g>
  </g>
);

export const RevisionControlLogo = (
  <>
    <g>
      <path
        d="M54.156,209.167L35.679,190.69L63.056,160.832L62.48,88.231L42.824,73.168L43.6,50.143L67.152,40.93L89.528,47.372L163.716,121.56L185.198,120.39L179.198,75.127L210.024,44.096L269.99,104.061L277.319,263.78L115.816,260.26L117.471,261.915L95.55,261.915L42.527,208.892L54.156,209.167Z"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(0.45066,0,0,0.45066,10.637,10.6708)">
      <path
        d="M136,256L136,211C136,204.231 134.568,195.599 136.318,189.044C137.971,182.853 149.939,180.566 155,177.547C166.208,170.862 175.536,160.858 181.11,149C206.234,95.557 154.211,36.332 98,54.671C65.627,65.233 47.155,97.924 52.275,131C54.889,147.891 64.317,163.357 78,173.522C83.933,177.929 101.246,182.274 101.941,190.015C104.56,219.159 102,249.726 102,279C102,292.485 105.32,310.932 101.682,323.892C100.149,329.355 88.58,331.71 84,334.337C73.655,340.271 64.927,349.494 59.323,360C32.728,409.863 76.022,468.234 131,459.725C179.823,452.169 203.907,392.71 175.079,353C168.666,344.165 160.729,337.258 151,332.259C147.081,330.245 138.293,328.658 137.028,323.892C133.07,308.978 147.899,289.866 159,282.221C176.649,270.067 198.721,273 219,273L329,273C348.358,273 368.724,275.589 386,265.073C404.178,254.009 409.968,234.081 410,214C410.012,206.572 407.572,194.049 410.603,187.225C412.863,182.138 425.309,179.332 430,176.301C441.719,168.73 450.637,157.983 455.796,145C477.592,90.15 422.84,35.722 368,55.695C325.547,71.157 311.413,125.876 338.428,161C344.303,168.638 351.468,174.697 360,179.218C364.238,181.465 372.408,182.968 374.972,187.225C377.004,190.597 376,196.224 376,200C376,210.7 378.555,225.668 369.895,233.786C363.495,239.786 355.103,239 347,239L217,239C199.315,239 181.187,237.502 164,242.427C153.689,245.382 145.261,250.864 136,256M116,85.29C160.43,79.716 166.571,148.43 122,153.707C78.581,158.847 72.546,90.741 116,85.29M117,358.293C136.561,355.978 155.287,374.492 153.815,394C152.472,411.791 139.49,424.642 122,426.707C77.894,431.914 72.957,363.507 117,358.293Z"
        fill="white"
        fillRule="nonzero"
      />
    </g>
  </>
);

export const RheumatologyLogo = (
  <g>
    <g>
      <g>
        <path
          d="M58.707,193.023C58.707,193.023 35.138,151.209 35.138,126C35.138,75.852 75.852,35.138 126,35.138C151.891,35.138 193.838,59.644 193.838,59.644L252.089,117.895L252.089,252.235L148.292,252.235L148.221,252.164L117.848,252.164L58.707,193.023Z"
          fillOpacity="0.2"
        />
        <g transform="matrix(1,0,0,1,3.18038,-27.612)">
          <g transform="matrix(1.51202,0,0,1.51202,-75.8453,-79.8842)">
            <circle
              cx="131.39"
              cy="154.427"
              r="60.093"
              fill="none"
              stroke="white"
              strokeWidth="5.29px"
            />
          </g>
          <g transform="matrix(0.141389,0,0,0.141389,27.4393,53.8779)">
            <path
              d="M427.526,141.611C428.265,141.474 728.914,449.579 737.509,456.54C746.105,463.501 768.959,486.453 795.693,499.826C822.427,513.198 891.406,544.555 863.388,657.521C835.37,770.487 723.991,810.654 651.375,802.786C578.76,794.918 511.285,763.006 537.005,680.41C562.724,597.814 541.21,519.793 492.816,466.488C444.423,413.182 277.506,234.503 277.506,234.503C292.25,213.889 394.751,147.692 427.526,141.611Z"
              fill="white"
            />
          </g>
          <g transform="matrix(0.141389,0,0,0.141389,27.4393,53.8779)">
            <path
              d="M892.421,599.112C890.468,580.306 888.126,558.492 885.516,546.777C882.906,535.061 891.678,521.144 906.385,533.446C921.092,545.748 943.781,584.464 948.064,608.865C951.233,626.913 952.926,666.783 931.238,702.201C920.632,719.521 897.386,745.732 876.991,760.424C868.372,766.633 845.878,767.489 855.735,738.864C859.766,727.156 872.505,706.688 879.158,691.32C885.81,675.951 895.648,630.19 892.421,599.112Z"
              fill="white"
            />
          </g>
          <g transform="matrix(0.141389,0,0,0.141389,27.4393,53.8779)">
            <path
              d="M826.119,1220.95C832.449,1178.6 853.458,1080.48 865.191,1037.37C876.923,994.249 889.685,927.692 872.399,897.902C855.112,868.113 851.3,845.359 846.222,831.247C841.145,817.134 824.851,791.461 793.405,797.804C767.434,803.043 744.082,813.253 715.365,824.983C684.061,837.77 647.225,835.627 603.666,825.051C559.697,814.375 520.817,811.196 504.198,852.698C487.579,894.201 516.253,906.431 528.715,915.625C554.95,934.98 595.481,978.677 615.976,1048.78C628.059,1090.11 634.268,1137.73 637.262,1198.38C640.257,1259.02 640.719,1311.08 640.512,1318.45C670.038,1323.95 793.509,1317.33 814.083,1303.8C816.503,1286.14 819.788,1263.31 826.119,1220.95Z"
              fill="white"
            />
          </g>
          <g transform="matrix(0.141389,0,0,0.141389,27.4393,53.8779)">
            <path
              d="M524.941,1218.82C524.941,1218.82 530.282,1073.04 528.56,1040.42C527.088,1012.53 521.672,970.321 533.811,948.88C562.309,977.56 603.654,1050.53 614.568,1127.49C600.534,1152.71 580.276,1240.34 576.943,1312.43C551.925,1312.7 524.439,1300.88 521.684,1300.46C522.278,1273.49 523.539,1248.97 524.941,1218.82Z"
              fill="white"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
);

export const StrokeLogo = (
  <g>
    <g>
      <g>
        <g>
          <path
            d="M141.603,72.738L155.623,25.072C155.984,23.843 157.119,22.994 158.4,22.995L181.542,22.995C183.129,22.996 184.433,24.301 184.433,25.887C184.433,26.198 184.383,26.507 184.285,26.802L174.474,56.244L201.933,56.609L251.01,105.686L251.01,251.254L170.137,251.254L170.137,251.106L109.701,251.106L78.034,219.409L78.613,213.365L53.738,191.873L44.062,171.509L44.395,160.363L29.404,138.844L35.424,121.431L50.591,90.632L90.73,68.818L141.603,72.738Z"
            fillOpacity="0.2"
            fillRule="nonzero"
          />
        </g>
        <g transform="matrix(3.72555,0,0,3.72555,3.0288,26.584)">
          <g transform="matrix(1,0,0,1,21.7744,36.7865)">
            <path
              d="M0,-0.267C0.926,-0.134 2.028,-0.105 3.532,0C2.029,-0.105 0.925,-0.135 0,-0.267Z"
              fill="none"
              fillRule="nonzero"
              stroke="white"
              strokeWidth="2px"
            />
          </g>
          <g transform="matrix(1,0,0,1,26.2349,36.7964)">
            <path
              d="M0,0.06C-0.265,0.038 -0.517,0.018 -0.76,0C-0.517,0.018 -0.265,0.038 0,0.06Z"
              fill="none"
              fillRule="nonzero"
              stroke="white"
              strokeWidth="2px"
            />
          </g>
          <g transform="matrix(1,0,0,1,26.2349,50.8824)">
            <path
              d="M0,-14.026C0.243,-13.794 0.473,-13.586 0.698,-13.387C0.345,-13.072 -0.041,-12.728 -0.444,-12.37C0.673,-8.142 -1.324,-6.874 -4.764,-6.288C-4.931,-3.863 -5.102,0 -5.102,0L-2.102,0C-1.585,-0.71 0.842,-7.823 0.906,-9.423C1.822,-9.988 2.639,-10.457 3.33,-11.683C2.263,-12.082 1.267,-12.815 0,-14.026Z"
              fill="none"
              fillRule="nonzero"
              stroke="white"
              strokeWidth="2px"
            />
          </g>
          <g transform="matrix(1,0,0,1,26.9331,43.4151)">
            <path
              d="M0,-5.92C-0.225,-6.118 -0.456,-6.326 -0.698,-6.559C-5.056,-6.928 -6.364,-6.525 -8.686,-8.603C-11.449,-8.202 -13.272,-7.733 -14.889,-8.201C-16.386,-7.429 -16.855,-6.233 -15.934,-3.657C-13.697,-0.004 -10.886,2.683 -5.533,1.192C-2.049,0.612 -0.017,-0.646 -1.142,-4.902C-0.739,-5.261 -0.353,-5.605 0,-5.92Z"
              fill="none"
              fillRule="nonzero"
              stroke="white"
              strokeWidth="2px"
            />
          </g>
          <g transform="matrix(0.268416,0,0,0.268416,-0.812979,-7.13559)">
            <path
              d="M176.854,89.941C184.242,92.557 188.362,98.664 188.323,105.407C201.046,113.197 207.502,125.029 195.938,137.592C197.753,152.773 191.036,159.263 162.025,153.165C159.137,154.83 154.201,154.122 151.727,152.736C152.115,154.673 153.046,177.802 135.722,172.541C117.765,175.466 112.277,174.888 100.769,163.894C84.533,162.519 79.66,164.017 71.009,156.279C54.665,158.649 47.14,161.677 37.528,150.315C26.146,136.932 25.017,133.184 37.874,123.319C32.517,113.316 39.454,107.694 46.354,105.671C41.7,100.943 49.763,85.009 67.291,81.619C76.754,71.515 97.561,64.273 122.143,72.167C129.46,71.434 136.039,71.533 141.734,72.293L141.158,74.25C141.08,74.515 141.041,74.79 141.041,75.066C141.041,76.653 142.347,77.959 143.934,77.959L158.735,77.959C160.101,78.866 161.278,79.853 162.254,80.907L152.741,111.822C152.655,112.099 152.612,112.388 152.612,112.678C152.612,114.265 153.918,115.571 155.505,115.571C156.399,115.571 157.245,115.156 157.792,114.449L176.854,89.941Z"
              fill="none"
              fillRule="nonzero"
              stroke="white"
              strokeWidth="7.5px"
            />
          </g>
        </g>
        <g transform="matrix(0.115714,0,0,0.115714,123.686,22.9945)">
          <path
            d="M276,17.95C279.12,7.334 288.935,-0.006 300,0L500,0C513.707,0.01 524.981,11.293 524.981,25C524.981,27.685 524.548,30.353 523.7,32.9L434.7,300L625,300C625.006,300 625.012,300 625.017,300C638.732,300 650.017,311.285 650.017,325C650.017,330.559 648.163,335.962 644.75,340.35L294.75,790.35C290.019,796.463 282.71,800.048 274.98,800.048C261.266,800.048 249.98,788.762 249.98,775.048C249.98,772.54 250.358,770.046 251.1,767.65L341.15,475L175,475C174.995,475 174.99,475 174.985,475C161.271,475 149.985,463.715 149.985,450C149.985,447.614 150.327,445.24 151,442.95L276,17.95Z"
            fill="none"
            fillRule="nonzero"
            stroke="white"
            strokeWidth="69.14px"
          />
        </g>
      </g>
    </g>
  </g>
);

export const SurgeryLogo = (
  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
    <g>
      <g transform="matrix(1,0,0,1,60.2656,13.2957)">
        <path
          d="M-15.201,-1.255L-38.339,22.129L-36.525,23.943L-47.025,32.964L-51.496,36.283L-41.37,46.408L-40.809,46.97L0,46.97L0,8.852L-10.107,-1.255L-15.201,-1.255Z"
          fillOpacity="0.2"
        />
      </g>
      <g transform="matrix(1,0,0,1,28.2305,47.6879)">
        <path
          d="M0,-8.767L-5.359,-3.408C-9.11,0.344 -9.897,1.879 -15.785,1.887L-19.46,1.891L-7.08,-10.658L-4.667,-10.013L-11.754,-2.926C-12.015,-2.664 -12.015,-2.243 -11.754,-1.983C-11.493,-1.721 -11.071,-1.721 -10.81,-1.983L-3.177,-9.615L0,-8.767Z"
          fill="white"
        />
      </g>
      <g transform="matrix(-1,0,0,1,20.7932,48.2382)">
        <path
          d="M-26.033,1.335L0,1.335L-1.333,0L-26.033,0L-26.033,1.335Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(1,0,0,1,30.1733,17.8317)">
        <path
          d="M0,12.786C-0.356,12.69 -0.567,12.324 -0.472,11.969C-0.376,11.613 -0.011,11.402 0.345,11.497L3.312,12.292C3.668,12.387 3.879,12.752 3.785,13.108C3.69,13.464 3.324,13.676 2.967,13.58L0,12.786ZM1.776,11.011C1.419,10.915 1.208,10.55 1.303,10.194C1.398,9.839 1.764,9.627 2.12,9.722L5.087,10.517C5.443,10.612 5.654,10.977 5.559,11.334C5.464,11.69 5.099,11.901 4.743,11.806L1.776,11.011ZM-1.774,14.56C-2.13,14.465 -2.341,14.1 -2.247,13.744C-2.151,13.388 -1.786,13.176 -1.43,13.271L1.538,14.067C1.893,14.161 2.105,14.527 2.01,14.882C1.915,15.239 1.549,15.45 1.194,15.356L-1.774,14.56ZM3.551,9.236C3.194,9.141 2.982,8.776 3.078,8.42C3.173,8.064 3.538,7.852 3.895,7.947L6.862,8.743C7.217,8.837 7.429,9.203 7.333,9.559C7.24,9.915 6.874,10.126 6.518,10.031L3.551,9.236ZM5.325,7.461C4.969,7.367 4.757,7 4.852,6.645C4.948,6.289 5.314,6.078 5.669,6.173L8.636,6.968C8.992,7.063 9.204,7.429 9.109,7.785C9.012,8.14 8.647,8.351 8.292,8.256L5.325,7.461ZM15.03,-4.381L-5.667,16.316L-0.078,17.808L18.57,-0.839C18.9,-1.169 19.114,-1.532 19.225,-1.901C19.356,-2.333 19.355,-2.787 19.243,-3.215C19.128,-3.644 18.899,-4.047 18.569,-4.376C18.268,-4.676 17.891,-4.911 17.451,-5.045C17.02,-5.176 16.588,-5.178 16.185,-5.071C15.767,-4.96 15.371,-4.722 15.03,-4.381M-8.309,16.125L13.613,-5.797C14.201,-6.384 14.907,-6.799 15.677,-7.003C16.425,-7.203 17.227,-7.197 18.03,-6.954C18.806,-6.718 19.466,-6.31 19.986,-5.791C20.562,-5.214 20.97,-4.497 21.174,-3.724C21.379,-2.951 21.376,-2.122 21.135,-1.322C20.926,-0.64 20.552,0.012 19.987,0.577L0.931,19.631C0.656,19.908 0.261,19.989 -0.086,19.876L-7.859,17.799C-8.393,17.658 -8.709,17.109 -8.567,16.575C-8.52,16.4 -8.429,16.246 -8.309,16.125"
          fill="white"
          fillRule="nonzero"
        />
      </g>
    </g>
  </g>
);

export const TemplateLogo = (
  <>
    <g>
      <path
        d="M177.315,73.789L254.14,150.614L251.104,150.022L251.104,250.754L147.642,250.754L73.996,177.108L177.315,73.789Z"
        fillOpacity="0.2"
      />
    </g>
    <g transform="matrix(3.28986,0,0,3.28986,-51.1715,-282.733)">
      <circle
        cx="53.718"
        cy="124.104"
        r="22.256"
        fill="rgb(0,160,224)"
        stroke="white"
        strokeWidth="2.43px"
      />
    </g>
  </>
);

export const TheatresLogo = (
  <>
    <g transform="matrix(4.16667,0,0,4.16667,-699.446,-99.4459)">
      <g transform="matrix(0.24,0,0,0.24,167.867,23.867)">
        <path
          d="M94.114,203.273L95,200L85,190L76.703,156.809L66.34,154.754L57.871,138.033L58.061,121.137L63.984,117.65L59.569,91.961L65.628,64.252L84.715,44.002L109.136,33.162L129.693,31.272L152.599,36.212L169.656,44.678L185,55L251.461,121.461L251.461,252L145.09,252L145.925,252.835L115.376,252.835L83.252,220.71L94.114,203.273Z"
          fillOpacity="0.2"
        />
      </g>
    </g>
    <g>
      <path
        d="M174.454,152.469C174.157,163.851 173.429,175.302 166.223,189.862C160.831,200.755 148.018,206.342 138.278,209.106C130.209,211.395 121.662,211.395 113.591,209.106C103.853,206.342 91.038,200.755 85.648,189.862C76.63,171.644 77.755,158.293 77.177,143.854C77.177,143.854 95.08,145.972 105.475,135.77C115.871,125.566 118.867,124.028 125.936,124.028C133.002,124.028 136,125.566 146.394,135.77C156.789,145.972 174.692,143.854 174.692,143.854C174.576,146.753 174.529,149.609 174.454,152.469L174.469,152.469L174.454,152.469Z"
        fill="rgb(194,182,163)"
      />
      <g transform="matrix(2.18835,0,0,2.18835,-694.63,-196.824)">
        <path
          d="M374.97,145.868L374.97,147.368C375.751,147.367 376.387,147.411 376.97,147.534C377.842,147.721 378.629,148.078 379.684,148.843C380.734,149.607 382.022,150.779 383.794,152.519C385.597,154.287 387.828,155.278 389.936,155.833C392.046,156.388 394.043,156.511 395.431,156.511C396.583,156.511 397.315,156.426 397.338,156.423L397.25,155.678L396.501,155.648C396.369,158.977 396.429,162.127 396.017,165.45C395.604,168.775 394.729,172.282 392.708,176.369C391.561,178.689 389.599,180.482 387.35,181.852C385.105,183.221 382.587,184.156 380.406,184.775C378.629,185.279 376.799,185.531 374.97,185.531C373.14,185.531 371.311,185.279 369.534,184.775C367.353,184.156 364.835,183.221 362.589,181.852C360.341,180.482 358.378,178.689 357.232,176.369C355.21,172.282 354.335,168.775 353.923,165.45C353.51,162.127 353.571,158.977 353.438,155.648L352.689,155.678L352.601,156.423C352.624,156.426 353.356,156.511 354.508,156.511C355.896,156.511 357.894,156.388 360.004,155.833C362.111,155.278 364.343,154.287 366.145,152.519C368.507,150.198 370.012,148.893 371.235,148.205C371.847,147.859 372.386,147.658 372.969,147.534C373.552,147.411 374.188,147.367 374.97,147.368L374.97,145.868C374.136,145.868 373.39,145.912 372.659,146.067C371.56,146.296 370.532,146.783 369.373,147.631C368.209,148.48 366.886,149.691 365.095,151.449C363.541,152.975 361.56,153.873 359.622,154.383C357.686,154.893 355.806,155.012 354.508,155.012C353.969,155.012 353.531,154.991 353.23,154.971C353.079,154.961 352.963,154.952 352.886,154.945L352.777,154.933C352.559,154.908 352.341,154.978 352.18,155.128C352.018,155.277 351.931,155.489 351.939,155.708C352.071,158.977 352.007,162.177 352.434,165.634C352.861,169.091 353.789,172.797 355.887,177.035C357.204,179.693 359.401,181.665 361.809,183.133C364.22,184.6 366.854,185.573 369.124,186.218C371.035,186.76 373.002,187.031 374.97,187.031C376.937,187.031 378.904,186.76 380.815,186.218C383.085,185.573 385.72,184.6 388.13,183.133C390.538,181.665 392.735,179.693 394.052,177.035C396.151,172.797 397.079,169.091 397.505,165.634C397.932,162.177 397.868,158.977 397.999,155.708C398.008,155.489 397.921,155.277 397.759,155.128C397.598,154.978 397.38,154.908 397.162,154.933L397.138,154.936C397.01,154.95 396.374,155.012 395.431,155.012C394.133,155.012 392.253,154.893 390.318,154.383C388.38,153.873 386.398,152.975 384.845,151.449C382.456,149.107 380.901,147.729 379.444,146.9C378.716,146.487 378.01,146.22 377.28,146.067C376.549,145.912 375.803,145.868 374.97,145.868Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(2.18835,0,0,2.18835,-694.63,-196.824)">
        <path
          d="M397.148,158.865L397.124,158.865C396.365,158.865 395.442,158.82 394.716,158.774C393.989,158.729 393.46,158.684 393.459,158.684L393.454,158.683C390.13,158.428 385.542,157.396 382.219,154.124C380.013,151.963 378.702,150.858 377.648,150.252C377.122,149.95 376.646,149.778 376.199,149.696C375.752,149.614 375.357,149.617 374.97,149.617C374.614,149.617 374.231,149.614 373.791,149.697C373.126,149.821 372.407,150.139 371.481,150.805C370.55,151.473 369.376,152.5 367.721,154.124C364.397,157.396 359.809,158.428 356.485,158.683L356.481,158.684C356.48,158.684 355.925,158.73 355.214,158.777C354.506,158.824 353.64,158.87 353.057,158.87L352.819,158.867C352.405,158.855 352.06,159.181 352.048,159.595C352.036,160.009 352.362,160.354 352.777,160.366C352.865,160.368 352.959,160.37 353.057,160.37C354.354,160.369 356.595,160.179 356.606,160.179L356.602,160.179C360.106,159.903 365.05,158.838 368.772,155.194C370.938,153.066 372.236,152.027 373.078,151.557C373.501,151.321 373.797,151.223 374.069,151.171C374.34,151.119 374.609,151.116 374.97,151.117C375.362,151.116 375.65,151.119 375.926,151.171C376.334,151.249 376.798,151.429 377.613,152.021C378.421,152.61 379.541,153.597 381.168,155.194C384.89,158.838 389.832,159.903 393.337,160.179L393.332,160.178C393.342,160.179 395.498,160.364 397.124,160.365L397.149,160.365C397.563,160.364 397.899,160.028 397.898,159.614C397.898,159.2 397.562,158.864 397.148,158.865Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(2.18835,0,0,2.18835,-694.63,-196.824)">
        <path
          d="M358.072,168.664C358.136,168.695 365.114,172.181 375.27,172.184C380.347,172.184 386.219,171.308 392.391,168.684C392.772,168.522 392.95,168.081 392.788,167.7C392.626,167.319 392.185,167.141 391.804,167.304C385.837,169.84 380.176,170.684 375.27,170.684C370.366,170.684 366.218,169.838 363.304,168.993C361.847,168.571 360.699,168.15 359.918,167.836C359.528,167.678 359.23,167.548 359.032,167.458C358.933,167.413 358.858,167.378 358.81,167.355L358.743,167.323C358.372,167.138 357.922,167.288 357.736,167.658C357.551,168.029 357.701,168.479 358.072,168.664Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(2.18835,0,0,2.18835,-694.63,-196.824)">
        <path
          d="M359.868,174.556C359.898,174.58 361.555,175.93 364.25,177.284C366.944,178.636 370.682,180.001 374.882,180.003C384.132,179.99 390.577,174.597 390.643,174.551C390.961,174.286 391.004,173.813 390.739,173.495C390.474,173.177 390.001,173.134 389.683,173.399L389.671,173.409C389.358,173.672 383.256,178.515 374.882,178.503C371.013,178.505 367.482,177.23 364.923,175.944C363.644,175.301 362.61,174.658 361.899,174.178C361.544,173.938 361.269,173.739 361.086,173.602C360.994,173.533 360.925,173.479 360.879,173.444L360.829,173.404L360.816,173.394C360.495,173.132 360.023,173.18 359.761,173.501C359.499,173.822 359.547,174.295 359.868,174.556Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(2.18835,0,0,2.18835,-694.63,-196.824)">
        <path
          d="M392.034,161.968C392.033,161.968 391.953,161.975 391.798,161.986C391.333,162.019 390.223,162.085 388.886,162.085C386.93,162.09 384.461,161.929 382.923,161.375C380.41,160.489 377.968,159.422 375.252,159.415C372.537,159.422 370.095,160.489 367.582,161.375C366.044,161.929 363.575,162.09 361.619,162.085C360.728,162.085 359.937,162.056 359.371,162.026C359.088,162.011 358.862,161.997 358.706,161.986C358.551,161.975 358.471,161.968 358.471,161.968C358.058,161.933 357.695,162.239 357.66,162.651C357.625,163.064 357.93,163.427 358.343,163.463C358.357,163.464 359.771,163.585 361.619,163.585C363.658,163.58 366.198,163.451 368.084,162.789C370.657,161.869 372.954,160.908 375.252,160.915C377.551,160.908 379.848,161.869 382.421,162.789C384.307,163.451 386.847,163.58 388.886,163.585C390.734,163.585 392.148,163.464 392.162,163.463C392.574,163.427 392.88,163.064 392.845,162.651C392.81,162.239 392.446,161.933 392.034,161.968Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
    </g>
    <g>
      <path
        d="M180.094,136.063C180.365,131.907 182.632,124.157 187.281,119.176C188.045,116.904 194.784,97.688 190.509,74.95C186.235,52.211 158.358,31.251 126.506,31.251C94.655,31.251 66.808,50.653 62,74C57.192,97.347 63.411,116.464 65,119C66.589,121.536 73.495,131.481 73,137C76.123,134.442 77.277,133.447 77,127C76.723,120.553 76.835,90.242 81,82C85.165,73.758 84.354,72.881 93,74C101.646,75.119 126.895,87.006 158,85C155.269,72.52 166.875,67.093 171,84C172.087,88.454 174.771,101.653 174.68,129.836C174.824,133.829 175.535,136.729 180.094,136.063Z"
        fill="none"
        stroke="white"
        strokeWidth="8px"
      />
      <path
        d="M84.701,218.278C89.375,214.33 92.348,209.068 94.075,199.948"
        fill="none"
        stroke="white"
        strokeWidth="8px"
      />
      <g transform="matrix(-1,0,0,1,252.56,0)">
        <path
          d="M84.701,218.278C89.375,214.33 92.348,209.068 94.075,199.948"
          fill="none"
          stroke="white"
          strokeWidth="8px"
        />
      </g>
      <path
        d="M187.281,119.176C192.595,120.407 194.385,121.171 194.693,127.642C195.001,134.113 194.926,145.751 186.868,153.628C178.81,161.506 175.808,156.746 175.186,156.395C175.186,187.133 159.731,210.175 125.329,210.175C90.926,210.175 77.412,184.278 77.412,156.858C74.415,157.484 70.823,158.985 65.638,153.642C58.028,145.801 55.026,135.374 57.926,124.176C60.053,115.964 64.553,118.855 64.633,118.801"
        fill="none"
        stroke="white"
        strokeWidth="8px"
      />
      <path
        d="M175,144L179.584,136.852"
        fill="none"
        stroke="white"
        strokeWidth="8px"
      />
      <path
        d="M77,144L73.033,136.597"
        fill="none"
        stroke="white"
        strokeWidth="8px"
      />
    </g>
  </>
);

export const TherapiesLogo = (
  <g>
    <g>
      <g>
        <g transform="matrix(4.16667,0,0,4.16667,-699.446,-99.4459)">
          <path
            d="M201.888,60.089L203.097,57.906L203.403,55.546L201.889,54.031L200.297,49.705L200.289,31.474L208.832,31.476L211.403,34.047L219.916,37.553L235.575,53.211L235.575,85.447L227.287,85.487L228.993,87.194L228.993,87.888L229.051,87.947L228.993,87.947L228.993,87.969L228.971,87.947L192.269,87.947L175.103,70.781L175.549,59.044L177.416,55.159L181.132,53.381L194.486,53.381L195.879,54.774L196.612,54.813L201.888,60.089Z"
            fillOpacity="0.2"
          />
        </g>
        <g transform="matrix(0.886688,0,0,0.886688,57.9515,-5.5468)">
          <g transform="matrix(3.26338,0,0,3.26338,-488.347,-743.66)">
            <path
              d="M185.175,266.771L183.86,269.762L183.463,273.375L184.924,272.303L187.087,267.384C187.143,267.256 187.171,267.119 187.171,266.981L187.171,262.568L185.175,266.027L185.175,266.771Z"
              fill="white"
              fillRule="nonzero"
            />
          </g>
          <g transform="matrix(3.26338,0,0,3.26338,-488.347,-743.66)">
            <path
              d="M183.001,288.767L182.54,288.767L182.54,280.1L182.289,280.285L180.545,283.307L180.545,288.767L180.085,288.767L180.085,291.049L179.813,291.049L179.813,292.243L183.271,292.243L183.271,291.049L183.001,291.049L183.001,288.767Z"
              fill="white"
              fillRule="nonzero"
            />
          </g>
          <g transform="matrix(3.26338,0,0,3.26338,-488.347,-743.66)">
            <path
              d="M175.771,243.492L175.914,243.492L175.914,266.981C175.914,267.119 175.942,267.256 175.998,267.384L178.572,273.238L179.008,269.268L177.911,266.771L177.911,258.746L183.747,258.746L184.899,256.75L177.911,256.75L177.911,243.492L185.175,243.492L185.175,256.274L187.171,252.814L187.171,243.492L187.314,243.492C188.233,243.492 188.979,242.748 188.979,241.828C188.979,240.91 188.233,240.165 187.314,240.165L175.771,240.165C174.852,240.165 174.107,240.91 174.107,241.828C174.107,242.748 174.852,243.492 175.771,243.492Z"
              fill="white"
              fillRule="nonzero"
            />
          </g>
          <g transform="matrix(3.26338,0,0,3.26338,-488.347,-743.66)">
            <path
              d="M193.961,262.455L187.67,258.824L194.299,247.344L200.59,250.975L193.961,262.455ZM188.95,271.135L181.674,276.475L182.659,267.504L186.672,260.554L192.964,264.184L188.95,271.135ZM175.862,284.528C176.32,284.846 177.137,286.441 177.137,286.441L181.192,279.303L190.3,272.622C190.413,272.539 190.506,272.434 190.575,272.316L202.319,251.973L202.443,252.045C203.239,252.505 204.256,252.232 204.715,251.436C205.175,250.641 204.903,249.623 204.106,249.164L194.11,243.392C193.314,242.932 192.297,243.204 191.837,244C191.377,244.797 191.65,245.813 192.446,246.273L192.57,246.345L180.825,266.686C180.757,266.807 180.713,266.939 180.697,267.076L179.465,278.306C179.465,278.306 176.774,282.958 175.862,284.528Z"
              fill="white"
              fillRule="nonzero"
            />
          </g>
        </g>
        <g transform="matrix(1,0,0,1,0,12.9052)">
          <g transform="matrix(0.682673,0,0,0.682673,-88.7847,10.7079)">
            <path
              d="M238.532,188.099L284.818,188.099C294.899,188.099 304.064,192.005 310.897,198.379C312.181,194.334 312.878,190.028 312.878,185.558C312.878,162.168 293.916,143.206 270.526,143.206L219.281,143.206C195.89,143.206 176.929,162.168 176.929,185.558L176.929,248.43L200.348,227.906C200.306,227.17 200.279,227.099 200.279,226.353C200.279,205.226 217.405,188.099 238.532,188.099Z"
              fill="none"
              fillRule="nonzero"
              stroke="white"
              strokeWidth="8.79px"
            />
          </g>
          <g transform="matrix(0.682673,0,0,0.682673,-88.7847,10.7079)">
            <path
              d="M310.897,198.379C305.465,215.501 289.447,227.911 270.526,227.911L200.348,227.906L200.348,228.574C201.499,248.666 218.151,264.606 238.532,264.606L301.212,264.606L323.071,283.14L323.071,226.353C323.071,215.307 318.384,205.362 310.897,198.379Z"
              fill="none"
              fillRule="nonzero"
              stroke="white"
              strokeWidth="8.79px"
            />
          </g>
          <g transform="matrix(0.682673,0,0,0.682673,-88.7847,10.7079)">
            <path
              d="M270.526,227.911C289.447,227.911 305.465,215.501 310.897,198.379C304.064,192.005 294.899,188.099 284.818,188.099L238.532,188.099C217.405,188.099 200.279,205.226 200.279,226.353C200.279,227.099 200.306,227.17 200.348,227.906L270.526,227.911Z"
              fill="none"
              fillRule="nonzero"
              stroke="white"
              strokeWidth="8.79px"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
);

export const TutorialsLogo = (
  <>
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
      <g transform="matrix(0.24,0,0,0.24,0,0)">
        <g>
          <path
            d="M148.648,40.106L153.079,33.234L153.056,33.212L153.179,33.079L156.24,28.331L156.93,29.022L163.084,22.367L179.566,19.396L194.982,23.18L209.407,27.144L260.441,78.178L260.441,257.338L81.674,257.338L33.929,209.592L37.334,196.559L51.798,190.021L35.581,169.943L20.976,139.653L19.799,122.543L26.428,104.084L44.238,86.082L71.504,80.501L103.789,93.219L128.415,117.846L129.953,116.804L135.572,115.881L139.836,115.181L138.733,114.078L144.718,112.29L145.198,113.347L154.769,118.5L159.571,118.493L158.016,110.18L168.349,102.618L150.18,77.49L148.285,64.344C144.116,60.279 141.422,57.209 141.453,56.09C141.587,51.225 142.761,42.825 144.754,38.416C145.045,37.773 146.454,38.461 148.648,40.106ZM254.367,229.439L254.367,199.482L256.399,201.514L256.399,245.829L253.233,242.663L253.233,228.305L254.367,229.439ZM200.406,91.205L200.414,91.213L205.736,85.892L204.971,85.126L200.406,91.205Z"
            fillOpacity="0.2"
          />
        </g>
      </g>
    </g>
    <g>
      <path
        d="M180.631,15.834C190.359,15.798 200.101,19.225 207.558,26.186C211.133,29.523 215.242,34.201 216.695,39.08C219.184,44.579 220.154,50.319 219.967,56.082C220.136,59.652 219.32,63.502 218.432,66.875C214.889,80.33 206.475,92.86 196.82,102.719C198.253,103.059 199.766,103.624 201.216,104.373C204.308,105.917 207.145,108.271 208.208,111.209C209.156,113.584 208.954,116.26 206.805,119.012C205.023,121.294 202.473,122.772 199.782,123.852C194.121,126.342 187.324,127.408 180.631,127.346C173.938,127.408 167.141,126.342 161.48,123.852C158.788,122.772 156.239,121.294 154.457,119.012C152.308,116.26 152.106,113.584 153.054,111.209C154.117,108.271 156.954,105.917 160.046,104.373C161.496,103.624 163.009,103.059 164.442,102.719C154.786,92.86 146.373,80.33 142.83,66.875C141.942,63.502 141.126,59.652 141.295,56.082C141.108,50.32 142.078,44.58 144.567,39.08C146.02,34.201 150.129,29.523 153.704,26.186C161.161,19.225 170.902,15.798 180.631,15.834ZM180.631,22.31C169.419,22.467 158.535,28.48 152.44,38.517C151.874,39.641 151.326,40.892 150.634,41.92C150.413,42.4 150.204,42.885 150.005,43.377C148.339,47.502 147.638,51.651 147.69,55.766C147.747,56.567 147.741,57.386 147.828,58.113C148.442,63.237 149.84,68.109 151.868,72.849C152.036,73.243 152.209,73.635 152.385,74.024C157.36,84.441 165.464,93.974 172.593,101.508L172.803,101.728C173.407,102.322 174.014,102.91 174.625,103.492C176.153,104.898 177.75,106.24 179.21,107.714L179.694,108.144C179.873,108.302 180.053,108.461 180.232,108.619L181.03,108.619C181.209,108.461 181.388,108.302 181.568,108.144L182.052,107.714C183.512,106.24 185.109,104.898 186.637,103.492C187.247,102.91 187.854,102.322 188.459,101.728L188.669,101.508C195.798,93.974 203.902,84.441 208.877,74.024C209.053,73.635 209.226,73.243 209.394,72.849C211.422,68.109 212.82,63.237 213.434,58.113C213.52,57.386 213.515,56.567 213.572,55.766C213.624,51.651 212.923,47.502 211.257,43.377C211.058,42.885 210.849,42.4 210.628,41.92C209.936,40.892 209.388,39.641 208.822,38.517C202.729,28.481 191.845,22.468 180.631,22.31Z"
        fill="white"
        fillRule="nonzero"
      />
      <g transform="matrix(0.398267,0,0,0.398267,15.8886,15.8967)">
        <path
          d="M409,54.428C401.273,55.532 394.445,57.491 388,62.043C383.114,65.495 378.896,69.819 375.877,75C356.714,107.883 384.389,147.943 422,141.674C427.665,140.73 433.211,138.229 438,135.134C469.683,114.661 460.6,60.765 422,55.004C417.601,54.347 413.438,53.794 409,54.428Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0.398267,0,0,0.398267,15.8886,15.8967)">
        <path
          d="M409,70.465C405.057,71.179 401.321,72.668 398,74.916C373.037,91.809 389.746,130.801 419,125.671C422.537,125.051 425.969,123.424 428.996,121.532C453.928,105.952 437.673,65.269 409,70.465Z"
          fillOpacity="0.2"
        />
      </g>
      <g transform="matrix(0.398267,0,0,0.398267,15.8886,15.8967)">
        <path
          d="M77,437C56.685,440 24.33,461.425 40.8,485C43.288,488.561 46.525,491.653 50,494.239C59.213,501.095 70.897,504.935 82,507.424C101.677,511.834 122.838,513.75 143,511.83C164.086,509.822 192.721,505.392 207.815,488.96C209.973,486.61 211.694,483.951 212.906,481C222.399,457.893 194.287,438.771 174,437C183.743,425.848 193.587,414.791 202.571,403C205.885,398.651 209.424,392.003 203.772,387.742C194.727,380.925 186.442,396.508 181.916,402C169.336,417.266 155.847,432.191 141,445.285C137.161,448.671 131.506,456.859 126,457.269C122.295,457.546 118.535,452.773 116,450.576C106.849,442.642 98.542,433.582 90.001,425C80.721,415.675 72.368,405.408 64.349,395C40.705,364.314 18.807,327.643 16.09,288C11.416,219.821 72.938,161.005 141,170.729C151.725,172.262 162.285,175.425 172,180.248C182.581,185.5 192.498,191.721 201,200.015C210.126,208.917 218.62,219.399 224.111,231C231.23,246.041 235.425,262.335 235.957,279C236.832,306.451 224.954,334.375 212.23,358C210.219,361.734 207.556,365.527 208.244,369.995C209.319,376.981 217.129,378.072 221.787,373.721C225.972,369.813 228.675,363.054 231.244,358C237.525,345.642 242.924,332.449 246.37,319C257.429,275.842 250.578,230.329 220.711,196C169.377,137 72.186,140.878 25.131,203C12.064,220.251 3.937,240.614 1,262C-2.488,287.398 2.135,313.165 11.05,337C20.226,361.533 34.363,384.385 50.424,405C58.908,415.888 69.139,425.708 77,437M124,224.439C113.586,225.555 102.703,227.389 94.189,234.094C89.683,237.643 88.1,245.552 94.109,248.667C99.811,251.624 106.082,246.072 111,243.796C117.851,240.625 125.626,240.055 133,241.461C168.224,248.174 175.177,296.245 144,313.201C121.727,325.316 95.662,312.682 88.348,289C85.801,280.754 89.114,273.133 87.851,265.015C87.053,259.885 80.677,256.985 76.214,259.897C73.197,261.866 72.245,265.686 71.619,269C70.098,277.043 70.603,286.118 72.63,294C79.828,321.996 107.255,337.458 135,333.711C141.775,332.797 148.136,330.471 154,326.985C193.243,303.656 187.832,242.107 144,227.356C137.872,225.293 130.477,223.745 124,224.439Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0.398267,0,0,0.398267,15.8886,15.8967)">
        <path
          d="M385,231.978C374.66,230.734 350.729,242.941 366.004,253.034C371.937,256.954 379.154,258.78 386,260.349C404.459,264.579 424.568,264.064 443,259.986C449.789,258.484 457.237,256.032 462.906,251.895C465.33,250.126 468.117,247.316 466.839,244.039C465.486,240.572 461.093,238.397 458,236.785C453.423,234.401 445.148,230.4 440,232.607C433.192,235.526 427.765,243.303 422,247.901C419.461,249.926 416.47,252.375 413,252.091C401.292,251.133 396.151,233.32 385,231.978Z"
          fillOpacity="0.2"
        />
      </g>
      <g transform="matrix(0.398267,0,0,0.398267,15.8886,15.8967)">
        <path
          d="M304.015,238.742C298.552,240.897 296.188,248.289 301.279,252.258C305.078,255.22 314.71,254.824 318.956,252.991C324.273,250.694 325.746,243.263 320.852,239.603C317.267,236.924 308.058,237.148 304.015,238.742M276.004,251.742C271.299,253.551 266.028,259.932 265.438,265C264.742,270.982 270.374,275.326 276,273.254C280.94,271.435 286.429,265.246 287.348,260C288.523,253.294 281.821,249.505 276.004,251.742M261.055,286.746C251.258,290.645 255.844,315.885 267.945,310.975C277.6,307.058 273.302,281.872 261.055,286.746Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0.398267,0,0,0.398267,15.8886,15.8967)">
        <path
          d="M278.004,321.758C273.35,322.514 270.182,327.512 271.758,332C273.706,337.547 281.845,344.094 287.996,343.091C292.642,342.334 295.857,337.553 294.242,333.004C292.39,327.784 283.826,320.811 278.004,321.758M312.105,335.742C306.751,338.015 305.92,345.666 310.394,349.258C313.968,352.126 323.855,351.929 327.956,350.258C333.389,348.044 334.515,340.327 329.772,336.742C326.102,333.969 316.247,333.984 312.105,335.742M352.044,335.742C346.611,337.956 345.485,345.673 350.228,349.258C354.052,352.148 363.66,351.896 367.895,349.991C373.074,347.662 374.219,340.576 369.606,337.009C365.795,334.064 356.398,333.968 352.044,335.742M392.019,335.742C386.548,337.927 385.258,345.679 390.148,349.258C393.846,351.964 402.826,351.916 406.981,350.258C412.452,348.073 413.742,340.321 408.852,336.742C405.154,334.036 396.174,334.084 392.019,335.742M431.105,335.742C425.75,338.015 424.92,345.666 429.394,349.258C432.968,352.126 442.855,351.929 446.956,350.258C452.32,348.072 453.583,340.36 448.772,336.858C444.967,334.089 435.362,333.936 431.105,335.742M470.019,343.758C456.074,348.868 473.185,367.457 482.981,364.066C487.372,362.546 489.601,357.266 487.643,353.04C485.284,347.949 475.735,341.663 470.019,343.758M495.109,373.029C485.69,378.274 494.927,401.789 505.941,395.82C515.647,390.56 506.135,366.887 495.109,373.029M500.108,411.742C491.332,415.476 490.373,440.58 503.956,435.254C513.871,431.366 514.892,405.452 500.108,411.742M482,445.704C477.318,447.255 471.474,452.038 470.323,457C468.943,462.942 474.113,467.991 480,466.332C484.661,465.018 491.343,459.85 492.551,454.985C494.178,448.43 488.064,443.694 482,445.704Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0.398267,0,0,0.398267,15.8886,15.8967)">
        <path
          d="M88,450.498C78.922,451.136 67.13,455.998 60.001,461.529C56.781,464.027 52.859,467.506 53.287,472C53.984,479.316 63.23,483.506 69,486.218C93.493,497.731 125.658,498.472 152,494.573C165.895,492.516 188.685,489.014 196.848,475.96C200.052,470.837 197.186,465.988 192.957,462.529C185.974,456.819 172.232,450.343 163,450.448C158.729,450.497 155.883,454.246 153,456.911C147.487,462.008 141.794,466.974 136,471.75C132.977,474.242 129.291,478.063 125,477.472C121.534,476.995 118.585,474.201 116,472.076C110.519,467.571 105.053,462.978 100,457.996C96.597,454.64 93.252,450.128 88,450.498Z"
          fillOpacity="0.2"
        />
      </g>
      <g transform="matrix(0.398267,0,0,0.398267,15.8886,15.8967)">
        <path
          d="M402,462.429C395.097,463.463 387.904,471.585 396.144,477.062C400.381,479.878 407.292,478.716 411.985,477.775C417.819,476.606 420.124,468.855 415.566,464.703C412.086,461.532 406.314,461.783 402,462.429M439.015,462.533C432.864,464.074 429.511,471.98 435.228,476.397C438.83,479.179 447.837,478.699 451.981,477.347C457.746,475.468 459.992,467.689 454.772,463.742C451.073,460.946 443.294,461.461 439.015,462.533M240.015,463.573C234.057,465.337 231.834,473.424 237.148,477.397C240.737,480.08 249.792,479.779 253.956,478.566C259.699,476.894 260.985,469.364 256.721,465.434C253.012,462.016 244.607,462.213 240.015,463.573M279.019,463.742C273.627,465.884 271.651,473.174 276.419,477.106C280.051,480.102 289.762,479.942 293.981,478.258C299.452,476.073 300.742,468.321 295.852,464.742C292.149,462.032 283.179,462.089 279.019,463.742M318.044,463.742C312.57,465.973 311.758,473.408 316.394,476.991C320.358,480.054 329.509,479.911 333.956,477.991C339.282,475.691 340.611,468.4 335.772,464.742C332.053,461.932 322.249,462.029 318.044,463.742M357.059,464.028C352.336,466.614 351.743,473.793 356.228,476.91C360.449,479.845 369.439,480.054 373.945,477.682C378.702,475.179 380.291,468.31 375.721,464.742C372.061,461.884 361.065,461.833 357.059,464.028Z"
          fill="white"
          fillRule="nonzero"
        />
      </g>
    </g>
  </>
);

export const UrologyLogo = (
  <>
    <path
      d="M168.49,93.718C168.179,93.69 167.83,93.669 167.452,93.627C150.827,94.328 140.357,73.064 150.927,58.369C161.497,43.673 178.403,39.446 193.123,48.998C196.005,50.869 198.861,53.232 201.599,55.976L204.529,52.636L255.949,104.056L258.801,211.215L268.271,220.686L268.271,252L259.886,252L260,256.282L180,256.385L177.383,253.768L136.083,253.768L40,157.685L42.237,153.761C41.408,152.917 40.657,152.076 39.994,151.258C28.347,136.88 27.63,122.111 28.876,101.763C30.121,81.415 44.157,58.998 58.877,49.446C72.375,40.687 87.712,43.514 98.313,55.374L100,52.414L150.087,102.502L165.183,97.487L168.49,93.718Z"
      fillOpacity="0.2"
    />
    <g transform="matrix(1,0,0,1,-2.442,0)">
      <g transform="matrix(1,0,0,1,0,3.941)">
        <g transform="matrix(0.103164,0,0,0.103164,-251.074,-30.6959)">
          <path
            d="M3276.95,1171.24C3438.1,1178.03 3539.58,971.915 3437.13,829.467C3334.68,687.019 3170.8,646.047 3028.11,738.639C2885.42,831.231 2749.37,1048.52 2737.3,1245.76C2725.23,1443 2732.17,1586.16 2845.07,1725.53C2922.85,1821.54 3126.27,1949.04 3274.17,1801.74C3422.08,1654.43 3433.72,1471.42 3258.39,1411.85C3223.46,1394.93 3238.36,1391.75 3242.15,1377.31C3245.94,1362.87 3278.42,1280.56 3254.94,1196.46C3247.04,1170.09 3258.48,1173.3 3276.95,1171.24Z"
            fill="none"
            stroke="white"
            strokeWidth="77.55px"
          />
        </g>
        <g transform="matrix(0.103164,0,0,0.103164,-249.465,-34.8234)">
          <path
            d="M3456.06,2312.33C3519.83,1991.79 3557.08,1723.17 3550.34,1540.92C3543.6,1358.67 3355.16,1252.54 3256.27,1248.66C3255.67,1250.3 3251.38,1403.82 3251.38,1403.82C3314.99,1417.09 3431.14,1435.64 3453.15,1562.48C3466.9,1689.32 3414.88,2030.68 3354.34,2305.06C3357.85,2307.89 3456.06,2312.33 3456.06,2312.33Z"
            fill="none"
            stroke="white"
            strokeWidth="58.16px"
          />
        </g>
      </g>
      <g transform="matrix(-1,0,0,1,256.884,3.4932)">
        <g transform="matrix(0.103164,0,0,0.103164,-251.074,-30.6959)">
          <path
            d="M3276.95,1171.24C3438.1,1178.03 3539.58,971.915 3437.13,829.467C3334.68,687.019 3170.8,646.047 3028.11,738.639C2885.42,831.231 2749.37,1048.52 2737.3,1245.76C2725.23,1443 2732.17,1586.16 2845.07,1725.53C2922.85,1821.54 3126.27,1949.04 3274.17,1801.74C3422.08,1654.43 3433.72,1471.42 3258.39,1411.85C3223.46,1394.93 3238.36,1391.75 3242.15,1377.31C3245.94,1362.87 3278.42,1280.56 3254.94,1196.46C3247.04,1170.09 3258.48,1173.3 3276.95,1171.24Z"
            fill="none"
            stroke="white"
            strokeWidth="77.55px"
          />
        </g>
        <g transform="matrix(0.103164,0,0,0.103164,-249.465,-34.8234)">
          <path
            d="M3456.06,2312.33C3519.83,1991.79 3557.08,1723.17 3550.34,1540.92C3543.6,1358.67 3355.16,1252.54 3256.27,1248.66C3255.67,1250.3 3251.38,1403.82 3251.38,1403.82C3314.99,1417.09 3431.14,1435.64 3453.15,1562.48C3466.9,1689.32 3414.88,2030.68 3354.34,2305.06C3357.85,2307.89 3456.06,2312.33 3456.06,2312.33Z"
            fill="none"
            stroke="white"
            strokeWidth="58.16px"
          />
        </g>
      </g>
    </g>
  </>
);

export const VascularLogo = (
  <>
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
      <g transform="matrix(1,0,0,1,60.2656,43.0708)">
        <path
          d="M0,-21.649L-6.414,-28.063L-7.331,-27.595L-12.477,-32.74L-13.699,-32.069L-18.332,-36.702L-20.944,-32.658L-27.131,-38.844L-30.515,-30.367L-35.952,-24.193L-41.384,-14.222L-43.042,-4.167L-47.102,9.158L-48.977,12.468L-44.25,17.195L-13.293,17.195C-5.982,17.195 0,11.211 0,3.899L0,-21.649Z"
          fillOpacity="0.2"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,24.1636,38.5503)">
        <path
          d="M-0.354,-0.354C-0.549,-0.354 -0.708,-0.195 -0.708,0C-0.708,0.196 -0.549,0.354 -0.354,0.354C-0.158,0.354 0,0.196 0,0C0,-0.195 -0.158,-0.354 -0.354,-0.354"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,28.8818,45.0503)">
        <path
          d="M-0.354,-0.354C-0.549,-0.354 -0.708,-0.195 -0.708,0C-0.708,0.196 -0.549,0.354 -0.354,0.354C-0.158,0.354 0,0.196 0,0C0,-0.195 -0.158,-0.354 -0.354,-0.354"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,37.4575,26.7788)">
        <path
          d="M-0.354,-0.354C-0.549,-0.354 -0.708,-0.195 -0.708,0C-0.708,0.196 -0.549,0.354 -0.354,0.354C-0.158,0.354 0,0.196 0,0C0,-0.195 -0.158,-0.354 -0.354,-0.354"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,44.8208,16.0908)">
        <path
          d="M-0.354,-0.354C-0.549,-0.354 -0.708,-0.195 -0.708,0C-0.708,0.196 -0.549,0.354 -0.354,0.354C-0.158,0.354 0,0.196 0,0C0,-0.195 -0.158,-0.354 -0.354,-0.354"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,26.0474,23.0605)">
        <path
          d="M-0.354,-0.354C-0.549,-0.354 -0.708,-0.195 -0.708,0C-0.708,0.196 -0.549,0.354 -0.354,0.354C-0.158,0.354 0,0.196 0,0C0,-0.195 -0.158,-0.354 -0.354,-0.354"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,32.0693,19.5805)">
        <path
          d="M-0.355,-0.355C-0.55,-0.355 -0.708,-0.196 -0.708,-0.001C-0.708,0.197 -0.55,0.355 -0.355,0.355C-0.158,0.355 -0.001,0.197 -0.001,-0.001C-0.001,-0.196 -0.158,-0.355 -0.355,-0.355"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,28.5278,29.5825)">
        <path
          d="M-0.354,-0.354C-0.549,-0.354 -0.708,-0.195 -0.708,0C-0.708,0.196 -0.549,0.354 -0.354,0.354C-0.158,0.354 0,0.196 0,0C0,-0.195 -0.158,-0.354 -0.354,-0.354"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,24.5181,53.1958)">
        <path
          d="M-0.354,-0.354C-0.549,-0.354 -0.708,-0.195 -0.708,0C-0.708,0.196 -0.549,0.354 -0.354,0.354C-0.158,0.354 0,0.196 0,0C0,-0.195 -0.158,-0.354 -0.354,-0.354"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,33.4888,11.748)">
        <path
          d="M-0.354,-0.354C-0.549,-0.354 -0.708,-0.196 -0.708,0C-0.708,0.196 -0.549,0.354 -0.354,0.354C-0.158,0.354 0,0.196 0,0C0,-0.196 -0.158,-0.354 -0.354,-0.354"
          fill="white"
          fillRule="nonzero"
        />
      </g>
    </g>
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
      <g transform="matrix(1,0,0,1,11.9375,5.1496)">
        <path
          d="M0,49.574C2.248,45.753 5.283,36.197 5.508,31.812C5.733,27.428 7.531,17.649 13.264,12.927C18.998,8.206 20.459,1.237 20.908,0"
          fill="none"
          fillRule="nonzero"
          stroke="white"
          strokeWidth="2px"
        />
      </g>
      <g transform="matrix(1,0,0,1,41.2676,29.9363)">
        <path
          d="M0,-22.764C-1.124,-17.93 -2.173,-16.806 -3.859,-14.782C-5.546,-12.759 -7.876,-7.361 -8.019,-6.127C-8.422,-2.636 -9.504,-1.313 -10.043,0C-9.057,-2.404 -7.006,-3.429 -5.771,-6.014C-4.534,-8.599 3.195,-17.537 5.781,-18.886"
          fill="none"
          fillRule="nonzero"
          stroke="white"
          strokeWidth="2px"
        />
      </g>
      <g transform="matrix(1,0,0,1,53.0645,54.724)">
        <path
          d="M0,-39.12C-1.574,-37.771 -5.171,-34.287 -7.42,-29.003C-9.668,-23.72 -12.591,-19.448 -14.84,-16.749C-17.088,-14.052 -20.348,-7.644 -21.921,0"
          fill="none"
          fillRule="nonzero"
          stroke="white"
          strokeWidth="2px"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,21.8823,39.331)">
        <path
          d="M-1.417,-1.417C-2.2,-1.417 -2.834,-0.783 -2.834,0C-2.834,0.783 -2.2,1.417 -1.417,1.417C-0.635,1.417 0,0.783 0,0C0,-0.783 -0.635,-1.417 -1.417,-1.417"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,24.1636,26.0698)">
        <path
          d="M-1.417,-1.417C-2.201,-1.417 -2.834,-0.782 -2.834,-0C-2.834,0.783 -2.201,1.417 -1.417,1.417C-0.635,1.417 -0,0.783 -0,-0C-0,-0.782 -0.635,-1.417 -1.417,-1.417"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,29.2358,36.4965)">
        <path
          d="M-1.417,-1.417C-2.201,-1.417 -2.834,-0.782 -2.834,-0C-2.834,0.783 -2.201,1.417 -1.417,1.417C-0.635,1.417 -0,0.783 -0,-0C-0,-0.782 -0.635,-1.417 -1.417,-1.417"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,27.4643,47.9135)">
        <path
          d="M-1.417,-1.417C-2.201,-1.417 -2.834,-0.782 -2.834,-0C-2.834,0.783 -2.201,1.417 -1.417,1.417C-0.635,1.417 -0,0.783 -0,-0C-0,-0.782 -0.635,-1.417 -1.417,-1.417"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,28.8818,20.58)">
        <path
          d="M-1.417,-1.417C-2.201,-1.417 -2.834,-0.782 -2.834,-0C-2.834,0.783 -2.201,1.417 -1.417,1.417C-0.635,1.417 -0,0.783 -0,-0C-0,-0.782 -0.635,-1.417 -1.417,-1.417"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,35.6855,29.9355)">
        <path
          d="M-1.418,-1.418C-2.201,-1.418 -2.835,-0.783 -2.835,0C-2.835,0.783 -2.201,1.418 -1.418,1.418C-0.636,1.418 -0.001,0.783 -0.001,0C-0.001,-0.783 -0.636,-1.418 -1.418,-1.418"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,43.0493,19.58)">
        <path
          d="M-1.417,-1.417C-2.201,-1.417 -2.834,-0.782 -2.834,0.001C-2.834,0.783 -2.201,1.417 -1.417,1.417C-0.635,1.417 -0,0.783 -0,0.001C-0,-0.782 -0.635,-1.417 -1.417,-1.417"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,35.6855,8.9125)">
        <path
          d="M-1.418,-1.418C-2.201,-1.418 -2.835,-0.783 -2.835,0C-2.835,0.783 -2.201,1.418 -1.418,1.418C-0.636,1.418 -0.001,0.783 -0.001,0C-0.001,-0.783 -0.636,-1.418 -1.418,-1.418"
          fill="white"
          fillRule="nonzero"
        />
      </g>
      <g transform="matrix(0,-1,-1,0,20.9741,48.7465)">
        <path
          d="M-1.417,-1.417C-2.201,-1.417 -2.834,-0.782 -2.834,-0C-2.834,0.783 -2.201,1.417 -1.417,1.417C-0.635,1.417 -0,0.783 -0,-0C-0,-0.782 -0.635,-1.417 -1.417,-1.417"
          fill="white"
          fillRule="nonzero"
        />
      </g>
    </g>
  </>
);

export const categoryIconDetails = [
  {
    names: ['Ambulatory Care', 'AmbulatoryCare', 'AECU'],
    colour: '#F5C342',
    icon: AmbulatoryCareLogo,
  },
  { names: ['Authoring'], colour: 'rgb(173,179,58)', icon: AuthoringLogo },
  {
    names: ['COVID 19', 'COVID19'],
    colour: 'rgb(0,135,204)',
    icon: COVID19Logo,
  },
  { names: ['Cardiology'], colour: 'rgb(231,38,122)', icon: CardiologyLogo },
  { names: ['Dermatology'], colour: 'rgb(130,82,168)', icon: DermatologyLogo },
  {
    names: ['Diabetes', 'DiabetesEndocrinology', 'Diabetes & Endocrinology'],
    colour: 'rgb(216,187,118)',
    icon: DiabetesLogo,
  },
  { names: ['ENT'], colour: 'rgb(151,195,66)', icon: ENTLogo },
  {
    names: [
      'ElderlyCare',
      'Elderly Care',
      'Care of the Elderly',
      'CareoftheElderly',
      'Elderly',
    ],
    colour: 'rgb(157,181,183)',
    icon: ElderlyLogo,
  },
  {
    names: ['EmergencyMedicine', 'Emergency Medicine'],
    colour: 'rgb(77,179,87)',
    icon: EmergencyMedicineLogo,
  },
  {
    names: ['Therapies'],
    colour: 'rgb(77,179,87)',
    icon: TherapiesLogo,
  },
  {
    names: ['Fluids & Electrolytes', 'FluidsElectrolytes', 'Electrolytes'],
    colour: 'rgb(208,132,183)',
    icon: ElectrolytesLogo,
  },
  {
    names: ['Gastroenterology'],
    colour: 'rgb(59,107,179)',
    icon: GastroenterologyLogo,
  },
  {
    names: ['BloodTransfusion', 'Blood Transfusion'],
    colour: 'rgb(226,51,56)',
    icon: BloodTransfusionLogo,
  },
  {
    names: ['HaematologyVTE', 'Haematology', 'Haematology & VTE'],
    colour: 'rgb(226,51,56)',
    icon: HaematologyLogo,
  },
  {
    names: ['IPC'],
    colour: 'rgb(240,126,53)',
    icon: IPCLogo,
  },
  {
    names: [
      'Renal, Metabolic and Endocrine',
      'RenalMetabolicandEndocrine',
      'Renal',
    ],
    colour: 'rgb(240,126,53)',
    icon: RenalLogo,
  },
  { names: ['ITU'], colour: 'rgb(238,50,131)', icon: ITULogo },
  {
    names: ['Medical', 'General Medicine', 'GeneralMedicine'],
    colour: 'rgb(195,203,226)',
    icon: MedicalLogo,
  },
  { names: ['Neonates'], colour: 'rgb(0,173,190)', icon: NeonatesLogo },
  {
    names: ['Neurology'],
    colour: 'rgb(77,158,255)',
    icon: NeurologyLogo,
  },
  {
    names: ['Neurology', 'Stroke'],
    colour: 'rgb(77,158,255)',
    icon: StrokeLogo,
  },
  {
    names: ['NutritionDietetics', 'Nutrition & Dietetics', 'Nutrition'],
    colour: 'rgb(204,204,0)',
    icon: NutritionLogo,
  },
  { names: ['Nursing'], colour: '#194184', icon: NursingLogo },
  {
    names: ['Obstetrics & Gynaecology', 'ObstetricsGynaecology'],
    colour: 'rgb(210,197,221)',
    icon: ObstetricsGynaecologyLogo,
  },
  {
    names: ['OMFS & Orthodontics', 'OMFSOrthodontics', 'Oral'],
    colour: 'rgb(78,203,199)',
    icon: OralLogo,
  },
  {
    names: ['Orthopaedics & Trauma', 'OrthopaedicsTrauma'],
    colour: 'rgb(189,71,66)',
    icon: OrthopaedicsTraumaLogo,
  },
  { names: ['Oncology'], colour: 'rgb(154,77,152)', icon: OncologyLogo },
  { names: ['Ophthalmics'], colour: 'rgb(148,154,209)', icon: OphthalmicsLogo },
  { names: ['Paediatrics'], colour: 'rgb(121,183,166)', icon: PaediatricsLogo },
  {
    names: ['Pain', 'Anaesthetics'],
    colour: 'rgb(167,168,132)',
    icon: PainLogo,
  },
  {
    names: ['PalliativeCare', 'Palliative Care'],
    colour: 'rgb(204,0,136)',
    icon: PalliativeCareLogo,
  },
  { names: ['Pharmacy'], colour: 'rgb(42,125,42)', icon: PharmacyLogo },
  {
    names: ['PlaceholderCategoryIcon'],
    colour: 'rgb(0,179,255)',
    icon: PlaceholderCategoryIconLogo,
  },
  { names: ['Respiratory'], colour: 'rgb(157,188,121)', icon: RespiratoryLogo },
  {
    names: ['Resuscitation'],
    colour: 'rgb(233,52,48)',
    icon: ResuscitationLogo,
  },
  {
    names: ['RevisionControl', 'Revision Control'],
    colour: 'rgb(48,190,240)',
    icon: RevisionControlLogo,
  },
  {
    names: ['Rheumatology'],
    colour: 'rgb(233,65,150)',
    icon: RheumatologyLogo,
  },
  {
    names: [
      'Theatres',
      'PreOpDSUTheatresPACURecovery',
      'Pre-Op, DSU, Theatres, PACU & Recovery',
    ],
    colour: 'rgb(224,188,133)',
    icon: TheatresLogo,
  },
  {
    names: ['Tutorials'],
    colour: 'rgb(210,197,221)',
    icon: TutorialsLogo,
  },
  {
    names: ['UpperGISurgery', 'Surgical', 'Upper GI Surgery', 'Surgery'],
    colour: 'rgb(170,126,133)',
    icon: SurgeryLogo,
  },
  {
    names: ['Urology', 'Template'],
    colour: 'rgb(0,177,239)',
    icon: UrologyLogo,
  },
  {
    names: [
      'Vascular',
      'VascularAccessIVTherapy',
      'Vascular Access & IV Therapy',
    ],
    colour: 'rgb(49,166,189)',
    icon: VascularLogo,
  },
];
